/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, s, i, o, n, r) {
    "use strict";
    function a(t) {
        t.querySelectorAll(".form-field").forEach((t) => {
            const e = t.querySelector("label"),
                s = t.querySelector("input, textarea");
            e &&
                s &&
                (s.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                s.value && s.value.length && e.classList.add("label--float"));
        });
    }
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 750, large: 990, widescreen: 1400 }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let l = p();
    function c() {
        const t = {};
        return (
            (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (t.footerHeight = m('[data-section-type*="footer"]')),
            (t.headerHeight = m("[data-header-height]")),
            (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0),
            (t.collectionNavHeight = m("[data-collection-nav]")),
            (t.logoHeight = (function () {
                const t = m("[data-footer-logo]");
                return t > 0 ? t + 20 : 0;
            })()),
            t
        );
    }
    function h() {
        document.addEventListener("theme:resize", u), d();
    }
    function d() {
        const { windowHeight: t, headerHeight: e, logoHeight: s, footerHeight: i, collectionNavHeight: o } = c();
        document.documentElement.style.setProperty("--full-height", `${t}px`),
            document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"),
            document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"),
            document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
            document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
            document.documentElement.style.setProperty("--collection-nav-height", `${o}px`),
            document.documentElement.style.setProperty("--header-height", `${e}px`),
            document.documentElement.style.setProperty("--footer-height", `${i}px`),
            document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", t - e - i + "px"),
            document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
                document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`);
    }
    function u() {
        const { windowHeight: t, headerHeight: e, logoHeight: s, footerHeight: i, collectionNavHeight: o } = c(),
            n = p();
        (n !== l || window.innerWidth > window.theme.sizes.mobile) &&
            (document.documentElement.style.setProperty("--full-height", `${t}px`),
            document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"),
            document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"),
            document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
            document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
            (l = n)),
            document.documentElement.style.setProperty("--collection-nav-height", `${o}px`),
            document.documentElement.style.setProperty("--header-height", `${e}px`),
            document.documentElement.style.setProperty("--footer-height", `${i}px`),
            document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", t - e - i + "px"),
            document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
                document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`);
    }
    function p() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0;
    }
    function m(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0;
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let v = !1,
        g = !1;
    function f() {
        setTimeout(() => {
            if (v) return;
            if (!g) return void f();
            const t = document.querySelectorAll('img[loading="lazy"]');
            t.length &&
                t.forEach((t) => {
                    t.setAttribute("loading", "eager");
                }),
                (v = !0);
        }, 3e3);
    }
    function y(t, e) {
        let s;
        return function () {
            if (t) {
                const i = () => t.apply(this, arguments);
                clearTimeout(s), (s = setTimeout(i, e));
            }
        };
    }
    function b() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    function w() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }
    function E() {
        return b() >= window.theme.sizes.small;
    }
    function S() {
        return b() < window.theme.sizes.small;
    }
    let L = b(),
        k = w();
    let A = window.scrollY,
        T = null,
        C = null,
        q = null,
        x = null,
        M = 0;
    function H(e) {
        setTimeout(() => {
            M && clearTimeout(M), t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function P(t) {
        const e = t.detail;
        e ? (M = setTimeout(I, e)) : I();
    }
    function I() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    const B = (t, e = "", s) => {
        const i = s || document.createElement("div");
        return i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t);
    };
    function D(t) {
        t.querySelectorAll(".rte table").forEach((t) => {
            B(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "");
        });
        t.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t) => {
            B(t, "rte__video-wrapper");
        });
    }
    function F(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length &&
            e.forEach((t) => {
                t.addEventListener("click", function (t) {
                    t.preventDefault();
                    const e = t.currentTarget;
                    e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                    const s = e.getAttribute("aria-controls"),
                        i = document.querySelector(`#${s}`),
                        o = () => {
                            i.classList.remove("expanding"), i.removeEventListener("transitionend", o);
                        },
                        n = () => {
                            i.classList.add("expanding"), i.removeEventListener("transitionstart", n);
                        };
                    i.addEventListener("transitionstart", n), i.addEventListener("transitionend", o), i.classList.toggle("expanded");
                });
            });
    }
    const O = "is-loading",
        $ = "img.is-loading";
    function _(t, e) {
        e = e || {};
        var s = t.tabIndex;
        (t.tabIndex = -1),
            (t.dataset.tabIndex = s),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function i(o) {
                o.target.removeEventListener(o.type, i), (t.tabIndex = s), delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function R(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter(function (t) {
            return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || ((e = t), (s = window.getComputedStyle(e)), "none" === s.display || "hidden" === s.visibility));
            var e, s;
        });
    }
    var N = {};
    function z() {
        document.removeEventListener("focusin", N.focusin), document.removeEventListener("focusout", N.focusout), document.removeEventListener("keydown", N.keydown);
    }
    var U = Object.freeze({
        __proto__: null,
        forceFocus: _,
        focusHash: function (t) {
            t = t || {};
            var e = window.location.hash,
                s = document.getElementById(e.slice(1));
            if (s && t.ignore && s.matches(t.ignore)) return !1;
            e && s && _(s, t);
        },
        bindInPageLinks: function (t) {
            return (
                (t = t || {}),
                Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                    if ("#" === e.hash || "" === e.hash) return !1;
                    if (t.ignore && e.matches(t.ignore)) return !1;
                    if (((s = e.hash.substr(1)), null === document.getElementById(s))) return !1;
                    var s,
                        i = document.querySelector(e.hash);
                    return (
                        !!i &&
                        (e.addEventListener("click", function () {
                            _(i, t);
                        }),
                        !0)
                    );
                })
            );
        },
        focusable: R,
        trapFocus: function (t, e) {
            e = e || {};
            var s = R(t),
                i = e.elementToFocus || t,
                o = s[0],
                n = s[s.length - 1];
            z(),
                (N.focusin = function (e) {
                    t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), (e.target !== t && e.target !== n && e.target !== o) || document.addEventListener("keydown", N.keydown);
                }),
                (N.focusout = function () {
                    document.removeEventListener("keydown", N.keydown);
                }),
                (N.keydown = function (e) {
                    "Tab" === e.code && (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()), (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
                }),
                document.addEventListener("focusout", N.focusout),
                document.addEventListener("focusin", N.focusin),
                _(i, e);
        },
        removeTrapFocus: z,
        accessibleLinks: function (t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var s,
                    i,
                    o,
                    n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    r = e.prefix || "a11y",
                    a = { newWindow: r + "-new-window-message", external: r + "-external-message", newWindowExternal: r + "-new-window-external-message" };
                t.forEach(function (t) {
                    var e = t.getAttribute("target"),
                        s = t.getAttribute("rel"),
                        i = (function (t) {
                            return t.hostname !== window.location.hostname;
                        })(t),
                        o = "_blank" === e,
                        n = null === s || -1 === s.indexOf("noopener");
                    if (o && n) {
                        var r = null === s ? "noopener" : s + " noopener";
                        t.setAttribute("rel", r);
                    }
                    i && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : i ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow);
                }),
                    (s = n),
                    (i = document.createElement("ul")),
                    (o = Object.keys(s).reduce(function (t, e) {
                        return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
                    }, "")),
                    i.setAttribute("hidden", !0),
                    (i.innerHTML = o),
                    document.body.appendChild(i);
            }
        },
    });
    const W = 'input[type="search"]',
        V = '[aria-selected="true"] a',
        j = 'button[type="reset"]',
        X = "hidden";
    let J = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(X);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(X) : 0 !== this.input.value.length || t || this.resetButton.classList.add(X);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(V);
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && ((this.input.value = ""), this.toggleResetButton(), t.target.querySelector(W).focus());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(W)),
                (this.resetButton = this.querySelector(j)),
                this.input &&
                    (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        y((t) => {
                            this.onChange(t);
                        }, 300).bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", J);
    const Y = '[role="option"]',
        Q = '[aria-selected="true"]',
        G = "[data-popular-searches]",
        K = "predictive-search",
        Z = "[data-predictive-search-results]",
        tt = "[data-predictive-search-status]",
        et = 'input[type="search"]',
        st = "[data-popdown]",
        it = "[data-predictive-search-live-region-count-value]",
        ot = "[data-search-results-groups-wrapper]",
        nt = "[data-predictive-search-search-for-text]",
        rt = "#shopify-section-predictive-search",
        at = '[aria-selected="true"] a',
        lt = '[aria-selected="true"] a, button[aria-selected="true"]';
    let ct = class extends J {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("focusout", this.onFocusOut.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            (this.searchTerm && t.startsWith(this.searchTerm)) || null === (e = this.querySelector(ot)) || void 0 === e || e.remove();
            this.updateSearchForTerm(this.searchTerm, t), (this.searchTerm = t), this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(at)) || t.preventDefault();
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
        }
        shouldResetForm() {
            return !document.querySelector(at);
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
        }
        onKeyup(t) {
            switch ((this.getQuery().length || this.close(!0), t.preventDefault(), t.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        updateSearchForTerm(t, e) {
            const s = this.querySelector(nt),
                i = null == s ? void 0 : s.innerText;
            if (i) {
                var o;
                if ((null === (o = i.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const n = i.replace(t, e);
                s.innerText = n;
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                s = this.querySelector(Q),
                i = Array.from(this.querySelectorAll(Y)).filter((t) => null !== t.offsetParent);
            let o = 0;
            if (e && !s) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
            if (((this.statusElement.textContent = ""), !e && s ? (o = n === i.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? i.length - 1 : n - 1), o === n)) return;
            const a = i[o];
            a.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
            const t = this.querySelector(lt);
            t && t.click();
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(),
                this.cachedResults[e]
                    ? this.renderSearchResults(this.cachedResults[e])
                    : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, { signal: this.abortController.signal })
                          .then((t) => {
                              if (!t.ok) {
                                  var e = new Error(t.status);
                                  throw (this.close(), e);
                              }
                              return t.text();
                          })
                          .then((t) => {
                              const s = new DOMParser().parseFromString(t, "text/html").querySelector(rt).innerHTML;
                              this.allPredictiveSearchInstances.forEach((t) => {
                                  t.cachedResults[e] = s;
                              }),
                                  this.renderSearchResults(s);
                          })
                          .catch((t) => {
                              if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                          });
        }
        setLiveRegionLoadingState() {
            (this.statusElement = this.statusElement || this.querySelector(tt)), (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0);
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"),
                (this.statusElement.textContent = t),
                setTimeout(() => {
                    this.statusElement.setAttribute("aria-hidden", "true");
                }, 1e3);
        }
        renderSearchResults(t) {
            (this.predictiveSearchResults.innerHTML = t), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(it).textContent);
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0);
        }
        close(t = !1) {
            this.closeResults(t), (this.isOpen = !1);
        }
        closeResults(t = !1) {
            var e;
            t && ((this.input.value = ""), this.removeAttribute("results"));
            const s = this.querySelector(Q);
            s && s.setAttribute("aria-selected", !1),
                this.input.setAttribute("aria-activedescendant", ""),
                this.removeAttribute("loading"),
                this.removeAttribute("open"),
                this.input.setAttribute("aria-expanded", !1),
                null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style");
        }
        reset() {
            (this.predictiveSearchResults.innerHTML = ""),
                (this.input.val = ""),
                this.a11y.removeTrapFocus(),
                this.popularSearches && (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })), this.a11y.trapFocus(this.searchPopdown, { elementToFocus: this.input }));
        }
        constructor() {
            var t;
            super(),
                (this.a11y = U),
                (this.abortController = new AbortController()),
                (this.allPredictiveSearchInstances = document.querySelectorAll(K)),
                (this.cachedResults = {}),
                (this.input = this.querySelector(et)),
                (this.isOpen = !1),
                (this.predictiveSearchResults = this.querySelector(Z)),
                (this.searchPopdown = this.closest(st)),
                (this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector(G)),
                (this.searchTerm = "");
        }
    };
    const ht = "[data-popout-list]",
        dt = "[data-popout-toggle]",
        ut = "[data-popout-toggle-text]",
        pt = "[data-popout-input]",
        mt = "[data-popout-option]",
        vt = "[data-product-image]",
        gt = "[data-product-grid-item]",
        ft = "popout-list--visible",
        yt = "is-visible",
        bt = "is-active",
        wt = "select-popout--top",
        Et = "aria-expanded",
        St = "aria-current",
        Lt = "data-value",
        kt = "data-popout-toggle-text",
        At = "submit";
    let Tt = class extends HTMLElement {
            connectedCallback() {
                (this.popoutList = this.querySelector(ht)),
                    (this.popoutToggle = this.querySelector(dt)),
                    (this.popoutToggleText = this.querySelector(ut)),
                    (this.popoutInput = this.querySelector(pt)),
                    (this.popoutOptions = this.querySelectorAll(mt)),
                    (this.productGrid = this.popoutList.closest(gt)),
                    (this.fireSubmitEvent = this.hasAttribute(At)),
                    (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
                    (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
                    (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
                    (this.keyUpEvent = (t) => this.onKeyUp(t)),
                    (this.bodyClickEvent = (t) => this.onBodyClick(t)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popupListMaxWidth();
            }
            onPopupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(Et);
                if (this.productGrid) {
                    const t = this.productGrid.querySelector(vt);
                    t && t.classList.toggle(yt, !e), (this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGrid.getBoundingClientRect().bottom)}px`);
                }
                t.currentTarget.setAttribute(Et, !e), this.popoutList.classList.toggle(ft), this.popupListMaxWidth(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent);
            }
            onPopupToggleFocusout(t) {
                this.contains(t.relatedTarget) || this._hideList();
            }
            onPopupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(ft) && !e && this._hideList();
            }
            toggleListPosition() {
                const t = "true" === this.querySelector(dt).getAttribute(Et),
                    e = window.innerHeight,
                    s = this.popoutList.getBoundingClientRect().bottom,
                    i = () => {
                        this.classList.remove(wt), this.popoutList.removeEventListener("transitionend", i);
                    };
                t ? e < s && this.classList.add(wt) : this.popoutList.addEventListener("transitionend", i);
            }
            popupListMaxWidth() {
                this.popoutList.style.setProperty("--max-width", "100vw"),
                    requestAnimationFrame(() => {
                        this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`);
                    });
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(mt).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if ((t.currentTarget.getAttribute(Lt) && (e = t.currentTarget.getAttribute(Lt)), (this.popoutInput.value = e), this.fireSubmitEvent)) this._submitForm(e);
                    else {
                        const s = t.currentTarget.parentElement,
                            i = this.popoutList.querySelector(`.${bt}`),
                            o = this.popoutList.querySelector(`[${St}]`);
                        this.popoutInput.dispatchEvent(new Event("change")),
                            i && (i.classList.remove(bt), s.classList.add(bt)),
                            "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add(bt),
                            o && o.hasAttribute(`${St}`) && (o.removeAttribute(`${St}`), t.currentTarget.setAttribute(`${St}`, "true")),
                            "" !== e && ((this.popoutToggleText.textContent = e), this.popoutToggleText.hasAttribute(kt) && "" !== this.popoutToggleText.getAttribute(kt) && this.popoutToggleText.setAttribute(kt, e)),
                            this.onPopupToggleFocusout(t),
                            this.onPopupListFocusout(t);
                    }
                }
            }
            onKeyUp(t) {
                "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
            }
            onBodyClick(t) {
                const e = this.contains(t.target);
                this.popoutList.classList.contains(ft) && !e && this._hideList();
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.addEventListener("click", (t) => this.popupOptionsClick(t));
                    });
            }
            _onFocusOut() {
                this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);
            }
            _submitForm() {
                const t = this.closest("form");
                t && t.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(ft), this.popoutToggle.setAttribute(Et, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent);
            }
            constructor() {
                super();
            }
        },
        Ct = class extends HTMLElement {
            connectedCallback() {
                (this.input = this.querySelector("input")),
                    (this.changeEvent = new Event("change", { bubbles: !0 })),
                    (this.buttonClickEvent = this.onButtonClick.bind(this)),
                    this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.buttonClickEvent));
            }
            onButtonClick(t) {
                t.preventDefault();
                const e = this.input.value,
                    s = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
                "increase" === s.name && this.input.stepUp(), "decrease" === s.name && this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent), "updates[]" == this.input.name && this.updateCart();
            }
            updateCart() {
                "" !== this.quantityValue && this.dispatchEvent(new CustomEvent("theme:cart:update", { bubbles: !0, detail: { id: this.input.dataset.id, quantity: this.input.value } }));
            }
            constructor() {
                super();
            }
        };
    const qt = "[data-aos]:not(.aos-animate)",
        xt = "[data-aos-anchor]",
        Mt = "aos-animate",
        Ht = { attributes: !1, childList: !0, subtree: !0 };
    let Pt = [];
    const It = (t) => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        s = t.querySelectorAll(qt),
                        i = t.querySelectorAll(xt);
                    s.length &&
                        s.forEach((t) => {
                            Bt.observe(t);
                        }),
                        i.length && Ft(i);
                }
        },
        Bt = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.isIntersecting && (t.target.classList.add(Mt), e.unobserve(t.target));
                });
            },
            { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
        ),
        Dt = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    if (t.intersectionRatio) {
                        const s = t.target.querySelectorAll(qt);
                        s.length &&
                            s.forEach((t) => {
                                t.classList.add(Mt);
                            }),
                            e.unobserve(t.target);
                    }
                });
            },
            { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
        );
    function Ft(t) {
        t.length &&
            t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                if (e && -1 === Pt.indexOf(e)) {
                    const t = document.querySelector(e);
                    t && (Dt.observe(t), Pt.push(e));
                }
            });
    }
    let Ot = class extends HTMLElement {
        connectedCallback() {
            this.closest(".shopify-section").addEventListener(
                "mouseover",
                () => {
                    this.classList.remove("hidden");
                },
                { once: !0 }
            );
        }
        constructor() {
            super();
        }
    };
    const $t = "[data-deferred-media-button]",
        _t = "video, model-viewer, iframe",
        Rt = '[data-host="youtube"]',
        Nt = '[data-host="vimeo"]',
        zt = "[data-product-grid-item]",
        Ut = ".shopify-section",
        Wt = "template",
        Vt = "video",
        jt = "product-model",
        Xt = "hidden",
        Jt = "loaded",
        Yt = "autoplay";
    let Qt = class extends HTMLElement {
        connectedCallback() {
            this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, { once: !0 }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent));
        }
        disconnectedCallback() {
            this.productGridItem &&
                (this.section.removeEventListener("mouseover", this.mouseOverEvent, { once: !0 }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent));
        }
        mouseOverActions() {
            this.classList.remove(Xt);
        }
        mouseEnterActions() {
            (this.hovered = !0), this.videoActions(), this.getAttribute(Jt) || this.loadContent();
        }
        mouseLeaveActions() {
            (this.hovered = !1), this.videoActions();
        }
        videoActions() {
            if (this.getAttribute(Jt)) {
                const t = this.querySelector(Rt),
                    e = this.querySelector(Nt),
                    s = t || e,
                    i = this.querySelector(Vt);
                if (s) {
                    let t = this.hovered ? "playVideo" : "pauseVideo",
                        i = `{"event":"command","func":"${t}","args":""}`;
                    e && ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
                        s.contentWindow.postMessage(i, "*"),
                        s.addEventListener("load", (t) => {
                            this.videoActions();
                        });
                } else i && (this.hovered ? i.play() : i.pause());
            }
        }
        loadContent(t = !0) {
            if ((this.pauseAllMedia(), !this.getAttribute(Jt))) {
                const e = document.createElement("div"),
                    s = this.querySelector(Wt).content.firstElementChild.cloneNode(!0);
                e.appendChild(s), this.setAttribute(Jt, !0);
                const i = this.appendChild(e.querySelector(_t));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute(Yt) && i.play(), this.productGridItem && this.videoActions();
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(Rt).forEach((t) => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            }),
                document.querySelectorAll(Nt).forEach((t) => {
                    t.contentWindow.postMessage('{"method":"pause"}', "*");
                }),
                document.querySelectorAll(Vt).forEach((t) => t.pause()),
                document.querySelectorAll(jt).forEach((t) => {
                    t.modelViewerUI && t.modelViewerUI.pause();
                });
        }
        constructor() {
            super();
            const t = this.querySelector($t);
            null == t || t.addEventListener("click", this.loadContent.bind(this)),
                (this.section = this.closest(Ut)),
                (this.productGridItem = this.closest(zt)),
                (this.hovered = !1),
                (this.mouseOverEvent = () => this.mouseOverActions()),
                (this.mouseEnterEvent = () => this.mouseEnterActions()),
                (this.mouseLeaveEvent = () => this.mouseLeaveActions());
        }
    };
    const Gt = "is-visible";
    class Kt {
        init() {
            var t;
            const e = { root: this.container, threshold: [0, 0.5, 0.75, 1] };
            (this.observer = new IntersectionObserver((t) => {
                t.forEach((t) => {
                    t.intersectionRatio > 0.5 ? t.target.classList.add(Gt) : t.target.classList.remove(Gt);
                });
            }, e)),
                null === (t = this.container.querySelectorAll(this.itemSelector)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        this.observer.observe(t);
                    });
        }
        destroy() {
            this.observer.disconnect();
        }
        constructor(t, e) {
            t && e && ((this.observer = null), (this.container = t), (this.itemSelector = e), this.init());
        }
    }
    const Zt = "is-dragging",
        te = "is-enabled",
        ee = "is-scrolling",
        se = "is-visible",
        ie = "[data-grid-item]";
    class oe {
        handleMouseDown(t) {
            t.preventDefault(), (this.isDown = !0), (this.startX = t.pageX - this.slider.offsetLeft), (this.scrollLeft = this.slider.scrollLeft), this.cancelMomentumTracking();
        }
        handleMouseLeave() {
            this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
        }
        handleMouseUp() {
            (this.isDown = !1), this.beginMomentumTracking();
        }
        handleMouseMove(t) {
            if (!this.isDown) return;
            t.preventDefault();
            const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
                s = this.slider.scrollLeft,
                i = e > 0 ? 1 : -1;
            this.slider.classList.add(Zt, ee), (this.slider.scrollLeft = this.scrollLeft - e), this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || i);
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(ee);
        }
        beginMomentumTracking() {
            (this.isScrolling = !1), this.slider.classList.remove(Zt), this.cancelMomentumTracking(), this.scrollToSlide();
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation);
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            const t = this.slider.querySelector(`${ie}.${se}`);
            if (!t) return;
            const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                s = t.offsetWidth + e,
                i = t.offsetLeft,
                o = this.velX > 0 ? 1 : -1,
                n = Math.floor(Math.abs(this.velX) / 100) || 1;
            (this.startPosition = this.slider.scrollLeft),
                (this.distance = i - this.startPosition),
                (this.startTime = performance.now()),
                (this.isScrolling = !0),
                o < 0 && this.velX < s && (this.distance -= s * n),
                o > 0 && this.velX < s && (this.distance += s * n),
                (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
        }
        scrollStep() {
            const t = performance.now() - this.startTime,
                e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
            (this.slider.scrollLeft = e), t < this.duration ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep)) : (this.slider.classList.remove(ee), (this.velX = 0), (this.isScrolling = !1));
        }
        easeOutCubic(t) {
            return (t /= this.duration), t--, this.distance * (t * t * t + 1) + this.startPosition;
        }
        destroy() {
            this.slider.classList.remove(te),
                this.slider.removeEventListener("mousedown", this.handleMouseDown),
                this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
                this.slider.removeEventListener("mouseup", this.handleMouseUp),
                this.slider.removeEventListener("mousemove", this.handleMouseMove),
                this.slider.removeEventListener("wheel", this.handleMouseWheel);
        }
        constructor(t) {
            (this.slider = t),
                (this.isDown = !1),
                (this.startX = 0),
                (this.scrollLeft = 0),
                (this.velX = 0),
                (this.scrollAnimation = null),
                (this.isScrolling = !1),
                (this.duration = 800),
                (this.scrollStep = this.scrollStep.bind(this)),
                (this.scrollToSlide = this.scrollToSlide.bind(this)),
                (this.handleMouseDown = this.handleMouseDown.bind(this)),
                (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
                (this.handleMouseUp = this.handleMouseUp.bind(this)),
                (this.handleMouseMove = this.handleMouseMove.bind(this)),
                (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
                this.slider.addEventListener("mousedown", this.handleMouseDown),
                this.slider.addEventListener("mouseleave", this.handleMouseLeave),
                this.slider.addEventListener("mouseup", this.handleMouseUp),
                this.slider.addEventListener("mousemove", this.handleMouseMove),
                this.slider.addEventListener("wheel", this.handleMouseWheel, { passive: !0 }),
                this.slider.classList.add(te);
        }
    }
    const ne = "[data-button-arrow]",
        re = "[data-collection-image]",
        ae = "[data-column-image]",
        le = "[data-product-image-default]",
        ce = "[data-grid-item]",
        he = "[data-grid-slider]",
        de = "data-button-prev",
        ue = "data-button-next",
        pe = "align-arrows",
        me = "slider__arrows",
        ve = "is-visible";
    class ge extends HTMLElement {
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init);
        }
        init() {
            (this.slider = this.querySelector(he)), (this.slides = this.querySelectorAll(ce)), (this.buttons = this.querySelectorAll(ne)), this.toggleSlider(), document.addEventListener("theme:resize:width", this.toggleSlider);
        }
        toggleSlider() {
            if (!(this.slider.clientWidth < this.getSlidesWidth()) || (!E() && window.theme.touch)) this.destroy();
            else {
                if (this.isInitialized) return;
                (this.slidesObserver = new Kt(this.slider, ce)), this.initArrows(), (this.isInitialized = !0), (this.draggableSlider = new oe(this.slider));
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(me),
                    (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
                    this.append(t),
                    (this.buttons = this.querySelectorAll(ne)),
                    (this.buttonPrev = this.querySelector(`[${de}]`)),
                    (this.buttonNext = this.querySelector(`[${ue}]`));
            }
            this.toggleArrowsObserver(),
                this.hasAttribute(pe) && (this.positionArrows(), this.arrowsResizeObserver()),
                this.buttons.forEach((t) => {
                    t.addEventListener("click", this.onButtonArrowClick);
                });
        }
        buttonArrowClickEvent(t) {
            t.preventDefault();
            const e = this.slider.querySelector(`${ce}.${ve}`);
            let s = null;
            t.target.hasAttribute(de) && (s = null == e ? void 0 : e.previousElementSibling), t.target.hasAttribute(ue) && (s = null == e ? void 0 : e.nextElementSibling), this.goToSlide(s);
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${me}`)) || void 0 === t || t.remove();
        }
        goToSlide(t) {
            t && this.slider.scrollTo({ top: 0, left: t.offsetLeft, behavior: "smooth" });
        }
        getSlidesWidth() {
            var t;
            return (null === (t = this.slider.querySelector(ce)) || void 0 === t ? void 0 : t.clientWidth) * this.slider.querySelectorAll(ce).length;
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                const t = this.slides.length,
                    e = this.slides[0],
                    s = this.slides[t - 1],
                    i = { attributes: !0, childList: !1, subtree: !1 },
                    o = (t) => {
                        for (const i of t)
                            if ("attributes" === i.type) {
                                const t = i.target,
                                    o = Boolean(t.classList.contains(ve));
                                t == e && (this.buttonPrev.disabled = o), t == s && (this.buttonNext.disabled = o);
                            }
                    };
                e && s && ((this.firstLastSlidesObserver = new MutationObserver(o)), this.firstLastSlidesObserver.observe(e, i), this.firstLastSlidesObserver.observe(s, i));
            }
        }
        positionArrows() {
            var t;
            const e = (null === (t = this.slider.querySelector(le)) || void 0 === t ? void 0 : t.parentNode) || this.slider.querySelector(re) || this.slider.querySelector(ae) || this.slider;
            e && this.style.setProperty("--button-position", e.clientHeight / 2 + "px");
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows);
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider);
        }
        destroy() {
            var t, e;
            (this.isInitialized = !1),
                null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
                (this.draggableSlider = null),
                null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
                (this.slidesObserver = null),
                this.removeArrows(),
                document.removeEventListener("theme:resize:width", this.positionArrows);
        }
        constructor() {
            super(),
                (this.isInitialized = !1),
                (this.draggableSlider = null),
                (this.positionArrows = this.positionArrows.bind(this)),
                (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
                (this.slidesObserver = null),
                (this.firstLastSlidesObserver = null),
                (this.isDragging = !1),
                (this.toggleSlider = this.toggleSlider.bind(this));
        }
    }
    const fe = "time",
        ye = "[data-days]",
        be = "[data-hours]",
        we = "[data-minutes]",
        Ee = "[data-seconds]",
        Se = ".shopify-section",
        Le = "data-expiration-behavior",
        ke = "show-message",
        Ae = "hidden",
        Te = "hide-section",
        Ce = "show-message";
    let qe = class extends HTMLElement {
        connectedCallback() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : (this.interval = setInterval(this.update, 1e3));
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= s * this.hoursInMs;
            const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= i * this.minutesInMs;
            return { days: e, hours: s, minutes: i, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
        }
        formatDigits(t) {
            return t < 10 && (t = "0" + t), t;
        }
        render(t) {
            (this.days.textContent = t.days), (this.hours.textContent = t.hours), (this.minutes.textContent = t.minutes), (this.seconds.textContent = t.seconds);
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        onComplete() {
            this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }), this.shouldHideOnComplete && this.shopifySection.classList.add(Ae), this.shouldShowMessage && this.classList.add(ke);
        }
        update() {
            const t = new Date().getTime(),
                e = this.endDate - t;
            e <= 0 && (this.stopTimer(), this.onComplete());
            const s = this.convertTime(e);
            this.render(s);
        }
        constructor() {
            super(),
                (this.shopifySection = this.closest(Se)),
                (this.expirationBehavior = this.getAttribute(Le)),
                (this.time = this.querySelector(fe)),
                (this.days = this.querySelector(ye)),
                (this.hours = this.querySelector(be)),
                (this.minutes = this.querySelector(we)),
                (this.seconds = this.querySelector(Ee)),
                (this.endDate = Date.parse(this.time.dateTime)),
                (this.daysInMs = 864e5),
                (this.hoursInMs = this.daysInMs / 24),
                (this.minutesInMs = this.hoursInMs / 60),
                (this.secondsInMs = this.minutesInMs / 60),
                (this.shouldHideOnComplete = this.expirationBehavior === Te),
                (this.shouldShowMessage = this.expirationBehavior === Ce),
                (this.update = this.update.bind(this));
        }
    };
    (window.requestIdleCallback =
        window.requestIdleCallback ||
        function (t) {
            var e = Date.now();
            return setTimeout(function () {
                t({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - e));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.theme.settings.enableAnimations &&
            (!(function () {
                const t = document.querySelectorAll(qt);
                t.length &&
                    t.forEach((t) => {
                        Bt.observe(t);
                    });
            })(),
            (function () {
                const t = document.querySelectorAll(xt);
                t.length && Ft(t);
            })(),
            new MutationObserver(It).observe(document.body, Ht)),
        window.addEventListener(
            "resize",
            y(function () {
                document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
                    L !== b() && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (L = b())),
                    k !== w() && (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })), (k = w()));
            }, 50)
        ),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.scrollY;
                                t > A ? ((C = !0), (T = !1)) : t < A ? ((C = !1), (T = !0)) : ((T = null), (C = null)),
                                    (A = t),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: T, down: C, position: t }, bubbles: !1 })),
                                    T && !q && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                    C && !x && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                    (x = C),
                                    (q = T);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", H),
                window.addEventListener("theme:scroll:unlock", P);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch")), (window.theme.touch = !0))
            : (window.theme.touch = !1),
        d(),
        document.addEventListener(
            "load",
            (t) => {
                "IMG" == t.target.tagName && t.target.classList.contains(O) && (t.target.classList.remove(O), t.target.parentNode.classList.remove(O));
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            h(),
                F(document),
                a(document),
                D(document),
                document.querySelectorAll($).forEach((t) => {
                    t.complete && (t.classList.remove(O), t.parentNode.classList.remove(O));
                }),
                document.body.classList.add("is-loaded"),
                window.fastNetworkAndCPU &&
                    ((document.onreadystatechange = () => {
                        "complete" === document.readyState && ((g = !0), f());
                    }),
                    requestIdleCallback(f)),
                requestIdleCallback(() => {
                    Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode");
                });
        }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            a(e), D(e), F(document), h();
        }),
        customElements.get("popout-select") || customElements.define("popout-select", Tt),
        customElements.get("quantity-counter") || customElements.define("quantity-counter", Ct),
        customElements.get("predictive-search") || customElements.define("predictive-search", ct),
        customElements.get("deferred-image") || customElements.define("deferred-image", Ot),
        customElements.get("deferred-media") || customElements.define("deferred-media", Qt),
        customElements.get("grid-slider") || customElements.define("grid-slider", ge),
        customElements.get("countdown-timer") || customElements.define("countdown-timer", qe);
    const xe = (t, e = !1, s = "block") => {
        t && (e ? t.style.removeProperty("display") : (t.style.display = s));
    };
    Shopify.Products = (function () {
        const t = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", section: null, onComplete: null };
        let e = [],
            s = null,
            i = null;
        const o = new Date(),
            n = new Date();
        n.setTime(o.getTime() + 7776e6);
        const r = {
                configuration: { expires: n.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 },
                name: "shopify_recently_viewed",
                write: function (t) {
                    const e = t.join(" ");
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                },
                read: function () {
                    let t = [],
                        e = null;
                    return (
                        -1 !== document.cookie.indexOf("; ") &&
                            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                            (e = document.cookie
                                .split("; ")
                                .find((t) => t.startsWith(this.name))
                                .split("=")[1]),
                        null !== e && (t = e.split(" ")),
                        t
                    );
                },
                destroy: function () {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                },
                remove: function (t) {
                    const e = this.read(),
                        s = e.indexOf(t);
                    -1 !== s && (e.splice(s, 1), this.write(e));
                },
            },
            a = (e, s, o, n) => {
                s.length && e < t.howManyToShow
                    ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=api-product-grid-item`)
                          .then((t) => t.text())
                          .then((t) => {
                              const i = 150 * e,
                                  r = 100 * e + 800,
                                  l = 50 * e + 800,
                                  c = o.id ? `#${o.id}` : "",
                                  h = document.createElement("div");
                              let d = t;
                              (d = d.includes("||itemAosDelay||") ? d.replaceAll("||itemAosDelay||", i) : d),
                                  (d = d.includes("||itemAosImageDuration||") ? d.replaceAll("||itemAosImageDuration||", r) : d),
                                  (d = d.includes("||itemAosTextDuration||") ? d.replaceAll("||itemAosTextDuration||", l) : d),
                                  (d = d.includes("||itemAnimationAnchor||") ? d.replaceAll("||itemAnimationAnchor||", c) : d),
                                  (h.innerHTML = d),
                                  (o.innerHTML += h.querySelector("[data-api-content]").innerHTML),
                                  s.shift(),
                                  e++,
                                  a(e, s, o, n);
                          })
                          .catch(() => {
                              r.remove(s[0]), s.shift(), a(e, s, o, n);
                          })
                    : ((e, s) => {
                          xe(e, !0);
                          const o = r.read().length;
                          if (Shopify.recentlyViewed && i && o && o < i && e.children.length) {
                              let t = [],
                                  s = [],
                                  i = 0;
                              for (const e in Shopify.recentlyViewed) {
                                  i += 1;
                                  const o = Shopify.recentlyViewed[e].split(" "),
                                      n = parseInt(e.split("_")[1]);
                                  (t = [...t, ...o]), (r.read().length === n || (i === Object.keys(Shopify.recentlyViewed).length && !s.length)) && (s = [...s, ...o]);
                              }
                              for (let i = 0; i < e.children.length; i++) {
                                  const o = e.children[i];
                                  t.length && o.classList.remove(...t), s.length && o.classList.add(...s);
                              }
                          }
                          if (t.onComplete)
                              try {
                                  t.onComplete(e, s);
                              } catch (t) {
                                  console.log(t);
                              }
                      })(o, n);
            };
        return {
            showRecentlyViewed: function (o) {
                const n = o || {};
                Object.assign(t, n), (e = r.read()), (s = document.querySelector(`#${t.wrapperId}`)), (i = t.howManyToShow), (t.howManyToShow = Math.min(e.length, t.howManyToShow)), t.howManyToShow && s && a(0, e, s, t.section);
            },
            getConfig: function () {
                return t;
            },
            clearList: function () {
                r.destroy();
            },
            recordRecentlyViewed: function (e) {
                const s = e || {};
                Object.assign(t, s);
                let i = r.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    let e = decodeURIComponent(window.location.pathname)
                        .match(
                            /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                        )[0]
                        .split("/products/")[1];
                    t.handle && (e = t.handle);
                    const s = i.indexOf(e);
                    -1 === s ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory))) : (i.splice(s, 1), i.unshift(e)), r.write(i);
                }
            },
            hasProducts: r.read().length > 0,
        };
    })();
    const Me = (t, e = [], s = !1) => {
            const i = Object.keys(t)
                .map((i) => {
                    let o = t[i];
                    if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(i), Me(o, e, Array.isArray(o));
                    {
                        let t = i;
                        if (e.length > 0) {
                            t = (s ? e : [...e, i]).reduce((t, e) => ("" === t ? e : `${t}[${e}]`), "");
                        }
                        return s ? `${t}[]=${o}` : `${t}=${o}`;
                    }
                })
                .join("&");
            return e.pop(), i;
        },
        He = (t) => {
            t && (t.style.display = "none");
        },
        Pe = (t, e, s = null) => {
            (t.style.opacity = 0), (t.style.display = e || "block");
            let i = !0;
            !(function e() {
                let o = parseFloat(t.style.opacity);
                (o += 0.1) > 1 || ((t.style.opacity = o), requestAnimationFrame(e)), 1 === parseInt(o) && i && "function" == typeof s && ((i = !1), s());
            })();
        };
    function Ie(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    Ie.prototype = Error.prototype;
    const Be = "[data-template-no-shipping]",
        De = ".get-rates",
        Fe = "#address_container",
        Oe = "#address_country",
        $e = "#address_province",
        _e = "#address_zip",
        Re = "#wrapper-response",
        Ne = "#shipping-calculator-response-template",
        ze = "data-template-no-shipping",
        Ue = "data-default",
        We = "error",
        Ve = "center",
        je = "success",
        Xe = "disabled",
        Je = "get-rates--trigger",
        Ye = "Error : country is not supported.",
        Qe = "We do not ship to this destination.",
        Ge = "Error : ";
    let Ke = class extends HTMLElement {
        connectedCallback() {
            const t = document.querySelector("html");
            let s = "en";
            if (
                (t.hasAttribute("lang") && "" !== t.getAttribute("lang") && (s = t.getAttribute("lang")),
                this.fieldsContainer && e.AddressForm(this.fieldsContainer, s, { shippingCountriesOnly: !0 }),
                this.selectCountry && this.selectCountry.hasAttribute(Ue) && this.selectProvince && this.selectProvince.hasAttribute(Ue) && this.selectCountry.addEventListener("change", this.onCountryChangeEvent),
                this.getRatesButton && (this.getRatesButton.addEventListener("click", this.onButtonClickEvent), theme.settings.customerLoggedIn && this.getRatesButton.classList.contains(Je)))
            ) {
                const t = document.querySelector(_e);
                t && t.value && this.getRatesButton.dispatchEvent(new Event("click"));
            }
        }
        disconnectedCallback() {
            this.selectCountry && this.selectCountry.hasAttribute(Ue) && this.selectProvince && this.selectProvince.hasAttribute(Ue) && this.selectCountry.removeEventListener("change", this.onCountryChangeEvent),
                this.getRatesButton && this.getRatesButton.removeEventListener("click", this.onButtonClickEvent);
        }
        onCountryChange() {
            this.selectCountry.removeAttribute(Ue), this.selectProvince.removeAttribute(Ue);
        }
        onButtonClick() {
            for (this.disableButtons(); this.wrapper.firstChild; ) this.wrapper.removeChild(this.wrapper.firstChild);
            He(this.wrapper);
            const t = {};
            let e = this.selectCountry.value,
                s = this.selectProvince.value;
            const i = this.selectCountry.getAttribute(Ue);
            "" === e && i && "" !== i && (e = i);
            const o = this.selectProvince.getAttribute(Ue);
            "" === s && o && "" !== o && (s = o), (t.zip = document.querySelector(_e).value || ""), (t.country = e || ""), (t.province = s || ""), this.getCartShippingRatesForDestination(t);
        }
        formatRate(t) {
            return "0.00" === t ? window.theme.strings.free : s.formatMoney(t, theme.moneyFormat);
        }
        render(t) {
            if (this.template && this.wrapper) {
                this.wrapper.innerHTML = "";
                let e = "",
                    s = "",
                    i = `${We} ${Ve}`,
                    o = this.template.innerHTML;
                const n = /[^[\]]+(?=])/g;
                if (t.rates && t.rates.length) {
                    let s = n.exec(o)[0];
                    t.rates.forEach((t) => {
                        let i = s;
                        (i = i.replace(/\|\|rateName\|\|/, t.name)), (i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))), (e += i);
                    });
                }
                if (t.success) {
                    i = `${je} ${Ve}`;
                    const e = document.createElement("div");
                    e.innerHTML = this.template.innerHTML;
                    const o = e.querySelector(Be);
                    t.rates.length < 1 && o && (s = o.getAttribute(ze));
                } else s = t.errorFeedback;
                (o = o.replace(n, "").replace("[]", "")), (o = o.replace(/\|\|ratesList\|\|/g, e)), (o = o.replace(/\|\|successClass\|\|/g, i)), (o = o.replace(/\|\|ratesText\|\|/g, s)), (this.wrapper.innerHTML += o), Pe(this.wrapper);
            }
        }
        enableButtons() {
            this.getRatesButton.removeAttribute("disabled"), this.getRatesButton.classList.remove(Xe), (this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButton);
        }
        disableButtons() {
            this.getRatesButton.setAttribute("disabled", "disabled"), this.getRatesButton.classList.add(Xe), (this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButtonDisabled);
        }
        getCartShippingRatesForDestination(t) {
            const e = encodeURI(Me({ shipping_address: t })),
                s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
            fetch(s)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((e) => {
                    const s = JSON.parse(e).shipping_rates;
                    this.onCartShippingRatesUpdate(s, t);
                })
                .catch((t) => {
                    this.onError(t.json);
                });
        }
        fullMessagesFromErrors(t) {
            const e = [];
            for (const s in t) for (const i of t[s]) e.push(i);
            return e;
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Ie({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        onError(t) {
            this.enableButtons();
            let e = "";
            (e = t.message ? t.message + "(" + t.status + "): " + t.description : Ge + this.fullMessagesFromErrors(t).join("; ")), e === Ye && (e = Qe), this.render({ rates: [], errorFeedback: e, success: !1 });
        }
        onCartShippingRatesUpdate(t, e) {
            this.enableButtons();
            let s = "";
            e.zip && (s += e.zip + ", "), e.province && (s += e.province + ", "), (s += e.country), this.render({ rates: t, address: s, success: !0 });
        }
        constructor() {
            super(),
                (this.getRatesButton = this.querySelector(De)),
                (this.fieldsContainer = this.querySelector(Fe)),
                (this.selectCountry = this.querySelector(Oe)),
                (this.selectProvince = this.querySelector($e)),
                (this.template = this.querySelector(Ne)),
                (this.wrapper = this.querySelector(Re)),
                (this.onCountryChangeEvent = () => this.onCountryChange()),
                (this.onButtonClickEvent = () => this.onButtonClick());
        }
    };
    const Ze = (t, e) => {
            let s, i;
            return function o(...n) {
                const r = Date.now();
                (i = clearTimeout(i)), !s || r - s >= e ? (t.apply(null, n), (s = r)) : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
            };
        },
        ts = "is-animated",
        es = "is-added",
        ss = "is-disabled",
        is = "is-hidden",
        os = "is-hiding",
        ns = "is-loading",
        rs = "is-open",
        as = "is-removed",
        ls = "is-success",
        cs = "is-visible",
        hs = "is-expanded",
        ds = "is-updated",
        us = "variant--soldout",
        ps = "variant--unavailable",
        ms = "[data-api-content]",
        vs = "[data-api-line-items]",
        gs = "[data-api-upsell-items]",
        fs = "[data-api-cart-price]",
        ys = "[data-animation]",
        bs = ".additional-checkout-buttons",
        ws = "[data-foot-holder]",
        Es = "[data-skip-upsell-product]",
        Ss = "[data-add-to-cart-bar]",
        Ls = "[data-cart-error-close]",
        ks = "[data-cart-drawer]",
        As = "[data-cart-drawer-close]",
        Ts = "[data-cart-empty]",
        Cs = "[data-cart-errors]",
        qs = "[data-item-remove]",
        xs = "[data-cart-page]",
        Ms = "[data-cart-form]",
        Hs = "[data-cart-acceptance-checkbox]",
        Ps = "[data-cart-checkout-buttons]",
        Is = "[data-cart-checkout-button]",
        Bs = "[data-cart-total]",
        Ds = "[data-error-message]",
        Fs = "[data-close-error]",
        Os = "[data-cart-errors-container]",
        $s = "[data-form-wrapper]",
        _s = "[data-free-shipping]",
        Rs = "[data-progress-graph]",
        Ns = "[data-progress-bar]",
        zs = "[data-header-wrapper]",
        Us = "[data-item]",
        Ws = "[data-items-holder]",
        Vs = "[data-left-to-spend]",
        js = "[data-drawer]",
        Xs = "[data-section-id]",
        Js = "[data-cart-price-holder]",
        Ys = "[data-quick-add-holder]",
        Qs = "[data-quick-add-modal]",
        Gs = 'input[name="updates[]"]',
        Ks = "[data-upsell-products]",
        Zs = "[data-upsell-widget]",
        ti = "[data-terms-error-message]",
        ei = "data-cart-total",
        si = "disabled",
        ii = "data-drawer-underlay",
        oi = "data-free-shipping",
        ni = "data-free-shipping-limit",
        ri = "data-item",
        ai = "data-item-index",
        li = "data-item-title",
        ci = "data-quick-add-holder";
    (window.cart = new (class {
        init() {
            (this.cartPage = document.querySelector(xs)),
                (this.cartForm = document.querySelector(Ms)),
                (this.cartDrawer = document.querySelector(ks)),
                (this.cartDrawerClose = document.querySelector(As)),
                (this.cartEmpty = document.querySelector(Ts)),
                (this.cartTermsCheckbox = document.querySelector(Hs)),
                (this.cartCheckoutButtonWrapper = document.querySelector(Ps)),
                (this.cartCheckoutButton = document.querySelector(Is)),
                (this.buttonHolder = document.querySelector(ws)),
                (this.itemsHolder = document.querySelector(Ws)),
                (this.priceHolder = document.querySelector(Js)),
                (this.items = document.querySelectorAll(Us)),
                (this.cartTotal = document.querySelector(Bs)),
                (this.freeShipping = document.querySelectorAll(_s)),
                (this.cartErrorHolder = document.querySelector(Cs)),
                (this.cartCloseErrorMessage = document.querySelector(Ls)),
                (this.headerWrapper = document.querySelector(zs)),
                (this.accessibility = U),
                (this.navDrawer = document.querySelector(js)),
                (this.upsellProductsHolder = document.querySelector(Ks)),
                (this.subtotal = window.theme.subtotal),
                (this.cart = this.cartDrawer || this.cartPage),
                (this.cartAddEvent = this.cartAddEvent.bind(this)),
                (this.addToCart = this.addToCart.bind(this)),
                (this.updateProgress = this.updateProgress.bind(this)),
                document.addEventListener("theme:cart:add", this.cartAddEvent),
                document.addEventListener("theme:announcement:init", this.updateProgress),
                (this.skipUpsellProductsArray = []),
                this.skipUpsellProductEvent(),
                this.checkSkippedUpsellProductsFromStorage(),
                this.toggleCartUpsellWidgetVisibility(),
                (this.circumference = 28 * Math.PI),
                (this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute(ni)) * window.Shopify.currency.rate : 0),
                this.freeShippingMessageHandle(this.subtotal),
                this.updateProgress(),
                this.cart &&
                    ((this.build = this.build.bind(this)),
                    (this.updateCart = this.updateCart.bind(this)),
                    (this.productAddCallback = this.productAddCallback.bind(this)),
                    (this.openCartDrawer = this.openCartDrawer.bind(this)),
                    (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                    (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                    (this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this)),
                    (this.animateItems = this.animateItems.bind(this)),
                    (this.showAnimatedItems = this.showAnimatedItems.bind(this)),
                    (this.formSubmitHandler = Ze(this.formSubmitHandler.bind(this), 50)),
                    this.cartPage && this.showAnimatedItems(),
                    (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.cartCount = this.getCartItemCount()),
                    (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                    (this.totalItems = this.items.length),
                    (this.cartDrawerIsOpen = !1),
                    (this.cartDrawerEnabled = theme.settings.cartDrawerEnabled),
                    (this.cartUpdateFailed = !1),
                    this.cartEvents(),
                    this.cartToggleEvents(),
                    this.cartRemoveEvents(),
                    this.cartUpdateEvents(),
                    document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
                    document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
                    document.addEventListener("theme:product:add", this.productAddCallback),
                    document.addEventListener("theme:product:add-error", this.productAddCallback),
                    document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded));
        }
        cartUpdateEvents() {
            (this.items = document.querySelectorAll(Us)),
                this.items.forEach((t) => {
                    t.addEventListener("theme:cart:update", (e) => {
                        this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                    });
                });
        }
        cartRemoveEvents() {
            document.querySelectorAll(qs).forEach((t) => {
                const e = t.closest(Us);
                t.addEventListener("click", (s) => {
                    s.preventDefault(), t.classList.contains(ss) || this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
                });
            }),
                this.cartCloseErrorMessage &&
                    this.cartCloseErrorMessage.addEventListener("click", (t) => {
                        t.preventDefault(), this.cartErrorHolder.classList.remove(hs);
                    });
        }
        cartAddEvent(t) {
            let e = "",
                s = t.detail.button;
            if (s.hasAttribute("disabled")) return;
            const i = s.closest("form");
            i.checkValidity() ? ((e = new FormData(i)), (null !== i && i.querySelector('[type="file"]')) || (t.preventDefault(), this.addToCart(e, s))) : i.reportValidity();
        }
        cartEvents() {
            this.cartTermsCheckbox &&
                (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                this.cartForm.addEventListener("submit", this.formSubmitHandler));
        }
        formSubmitHandler() {
            const t = document.querySelector(Hs).checked,
                e = document.querySelector(ti);
            if (t) e.classList.remove(hs), this.cartCheckoutButton.removeAttribute(si);
            else {
                if (document.querySelector(ti).length > 0) return;
                (e.innerText = theme.strings.cartAcceptanceError), this.cartCheckoutButton.setAttribute(si, !0), e.classList.add(hs);
            }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(Fs);
            null == e ||
                e.addEventListener("click", (e) => {
                    e.preventDefault(), t && t.classList.remove(cs);
                });
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                .then(this.cartErrorsHandler)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const s = e.querySelector(ms);
                    this.build(s);
                })
                .catch((t) => console.log(t));
        }
        addToCart(t, e) {
            this.cart && this.cart.classList.add(ns);
            const s = null == e ? void 0 : e.closest(Ys);
        
            // Get the shipping estimate from the product page
            const pickupAvailability = document.querySelector('.pickup-availability-notification__item');
            let shippingDaysEstimate = '';

            if (pickupAvailability) {
                shippingDaysEstimate = pickupAvailability.getAttribute('data-delivery-days');
            }
    
            // Parse the existing body (assuming 't' is a FormData object or similar)
            const formData = new FormData();
            formData.append('id', t.get('id'));  // The variant ID
            formData.append('quantity', t.get('quantity')); 

            if (shippingDaysEstimate) {
                formData.append('properties[_processing_time]', shippingDaysEstimate);  // Add shipping estimate as line item property
            }
        
            this.cartDrawerEnabled && (e && (e.classList.add(ns), (e.disabled = !0)), s && s.classList.add(cs));
        
            // Make the fetch request with the updated form data
            fetch(theme.routes.cart_add_url, { 
                method: "POST", 
                headers: { 
                    "X-Requested-With": "XMLHttpRequest", 
                    Accept: "application/javascript" 
                }, 
                body: formData  // Use the updated form data here
            })
            .then((t) => t.json())
            .then((t) => {
                if (t.status) {
                    this.addToCartError(t, e);
                    e && (e.classList.remove(ns), (e.disabled = !1));
                    return;
                }
                this.cartDrawerEnabled
                    ? (e && (e.classList.remove(ns), e.classList.add(es), e.dispatchEvent(new CustomEvent("theme:product:add", { detail: { response: t, button: e }, bubbles: !0 }))), this.getCart())
                    : (window.location = theme.routes.cart_url);
            })
            .catch((t) => {
                this.addToCartError(t, e), this.enableCartButtons();
            });
        }
        // addToCart(t, e) {
        //     this.cart && this.cart.classList.add(ns);
        //     const s = null == e ? void 0 : e.closest(Ys);
        //     this.cartDrawerEnabled && (e && (e.classList.add(ns), (e.disabled = !0)), s && s.classList.add(cs)),
        //         fetch(theme.routes.cart_add_url, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" }, body: t })
        //             .then((t) => t.json())
        //             .then((t) => {
        //                 if (t.status) return this.addToCartError(t, e), void (e && (e.classList.remove(ns), (e.disabled = !1)));
        //                 this.cartDrawerEnabled
        //                     ? (e && (e.classList.remove(ns), e.classList.add(es), e.dispatchEvent(new CustomEvent("theme:product:add", { detail: { response: t, button: e }, bubbles: !0 }))), this.getCart())
        //                     : (window.location = theme.routes.cart_url);
        //             })
        //             .catch((t) => {
        //                 this.addToCartError(t, e), this.enableCartButtons();
        //             });
        // }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(ns);
            let s = t.quantity;
            null !== e && (s ? e.classList.add(ns) : e.classList.add(as)), this.disableCartButtons();
            const i = this.cart.querySelector(`[${ri}="${t.id}"]`) || e,
                o = (null == i ? void 0 : i.hasAttribute(ai)) ? parseInt(i.getAttribute(ai)) : 0,
                n = (null == i ? void 0 : i.hasAttribute(li)) ? i.getAttribute(li) : null;
            if (0 === o) return;
            const r = { line: o, quantity: s };
            fetch(theme.routes.cart_change_url, { method: "post", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(r) })
                .then((t) => t.text())
                .then((t) => {
                    if (JSON.parse(t).errors) return (this.cartUpdateFailed = !0), this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), void this.enableCartButtons();
                    this.getCart();
                })
                .catch((t) => {
                    console.log(t), this.enableCartButtons();
                });
        }
        resetLineItem(t) {
            const e = t.querySelector(Gs),
                s = e.getAttribute("value");
            (e.value = s), t.classList.remove(ns);
        }
        disableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${qs}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.add(ss), t.blur(), (t.disabled = !0);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.setAttribute(si, !0);
                    });
        }
        enableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${qs}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.remove(ss), (t.disabled = !1);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.removeAttribute(si);
                    }),
                this.cart.classList.remove(ns);
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(Ds).innerText = t;
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(hs, this.cartUpdateFailed), (this.cartUpdateFailed = !1));
        }
        cartErrorsHandler(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Ie({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        addToCartError(t, e) {
            var s;
            if ((this.cartDrawerEnabled && this.closeCartDrawer(), null !== e)) {
                const s = e.closest(Xs) || e.closest(Ys) || e.closest(Qs);
                let i = null == s ? void 0 : s.querySelector(Os);
                const o = e.closest(Ys);
                o && o.querySelector(Os) && (i = o.querySelector(Os)),
                    i &&
                        ((i.innerHTML = `<div class="errors">${t.message}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
                        i.classList.add(cs),
                        this.formErrorsEvents(i)),
                    e.dispatchEvent(new CustomEvent("theme:product:add-error", { detail: { response: t, button: e }, bubbles: !0 }));
            }
            const i = null == e ? void 0 : e.closest(Ys);
            i && i.dispatchEvent(new CustomEvent("theme:cart:error", { bubbles: !0, detail: { message: t.message, description: t.description, holder: i } })), null === (s = this.cart) || void 0 === s || s.classList.remove(ns);
        }
        productAddCallback(t) {
            let e = [],
                s = null;
            const i = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(Ss);
            e.push(o),
                (s = o.closest(Ys)),
                n && e.push(n),
                e.forEach((t) => {
                    t.classList.remove(ns), i || t.classList.add(es);
                }),
                setTimeout(() => {
                    e.forEach((t) => {
                        var e, s;
                        t.classList.remove(es);
                        (null === (e = t.closest($s)) || void 0 === e ? void 0 : e.classList.contains(us)) || (null === (s = t.closest($s)) || void 0 === s ? void 0 : s.classList.contains(ps)) || (t.disabled = !1);
                    }),
                        null == s || s.classList.remove(cs);
                }, 1e3);
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen ? this.showAnimatedItems() : this.openCartDrawer();
        }
        openCartDrawer() {
            this.cartDrawer &&
                ((this.cartDrawerIsOpen = !0),
                (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                this.cartDrawer.classList.add(rs),
                this.observeAdditionalCheckoutButtons(),
                setTimeout(this.showAnimatedItems),
                this.accessibility.trapFocus(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(As) }));
        }
        closeCartDrawer() {
            this.cartDrawer &&
                this.cartDrawer.classList.contains(rs) &&
                ((this.cartDrawerIsOpen = !1),
                document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
                this.resetAnimatedItems(),
                this.itemsHolder.classList.remove(ds),
                this.cartEmpty.classList.remove(ds),
                this.cartErrorHolder.classList.remove(hs),
                this.cartDrawer.querySelectorAll(ys).forEach((t) => {
                    const e = () => {
                        t.classList.remove(os), t.removeEventListener("animationend", e);
                    };
                    t.classList.add(os), t.addEventListener("animationend", e);
                }),
                this.cartDrawer.classList.remove(rs),
                this.accessibility.removeTrapFocus(),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
        }
        cartToggleEvents() {
            this.cartDrawer &&
                (this.cartDrawerClose.addEventListener("click", (t) => {
                    t.preventDefault(), this.closeCartDrawer();
                }),
                this.cartDrawer.addEventListener("keyup", (t) => {
                    "Escape" === t.code && this.closeCartDrawer();
                }));
        }
        onBodyClick(t) {
            t.target.hasAttribute(ii) && this.closeCartDrawer();
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cartEmpty.classList.toggle(is, t), this.buttonHolder.classList.toggle(is, !t), this.itemsHolder.classList.toggle(is, !t);
        }
        build(t) {
            const e = t.querySelector(vs),
                i = t.querySelector(gs),
                o = Boolean(null === e && null === i),
                n = t.querySelector(fs),
                r = t.querySelector(Bs);
            this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
                o
                    ? ((this.itemsHolder.innerHTML = t), (this.upsellProductsHolder.innerHTML = ""))
                    : ((this.itemsHolder.innerHTML = e.innerHTML), (this.upsellProductsHolder.innerHTML = i.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()),
                (this.newTotalItems = e && e.querySelectorAll(Us).length ? e.querySelectorAll(Us).length : 0),
                (this.subtotal = r && r.hasAttribute(ei) ? parseInt(r.getAttribute(ei)) : 0),
                (this.cartCount = this.getCartItemCount()),
                document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: !0, detail: { cartCount: this.cartCount } })),
                (this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : s.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                this.cart.classList.remove(ns),
                this.totalItems !== this.newTotalItems && ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                this.cartDrawerIsOpen && this.itemsHolder.classList.add(ds),
                this.hasItemsInCart() ||
                    this.cartEmpty.querySelectorAll(ys).forEach((t) => {
                        t.classList.remove(ts);
                    }),
                this.freeShippingMessageHandle(this.subtotal),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                this.toggleErrorMessage(),
                this.enableCartButtons(),
                this.updateProgress(),
                document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: !0 })),
                this.cartDrawer || this.showAnimatedItems();
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Gs)).reduce((t, e) => t + parseInt(e.value), 0);
        }
        hasItemsInCart() {
            return this.totalItems > 0;
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length &&
                this.freeShipping.forEach((e) => {
                    const s = e.hasAttribute(oi) && "true" === e.getAttribute(oi) && t >= 0;
                    e.classList.toggle(ls, s && t >= this.freeShippingLimit);
                });
        }
        updateProgress() {
            if (((this.freeShipping = document.querySelectorAll(_s)), !this.freeShipping.length)) return;
            const t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                e = Math.min(100 * t, 100),
                i = this.circumference - ((e / 100) * this.circumference) / 2,
                o = s.formatMoney(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((t) => {
                const s = t.querySelector(Ns),
                    n = t.querySelector(Rs),
                    r = t.querySelector(Vs);
                r && (r.innerHTML = o.replace(".00", "")), s && (s.value = e), n && n.style.setProperty("--stroke-dashoffset", `${i}`);
            });
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(Es);
            t.length &&
                t.forEach((t) => {
                    t.addEventListener("click", (e) => {
                        e.preventDefault();
                        const s = t.closest(Ys).getAttribute(ci);
                        this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s),
                            window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray),
                            this.removeUpsellProduct(s),
                            this.toggleCartUpsellWidgetVisibility();
                    });
                });
        }
        checkSkippedUpsellProductsFromStorage() {
            const t = window.sessionStorage.getItem("skip_upsell_products");
            if (!t) return;
            t.split(",").forEach((t) => {
                this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t), this.removeUpsellProduct(t);
            });
        }
        removeUpsellProduct(t) {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelector(`[${ci}="${t}"]`);
            e && e.parentNode.remove();
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(Ys),
                e = this.upsellProductsHolder.closest(Zs);
            e && e.classList.toggle(is, !t.length);
        }
        observeAdditionalCheckoutButtons() {
            const t = this.cartDrawer.querySelector(bs);
            if (t) {
                const e = new MutationObserver(() => {
                    this.accessibility.trapFocus(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(As) }), e.disconnect();
                });
                e.observe(t, { subtree: !0, childList: !0 });
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(ys).forEach((t) => {
                t.classList.remove(ts), t.classList.remove(os);
            });
        }
        showAnimatedItems() {
            requestAnimationFrame(this.animateItems);
        }
        animateItems() {
            this.cart.querySelectorAll(ys).forEach((t) => {
                t.classList.add(ts);
            });
        }
        constructor() {
            window.location.pathname.endsWith("/password") || this.init();
        }
    })()),
        customElements.get("shipping-calculator") || customElements.define("shipping-calculator", Ke);
    const hi = "is-focused",
        di = "[data-skip-content]",
        ui = 'a[href="#"]';
    window.accessibility = new (class {
        init() {
            (this.a11y = U),
                (this.html = document.documentElement),
                (this.body = document.body),
                (this.inPageLink = document.querySelector(di)),
                (this.linkesWithOnlyHash = document.querySelectorAll(ui)),
                this.a11y.focusHash(),
                this.a11y.bindInPageLinks(),
                this.clickEvents(),
                this.focusEvents();
        }
        clickEvents() {
            this.inPageLink &&
                this.inPageLink.addEventListener("click", (t) => {
                    t.preventDefault();
                }),
                this.linkesWithOnlyHash &&
                    this.linkesWithOnlyHash.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                        });
                    });
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(hi);
            }),
                document.addEventListener("keyup", (t) => {
                    "Tab" === t.code && this.body.classList.add(hi);
                });
        }
        constructor() {
            this.init();
        }
    })();
    const pi = 'input[type="search"]';
    customElements.define(
        "main-search",
        class extends J {
            setupEventListeners() {
                let t = [];
                this.allSearchInputs.forEach((e) => t.push(e.form)),
                    this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                    t.length < 2 || (t.forEach((t) => t.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach((t) => t.addEventListener("input", this.onInput.bind(this))));
            }
            onFormReset(t) {
                super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input);
            }
            onInput(t) {
                const e = t.target;
                this.keepInSync(e.value, e);
            }
            onInputFocus() {
                E() || this.scrollIntoView({ behavior: "smooth" });
            }
            keepInSync(t, e) {
                this.allSearchInputs.forEach((s) => {
                    s !== e && (s.value = t);
                });
            }
            constructor() {
                super(), (this.allSearchInputs = document.querySelectorAll(pi)), this.setupEventListeners();
            }
        }
    );
    const mi = "details",
        vi = "[data-popdown]",
        gi = "[data-popdown-close]",
        fi = "[data-popdown-toggle]",
        yi = 'input:not([type="hidden"])',
        bi = "data-popdown-underlay";
    let wi = class extends HTMLElement {
        connectedCallback() {
            this.popdownContainer.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
                this.popdownClose.addEventListener("click", this.close.bind(this)),
                this.popdownToggle.addEventListener("click", this.onPopdownToggleClick.bind(this)),
                this.popdownToggle.setAttribute("role", "button"),
                this.popdown.addEventListener("transitionend", (t) => {
                    "visibility" == t.propertyName && this.popdownContainer.hasAttribute("open") && "false" == this.popdownContainer.getAttribute("open") && this.popdownContainer.removeAttribute("open");
                });
        }
        onPopdownToggleClick(t) {
            t.preventDefault(), t.target.closest(mi).hasAttribute("open") ? this.close() : this.open(t);
        }
        onBodyClick(t) {
            (this.contains(t.target) && !t.target.hasAttribute(bi)) || this.close();
        }
        open(t) {
            (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                t.target.closest(mi).setAttribute("open", ""),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                requestAnimationFrame(() => {
                    t.target.closest(mi).setAttribute("open", "true"), this.a11y.trapFocus(this.popdown, { elementToFocus: this.popdown.querySelector(yi) });
                });
        }
        close() {
            this.a11y.removeTrapFocus(),
                this.popdownContainer.setAttribute("open", "false"),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        constructor() {
            super(), (this.popdown = this.querySelector(vi)), (this.popdownContainer = this.querySelector(mi)), (this.popdownToggle = this.querySelector(fi)), (this.popdownClose = this.querySelector(gi)), (this.a11y = U);
        }
    };
    customElements.define("header-search-popdown", wi);
    const Ei = "[data-collapsible]",
        Si = "[data-collapsible-trigger]",
        Li = "[data-collapsible-body]",
        ki = "[data-collapsible-content]",
        Ai = "open",
        Ti = "single";
    let Ci = class extends HTMLElement {
        connectedCallback() {
            this.collapsibles.forEach((t) => {
                const e = t.querySelector(Si),
                    s = t.querySelector(Li);
                e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
                    s.addEventListener("transitionend", (e) => {
                        e.target === s && ("true" == t.getAttribute(Ai) && this.setBodyHeight(s, "auto"), "false" == t.getAttribute(Ai) && (t.removeAttribute(Ai), this.setBodyHeight(s, "")));
                    });
            });
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector(Li),
                s = t.querySelector(ki);
            t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector(Li),
                s = t.querySelector(ki);
            this.setBodyHeight(e, s.offsetHeight),
                t.setAttribute("open", !1),
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.setBodyHeight(e, 0);
                    });
                });
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = (t.target.matches(Si) ? t.target : t.target.closest(Si)).closest(Ei);
            this.single &&
                this.collapsibles.forEach((t) => {
                    t.hasAttribute(Ai) &&
                        t != e &&
                        requestAnimationFrame(() => {
                            this.close(t);
                        });
                }),
                e.hasAttribute(Ai) ? this.close(e) : this.open(e),
                e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } }));
        }
        constructor() {
            super(), (this.collapsibles = this.querySelectorAll(Ei)), (this.single = this.hasAttribute(Ti));
        }
    };
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", Ci);
    const qi = ".template-addresses",
        xi = "#AddressNewForm",
        Mi = ".address-new-toggle",
        Hi = ".address-edit-toggle",
        Pi = ".address-delete",
        Ii = "data-form-id",
        Bi = "data-confirm-message",
        Di = "#EditAddress",
        Fi = "AddressCountryNew",
        Oi = "AddressProvinceNew",
        $i = "AddressProvinceContainerNew",
        _i = ".address-country-option",
        Ri = "AddressCountry",
        Ni = "AddressProvince",
        zi = "AddressProvinceContainer",
        Ui = "hidden";
    const Wi = document.querySelector(qi);
    Wi &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm;
                    this.customerAddresses();
                    const s = t.querySelectorAll(Mi);
                    s.length &&
                        s.forEach((t) => {
                            t.addEventListener("click", function () {
                                e.classList.toggle(Ui);
                            });
                        });
                    const i = t.querySelectorAll(Hi);
                    i.length &&
                        i.forEach((e) => {
                            e.addEventListener("click", function () {
                                const e = this.getAttribute(Ii);
                                t.querySelector(`${Di}_${e}`).classList.toggle(Ui);
                            });
                        });
                    const o = t.querySelectorAll(Pi);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function () {
                                const t = this.getAttribute(Ii),
                                    e = this.getAttribute(Bi);
                                confirm(e) && Shopify.postLink(window.theme.routes.addresses_url + "/" + t, { parameters: { _method: "delete" } });
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(Fi, Oi, { hideElement: $i }),
                    this.section.querySelectorAll(_i).forEach((t) => {
                        const e = t.getAttribute(Ii),
                            s = `${Ri}_${e}`,
                            i = `${Ni}_${e}`,
                            o = `${zi}_${e}`;
                        new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
                    });
            }
            constructor(t) {
                (this.section = t), (this.addressNewForm = this.section.querySelector(xi)), this.init();
            }
        })(Wi);
    const Vi = ".customer-logged-in",
        ji = ".account",
        Xi = ".account-sidebar--mobile";
    const Ji = document.querySelector(Vi);
    Ji &&
        new (class {
            init() {
                this.section.querySelector(ji) && this.accountMobileSidebar();
            }
            accountMobileSidebar() {
                this.section.querySelector(Xi) &&
                    this.section.querySelector(Xi).addEventListener("click", function () {
                        const t = this.nextElementSibling;
                        t && "UL" === t.tagName && t.classList.toggle("visible");
                    });
            }
            constructor(t) {
                (this.section = t), this.init();
            }
        })(Ji);
    const Yi = "[data-account-form]",
        Qi = "[data-show-reset]",
        Gi = "[data-hide-reset]",
        Ki = "[data-recover-password]",
        Zi = "[data-recover-success]",
        to = "[data-login-form]",
        eo = "#recover",
        so = "is-hidden";
    const io = document.querySelector(Yi);
    io &&
        new (class {
            init() {
                window.location.hash == eo || this.recoverSuccess ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                    this.showButton.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), this.showRecoverPasswordForm();
                        }.bind(this),
                        !1
                    ),
                    this.hideButton.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), this.hideRecoverPasswordForm();
                        }.bind(this),
                        !1
                    );
            }
            showRecoverPasswordForm() {
                return this.login.classList.add(so), this.recover.classList.remove(so), (window.location.hash = eo), !1;
            }
            hideRecoverPasswordForm() {
                return this.recover.classList.add(so), this.login.classList.remove(so), (window.location.hash = ""), !1;
            }
            constructor(t) {
                (this.form = t),
                    (this.showButton = t.querySelector(Qi)),
                    (this.hideButton = t.querySelector(Gi)),
                    (this.recover = t.querySelector(Ki)),
                    (this.recoverSuccess = t.querySelector(Zi)),
                    (this.login = t.querySelector(to)),
                    this.init();
            }
        })(io),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const oo = window.Shopify.theme.sections.registered,
        no = window.Shopify.theme.sections.instances,
        ro = "data-section-id",
        ao = "data-section-type";
    let lo = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t) => {
                const s = { id: this.id, type: this.type, container: this.container };
                e ? t.call(s, e) : t.call(s);
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(t) {
            this.callFunctions("onSelect", t);
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t);
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t);
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t);
        }
        onReorder(t) {
            this.callFunctions("onReorder", t);
        }
        constructor(t, e) {
            (this.container = (function (t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(ro)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + ro + " attribute.");
                return t;
            })(t)),
                (this.id = t.getAttribute(ro)),
                (this.type = e.type),
                (this.callStack = e.getStack());
            try {
                this.onLoad();
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
            }
        }
    };
    function co(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== oo[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const s = new (class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, s] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof s ? t.push(s) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(s));
                        }
                    });
            }
        })(t, e);
        return (oo[t] = s), oo;
    }
    function ho(t, e) {
        (t = mo(t)),
            void 0 === e && (e = document.querySelectorAll("[" + ao + "]")),
            (e = vo(e)),
            t.forEach(function (t) {
                const s = oo[t];
                void 0 !== s &&
                    (e = e.filter(function (e) {
                        return !(uo(e).length > 0) && null !== e.getAttribute(ao) && (e.getAttribute(ao) !== t || (no.push(new lo(e, s)), !1));
                    }));
            });
    }
    function uo(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
        if (t instanceof Element || s instanceof Element)
            vo(t).forEach(function (t) {
                e = e.concat(
                    no.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof s) {
            mo(t).forEach(function (t) {
                e = e.concat(
                    no.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function po(t) {
        for (var e, s = 0; s < no.length; s++)
            if (no[s].id === t) {
                e = no[s];
                break;
            }
        return e;
    }
    function mo(t) {
        return (
            "*" === t
                ? (t = Object.keys(oo))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === lo
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === lo &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function vo(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                s = t.target.querySelector("[" + ro + '="' + e + '"]');
            null !== s && ho(s.getAttribute(ao), s);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                s = t.target.querySelector("[" + ro + '="' + e + '"]');
            "object" == typeof uo(s)[0] &&
                uo(s).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                s = t.target.querySelector("[" + ro + '="' + e + '"]');
            "object" == typeof uo(s)[0] &&
                uo(s).forEach(function (t) {
                    var e = no
                        .map(function (t) {
                            return t.id;
                        })
                        .indexOf(t.id);
                    no.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = po(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = po(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = po(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = po(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const go = "data-tooltip",
        fo = "data-tooltip-stop-mouseenter",
        yo = "tooltip-default",
        bo = "is-visible",
        wo = "is-hiding";
    let Eo = {},
        So = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        e = document.createElement("div");
                    (e.className = this.class), (e.innerHTML = t), document.body.appendChild(e);
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                    document.addEventListener("theme:tooltip:close", this.removePinEvent);
            }
            addPin(t = !1) {
                const e = document.querySelector(`.${this.class}`);
                if (e && ((t && !this.tooltip.hasAttribute(fo)) || !t)) {
                    const t = e.querySelector(`.${this.class}__arrow`),
                        s = e.querySelector(`.${this.class}__inner`);
                    e.querySelector(`.${this.class}__text`).textContent = this.label;
                    const i = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        n = o.top,
                        r = o.width,
                        a = n + o.height + window.scrollY;
                    let l = o.left - i / 2 + r / 2;
                    const c = l + i - b();
                    c > 0 && (l -= c),
                        l < 0 && (l = 0),
                        (t.style.left = `${o.left + r / 2}px`),
                        e.style.setProperty("--tooltip-top", `${a}px`),
                        (s.style.transform = `translateX(${l}px)`),
                        e.classList.remove(wo),
                        e.classList.add(bo),
                        document.addEventListener("theme:scroll", this.removePinEvent);
                }
            }
            removePin(t, e = !1, s = !1) {
                const i = document.querySelector(`.${this.class}`),
                    o = i.classList.contains(bo);
                i &&
                    ((e && !this.tooltip.hasAttribute(fo)) || !e) &&
                    (o &&
                        (s || t.detail.hideTransition) &&
                        (i.classList.add(wo),
                        this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                        (this.hideTransitionTimeout = setTimeout(() => {
                            i.classList.remove(wo);
                        }, this.transitionSpeed))),
                    i.classList.remove(bo),
                    document.removeEventListener("theme:scroll", this.removePinEvent));
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                    document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                    document.removeEventListener("theme:scroll", this.removePinEvent);
            }
            constructor(t, e = {}) {
                (this.tooltip = t),
                    this.tooltip.hasAttribute(go) &&
                        ((this.label = this.tooltip.getAttribute(go)),
                        (this.class = e.class || yo),
                        (this.transitionSpeed = e.transitionSpeed || 200),
                        (this.hideTransitionTimeout = 0),
                        (this.addPinEvent = () => this.addPin()),
                        (this.addPinMouseEvent = () => this.addPin(!0)),
                        (this.removePinEvent = (t) => Ze(this.removePin(t), 50)),
                        (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                        this.init());
            }
        };
    const Lo = {
        onLoad() {
            Eo[this.id] = [];
            this.container.querySelectorAll(`[${go}]`).forEach((t) => {
                Eo[this.id].push(new So(t));
            });
        },
        onUnload: function () {
            Eo[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    };
    var ko = {};
    const Ao = {
        onLoad() {
            ko[this.id] = [];
            this.container.querySelectorAll("[data-parallax-wrapper]").forEach((t) => {
                const e = t.querySelector("[data-parallax-img]");
                ko[this.id].push(new i(e, { center: !0, round: !0, frame: t }));
            }),
                window.addEventListener("load", () => {
                    ko[this.id].forEach((t) => {
                        "function" == typeof t.refresh && t.refresh();
                    });
                });
        },
        onUnload: function () {
            ko[this.id].forEach((t) => {
                "function" == typeof t.destroy && t.destroy();
            });
        },
    };
    co("article", [Lo, Ao]);
    const To = "[data-aos]",
        Co = ".collection-item__image",
        qo = "[data-column-image]",
        xo = ".flickity-button.next",
        Mo = ".flickity-button.previous",
        Ho = "a:not(.btn)",
        Po = ".product-item__image",
        Io = "[data-slide]",
        Bo = "data-slide",
        Do = "[data-slider]",
        Fo = "[data-slider-thumb]",
        Oo = { arrowPositionMiddle: "data-arrow-position-middle", slideIndex: "data-slide-index", sliderOptions: "data-options", slideTextColor: "data-slide-text-color" },
        $o = "aos-animate",
        _o = "desktop",
        Ro = "is-focused",
        No = "flickity-resize",
        zo = "flickity-resizing",
        Uo = "flickity-enabled",
        Wo = "is-initialized",
        Vo = "is-loading",
        jo = "is-selected",
        Xo = "mobile",
        Jo = "single-slide",
        Yo = "js-slider--initialized",
        Qo = {};
    let Go = class {
        init() {
            this.slideshow.classList.add(Vo);
            let t = Io;
            const e = E(),
                s = `${Io}:not(.${Xo})`,
                i = `${Io}:not(.${_o})`;
            (this.slideshow.querySelectorAll(i).length || this.slideshow.querySelectorAll(s).length) && (t = e ? s : i),
                this.slideshow.querySelectorAll(t).length <= 1 && (this.slideshow.classList.add(Jo), this.slideshow.classList.remove(Vo)),
                (this.sliderOptions = {
                    cellSelector: t,
                    contain: !0,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                    ...this.customOptions,
                    on: {
                        ready: () => {
                            requestAnimationFrame(() => {
                                this.slideshow.classList.add(Wo), this.slideshow.classList.remove(Vo), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", { bubbles: !0, detail: { slider: this } }));
                            }),
                                this.slideActions(),
                                this.sliderOptions.prevNextButtons && this.positionArrows();
                        },
                        change: (t) => {
                            const e = this.slideshowSlides[t];
                            if (!e || this.sliderOptions.groupCells) return;
                            const s = e.querySelectorAll(To);
                            s.length &&
                                s.forEach((t) => {
                                    t.classList.remove($o),
                                        requestAnimationFrame(() => {
                                            setTimeout(() => {
                                                t.classList.add($o);
                                            }, 0);
                                        });
                                });
                        },
                        resize: () => {
                            this.sliderOptions.prevNextButtons && this.positionArrows();
                        },
                    },
                }),
                this.sliderOptions.fade && (this.flkty = new n(this.slideshow, this.sliderOptions)),
                this.sliderOptions.fade || (this.flkty = new o(this.slideshow, this.sliderOptions)),
                this.isHeightEqualized && this.equalizeHeight(),
                this.flkty.on("change", () => this.slideActions(!0)),
                this.sliderThumbs.length &&
                    this.sliderThumbs.forEach((t) => {
                        t.addEventListener("click", (e) => {
                            e.preventDefault();
                            const s = [...t.parentElement.children].indexOf(t);
                            this.flkty.select(s);
                        });
                    }),
                (this.flkty && this.flkty.isActive) || this.slideshow.classList.remove(Vo);
        }
        resetSlider() {
            this.slideshow && (this.flkty && this.flkty.isActive ? this.flkty.select(0, !1, !0) : this.slideshow.scrollTo({ left: 0, behavior: "auto" }));
        }
        slideActions(t = !1) {
            const e = this.slideshow.querySelector(`.${jo}`),
                s = e.getAttribute(Oo.slideTextColor),
                i = e.querySelector(Ho),
                o = this.slideshow.querySelectorAll(`${Io} a, ${Io} button`);
            if (
                (document.body.classList.contains(Ro) && i && this.sliderOptions.groupCells && t && i.focus(),
                o.length &&
                    o.forEach((t) => {
                        const e = t.closest(Io);
                        if (e) {
                            const s = e.classList.contains(jo) ? 0 : -1;
                            t.setAttribute("tabindex", s);
                        }
                    }),
                "rgba(0,0,0,0)" !== s && "" !== s && this.slideshow.style.setProperty("--text", s),
                this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && e.hasAttribute(Oo.slideIndex))
            ) {
                const t = parseInt(e.getAttribute(Oo.slideIndex)),
                    s = this.container.querySelector(`${Fo}.${jo}`);
                s && s.classList.remove(jo), this.sliderThumbs[t].classList.add(jo);
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(Oo.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                const t = this.slideshow.querySelector(Co) || this.slideshow.querySelector(Po) || this.slideshow.querySelector(qo);
                if (!t) return;
                (this.slideshow.querySelector(Mo).style.top = t.clientHeight / 2 + "px"), (this.slideshow.querySelector(xo).style.top = t.clientHeight / 2 + "px");
            }
        }
        equalizeHeight() {
            (o.prototype._createResizeClass = function () {
                requestAnimationFrame(() => {
                    this.element.classList.add(No);
                });
            }),
                this.flkty._createResizeClass();
            const t = o.prototype.resize;
            o.prototype.resize = function () {
                this.element.classList.remove(No),
                    this.element.classList.add(zo),
                    t.call(this),
                    requestAnimationFrame(() => {
                        this.element.classList.remove(zo), this.element.classList.add(No);
                    });
            };
        }
        onUnload() {
            this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
        }
        onBlockSelect(t) {
            if (!this.slideshow) return;
            const e = this.slideshow.querySelector(`[${Bo}="${t.detail.blockId}"]`);
            if (!e) return;
            let s = parseInt(e.getAttribute(Oo.slideIndex));
            this.multipleSlides && !this.slideshow.classList.contains(Yo) && (s = 0), this.slideshow.classList.add(jo), this.flkty && this.slideshow.classList.contains(Uo) && (this.flkty.selectCell(s), this.flkty.stopPlayer());
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove(jo), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer());
        }
        constructor(t, e = null) {
            (this.container = t),
                (this.slideshow = e || this.container.querySelector(Do)),
                this.slideshow &&
                    ((this.slideshowSlides = this.slideshow.querySelectorAll(Io)),
                    this.slideshowSlides.length <= 1 ||
                        ((this.sliderThumbs = this.container.querySelectorAll(Fo)),
                        (this.multipleSlides = this.slideshow.hasAttribute(Oo.slidesLargeDesktop)),
                        (this.isHeightEqualized = "true" === this.slideshow.getAttribute(Oo.equalizeHeight)),
                        this.slideshow.hasAttribute(Oo.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(Oo.sliderOptions)))),
                        (this.flkty = null),
                        this.init()));
        }
    };
    const Ko = {
        onLoad() {
            Qo[this.id] = [];
            this.container.querySelectorAll(Do).forEach((t) => {
                Qo[this.id].push(new Go(this.container, t));
            });
        },
        onUnload() {
            Qo[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            Qo[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            Qo[this.id].forEach((e) => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
            });
        },
    };
    co("blog-section", [Ko]), co("hero", Ao), co("double", Ko);
    const Zo = (t) => {
        let { stickyHeaderHeight: e } = c();
        window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
    };
    let tn = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        constructor(t, e, s = 7) {
            const i = new Date(),
                o = new Date();
            o.setTime(i.getTime() + 864e5 * s), (this.configuration = { expires: o.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 }), (this.name = t), (this.value = e);
        }
    };
    const en = "[data-newsletter-form]",
        sn = "[data-newsletter-heading]",
        on = "[data-newsletter]",
        nn = "has-success",
        rn = "has-error",
        an = "hidden",
        ln = "data-cookie-name",
        cn = {};
    const hn = {
        onLoad() {
            cn[this.id] = [];
            this.container.querySelectorAll(en).forEach((t) => {
                cn[this.id].push(
                    new (class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                        }
                        checkForChallengePage() {
                            this.isChallengePage = "/challenge" === window.location.pathname;
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem("newsletter_form_id");
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem("newsletter_form_id");
                        }
                        showMessage() {
                            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                const t = document.getElementById(this.formID),
                                    e = t.parentElement.querySelector(sn),
                                    s = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                    i = -1 !== window.location.search.indexOf("accepts_marketing");
                                s
                                    ? (t.classList.remove(rn), t.classList.add(nn), e && (e.classList.add(an), t.classList.remove(an)), this.popup && this.cookie.write())
                                    : i && (t.classList.remove(nn), t.classList.add(rn), e && (e.classList.add(an), t.classList.remove(an))),
                                    (s || i) &&
                                        window.addEventListener("load", () => {
                                            this.scrollToForm(t);
                                        });
                            }
                        }
                        scrollToForm(t) {
                            const e = t.getBoundingClientRect();
                            (e.top >= 0 && e.left >= 0 && e.bottom <= w() && e.right <= b()) ||
                                setTimeout(() => {
                                    Zo(t.getBoundingClientRect().top);
                                }, 500);
                        }
                        unload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                        }
                        constructor(t) {
                            (this.sessionStorage = window.sessionStorage),
                                (this.newsletter = t),
                                (this.popup = this.newsletter.closest(on)),
                                this.popup && (this.cookie = new tn(this.popup.getAttribute(ln), "user_has_closed", null)),
                                (this.stopSubmit = !0),
                                (this.isChallengePage = !1),
                                (this.formID = null),
                                this.checkForChallengePage(),
                                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                this.isChallengePage || this.init();
                        }
                    })(t)
                );
            });
        },
        onUnload() {
            cn[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    };
    co("footer", [Ao, hn]);
    const dn = "[data-section-type]",
        un = "[data-collection-sidebar]",
        pn = "[data-collection-sidebar-slide-out]",
        mn = "[data-collection-filters-form]",
        vn = "input",
        gn = "select",
        fn = "label",
        yn = "textarea",
        bn = "[data-field-price-min]",
        wn = "[data-field-price-max]",
        En = "data-field-price-min",
        Sn = "data-field-price-max",
        Ln = "[data-se-min-value]",
        kn = "[data-se-max-value]",
        An = "data-se-min-value",
        Tn = "data-se-max-value",
        Cn = "data-se-min",
        qn = "data-se-max",
        xn = "[data-products-grid]",
        Mn = "[data-filter-update-url]",
        Hn = "[data-active-filters]",
        Pn = "data-active-filters-count",
        In = "data-sort-enabled",
        Bn = "[data-collection-nav]",
        Dn = "[data-show-more]",
        Fn = "[data-link-hidden]",
        On = "hidden",
        $n = "is-loading",
        _n = "is-focused";
    let Rn = class extends HTMLElement {
        connectedCallback() {
            this.form && (this.sidebar.addEventListener("input", this.updatePriceEvent), this.sidebar.addEventListener("theme:range:update", this.updateRangeEvent)),
                this.sidebar && this.sidebar.addEventListener("click", this.filterUpdateFromUrlEvent),
                this.productsContainer && this.productsContainer.addEventListener("click", this.filterUpdateFromUrlEvent),
                this.sort && this.container.addEventListener("theme:filter:sort-update", this.submitFormEvent),
                (this.sidebar || this.sort) && window.addEventListener("popstate", this.submitFormEvent),
                this.showMoreOptions.length &&
                    this.showMoreOptions.forEach((t) => {
                        t.addEventListener("click", this.showMoreEvent);
                    });
        }
        showMore(t) {
            t.preventDefault(),
                t.target.parentElement.classList.add(On),
                t.target.parentElement.previousElementSibling.querySelectorAll(Fn).forEach((t, e) => {
                    t.classList.remove(On);
                    const s = t.querySelector(vn);
                    0 === e && document.body.classList.contains(_n) && s && (this.collectionSidebarSlideOut || S() ? (this.accessibility.removeTrapFocus(), this.accessibility.trapFocus(this.sidebar, { elementToFocus: s })) : s.focus());
                });
        }
        updatePrice(t) {
            const e = t.type,
                s = t.target;
            if ((e === vn || e === gn || e === fn || e === yn) && this.form && "function" == typeof this.form.submit) {
                const e = this.form.querySelector(bn),
                    i = this.form.querySelector(wn);
                e && i && (s.hasAttribute(En) && !i.value ? (i.value = i.placeholder) : s.hasAttribute(Sn) && !e.value && (e.value = e.placeholder)), this.submitForm(t);
            }
        }
        filterUpdateFromUrl(t) {
            const e = t.target;
            if (e.matches(Mn) || (e.closest(Mn) && e)) {
                t.preventDefault();
                const s = e.matches(Mn) ? e : e.closest(Mn);
                this.submitForm(t, s.getAttribute("href"));
            }
        }
        submitForm(t, e = "") {
            this.sort = this.container.querySelector(`[${In}]`);
            const s = this.sort ? this.sort.getAttribute(In) : "";
            if (!t || (t && "popstate" !== t.type))
                if ("" === e) {
                    let e = new window.URL(window.location.href).searchParams;
                    const i = e,
                        o = Object.fromEntries(i),
                        n = e.toString();
                    if (n.includes("filter.") || n.includes("page=")) for (const t in o) (t.includes("filter.") || "page" === t) && e.delete(t);
                    if (this.form) {
                        const t = new FormData(this.form),
                            s = new URLSearchParams(t),
                            i = this.form.querySelector(Ln),
                            o = this.form.querySelector(kn),
                            n = i && i.hasAttribute(Cn) ? i.getAttribute(Cn) : "",
                            r = o && o.hasAttribute(qn) ? o.getAttribute(qn) : "";
                        let a = 0;
                        for (let [t, i] of s.entries()) t.includes("filter.") && i && (e.append(t, i), ((i === n && "filter.v.price.gte" === t) || (i === r && "filter.v.price.lte" === t)) && (a += 1));
                        2 === a && (e.delete("filter.v.price.gte"), e.delete("filter.v.price.lte"));
                    }
                    if (s || (t && t.detail && t.detail.href)) {
                        const i = s || t.detail.href;
                        e.set("sort_by", i);
                    }
                    const r = e.toString(),
                        a = r ? `?${r}` : location.pathname;
                    window.history.pushState(null, "", a);
                } else window.history.pushState(null, "", e);
            else this.sort && this.sort.dispatchEvent(new CustomEvent("theme:filter:sort", { bubbles: !1 }));
            this.productsContainer &&
                (this.productsContainer.classList.add($n),
                fetch(`${window.location.pathname}${window.location.search}`)
                    .then((t) => t.text())
                    .then((t) => {
                        if (((this.productsContainer.innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(xn).innerHTML), this.sidebar)) {
                            this.sidebar.innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(un).innerHTML;
                            const e = this.sidebar.querySelector(`[${Pn}]`),
                                s = this.container.querySelectorAll(Hn);
                            if (e && s.length) {
                                const t = parseInt(e.getAttribute(Pn));
                                s.forEach((e) => {
                                    (e.textContent = t), e.classList.toggle(On, t < 1);
                                });
                            }
                            this.sidebar.dispatchEvent(new CustomEvent("theme:filter:update", { bubbles: !0 }));
                        }
                        this.collectionNav && Zo(this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight),
                            setTimeout(() => {
                                this.productsContainer.classList.remove($n);
                            }, 500);
                    })
                    .catch((t) => {
                        console.log(t);
                    }));
        }
        updateRange(t) {
            if (this.form && "function" == typeof this.form.submit) {
                const e = this.form.querySelector(Ln),
                    s = this.form.querySelector(kn),
                    i = this.form.querySelector(bn),
                    o = this.form.querySelector(wn);
                if (e && s && i && o && e.hasAttribute(An) && s.hasAttribute(Tn)) {
                    const n = parseInt(i.placeholder),
                        r = parseInt(o.placeholder),
                        a = parseInt(e.getAttribute(An)),
                        l = parseInt(s.getAttribute(Tn));
                    (n === a && r === l) || ((i.value = a), (o.value = l), this.submitForm(t));
                }
            }
        }
        disconnectedCallback() {
            this.form && (this.sidebar.removeEventListener("input", this.updatePriceEvent), this.sidebar.removeEventListener("theme:range:update", this.updateRangeEvent)),
                this.sidebar && this.sidebar.removeEventListener("click", this.filterUpdateFromUrlEvent),
                this.productsContainer && this.productsContainer.removeEventListener("click", this.filterUpdateFromUrlEvent),
                this.sort && this.container.removeEventListener("theme:filter:sort-update", this.submitFormEvent),
                (this.sidebar || this.sort) && window.removeEventListener("popstate", this.submitFormEvent),
                this.showMoreOptions.length &&
                    this.showMoreOptions.forEach((t) => {
                        t.removeEventListener("click", this.showMoreEvent);
                    });
        }
        constructor() {
            super(),
                (this.container = this.closest(dn)),
                (this.sidebar = this.container.querySelector(un)),
                (this.collectionSidebarSlideOut = this.container.querySelector(pn)),
                (this.sort = this.container.querySelector(`[${In}]`)),
                (this.productsContainer = this.container.querySelector(xn)),
                (this.collectionNav = this.container.querySelector(Bn)),
                (this.form = this.querySelector(mn)),
                (this.showMoreOptions = this.querySelectorAll(Dn)),
                (this.accessibility = U),
                (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t)),
                (this.submitFormEvent = (t) => this.submitForm(t)),
                (this.updatePriceEvent = y((t) => this.updatePrice(t), 500)),
                (this.updateRangeEvent = (t) => this.updateRange(t)),
                (this.showMoreEvent = (t) => this.showMore(t));
        }
    };
    const Nn = "[data-collection-sidebar]",
        zn = "[data-range-left]",
        Un = "[data-range-right]",
        Wn = "[data-range-line]",
        Vn = "[data-range-holder]",
        jn = "data-se-min",
        Xn = "data-se-max",
        Jn = "data-se-min-value",
        Yn = "data-se-max-value",
        Qn = "data-se-step",
        Gn = "data-range-filter-update",
        Kn = "[data-field-price-min]",
        Zn = "[data-field-price-max]",
        tr = "is-initialized";
    let er = class extends HTMLElement {
        connectedCallback() {
            let t = this.min;
            this.hasAttribute(Jn) && (t = parseFloat(this.getAttribute(Jn)));
            let e = this.max;
            this.hasAttribute(Yn) && (e = parseFloat(this.getAttribute(Yn))),
                t < this.min && (t = this.min),
                e > this.max && (e = this.max),
                t > e && (t = e),
                this.getAttribute(Qn) && (this.step = Math.abs(parseFloat(this.getAttribute(Qn)))),
                this.reset(),
                (this.maxX = this.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(t),
                this.setMaxValue(e),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.classList.add(tr);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchLeft.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.setAttribute(Jn, t);
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchRight.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.setAttribute(Yn, t);
        }
        onStart(t) {
            let e = t;
            t.touches && (e = t.touches[0]),
                t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                (this.startX = e.pageX - this.x),
                (this.selectedTouch = t.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
        }
        onMove(t) {
            let e = t;
            if (
                (t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.selectedTouch === this.touchLeft
                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                      (this.selectedTouch.style.left = this.x + "px"))
                    : this.selectedTouch === this.touchRight &&
                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                      (this.selectedTouch.style.left = this.x + "px")),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.calculateValue(),
                this.getAttribute("on-change"))
            ) {
                new Function("min, max", this.getAttribute("on-change"))(this.getAttribute(Jn), this.getAttribute(Yn));
            }
            this.onChange(this.getAttribute(Jn), this.getAttribute(Yn));
        }
        onStop() {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.getAttribute(Jn), this.getAttribute(Yn));
        }
        onChange(t, e) {
            const s = this.closest(Vn);
            if (s) {
                const i = s.querySelector(Kn),
                    o = s.querySelector(Zn);
                i && o && ((i.value = t), (o.value = e));
            }
        }
        onChanged(t, e) {
            this.hasAttribute(Gn) && this.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: !0 }));
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                s = e + t;
            if (((e = e * (this.max - this.min) + this.min), (s = s * (this.max - this.min) + this.min), 0 !== this.step)) {
                let t = Math.floor(e / this.step);
                (e = this.step * t), (t = Math.floor(s / this.step)), (s = this.step * t);
            }
            this.selectedTouch === this.touchLeft && this.setAttribute(Jn, e), this.selectedTouch === this.touchRight && this.setAttribute(Yn, s);
        }
        onSidebarTransitionEnd(t) {
            t.target == this.sidebar && "min-width" == t.propertyName && (this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.connectedCallback());
        }
        disconnectedCallback() {
            this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.resizeEvent && document.removeEventListener("theme:resize:width", this.resizeEvent);
        }
        constructor() {
            super(),
                (this.sidebar = this.closest(Nn)),
                (this.sidebarTransitionEvent = (t) => this.onSidebarTransitionEnd(t)),
                (this.resizeEvent = () => {
                    this.connectedCallback(), this.sidebar.addEventListener("transitionend", this.sidebarTransitionEvent);
                }),
                (this.onMoveEvent = (t) => this.onMove(t)),
                (this.onStopEvent = (t) => this.onStop(t)),
                (this.onStartEvent = (t) => this.onStart(t)),
                (this.startX = 0),
                (this.x = 0),
                (this.touchLeft = this.querySelector(zn)),
                (this.touchRight = this.querySelector(Un)),
                (this.lineSpan = this.querySelector(Wn)),
                (this.min = parseFloat(this.getAttribute(jn))),
                (this.max = parseFloat(this.getAttribute(Xn))),
                (this.step = 0),
                (this.normalizeFact = 26),
                document.addEventListener("theme:resize:width", this.resizeEvent);
        }
    };
    const sr = "data-sort-enabled",
        ir = "[data-sort-link]",
        or = "data-value",
        nr = "[data-popout-toggle]",
        rr = "[data-sort-button-text]",
        ar = "[data-collection-sidebar]",
        lr = "[data-collection-sidebar-slide-out]",
        cr = "[data-collection-sidebar-close]",
        hr = "[data-aria-toggle]",
        dr = "[data-collection-nav]",
        ur = "drawer--animated",
        pr = "expanded",
        mr = "no-mobile-animation",
        vr = "is-active",
        gr = "is-focused";
    let fr = {};
    co("collection", [
        Ko,
        Ao,
        {
            onLoad() {
                fr[this.id] = new (class {
                    init() {
                        this.sort && this.initSort(),
                            null !== this.groupTagsButton &&
                                (document.addEventListener("theme:resize:width", this.sidebarResizeEvent),
                                this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent),
                                this.collectionSidebar &&
                                    setTimeout(() => {
                                        this.collectionSidebar.classList.remove(mr);
                                    }, 1e3),
                                new MutationObserver((t) => {
                                    for (const e of t) "attributes" === e.type && "true" == e.target.getAttribute("aria-expanded") && this.showSidebarCallback();
                                }).observe(this.groupTagsButton, { attributes: !0, childList: !1, subtree: !1 })),
                            this.collectionSidebarCloseButtons.length &&
                                this.collectionSidebarCloseButtons.forEach((t) => {
                                    t.addEventListener("click", this.collectionSidebarCloseEvent);
                                }),
                            this.container.addEventListener(
                                "keyup",
                                function (t) {
                                    "Escape" === t.code && this.hideSidebar();
                                }.bind(this)
                            ),
                            this.collectionSidebar &&
                                (this.collectionSidebar.addEventListener("transitionend", () => {
                                    this.collectionSidebar.classList.contains(pr) || this.collectionSidebar.classList.remove(ur);
                                }),
                                this.toggleSidebarSlider(),
                                this.collectionSidebar.addEventListener("theme:filter:update", () => {
                                    const t = this.container.querySelectorAll(cr);
                                    t.length &&
                                        t.forEach((t) => {
                                            t.addEventListener("click", this.collectionSidebarCloseEvent);
                                        });
                                }));
                    }
                    sortActions(t, e = !0) {
                        const s = t ? t.getAttribute(or) : "";
                        this.sort.setAttribute(sr, s);
                        const i = this.sort.querySelector(rr),
                            o = this.sort.querySelector(`.${vr}`);
                        if (i) {
                            const e = t ? t.textContent.trim() : "";
                            i.textContent = e;
                        }
                        o && o.classList.remove(vr), this.sort.classList.toggle(vr, t), t && (t.parentElement.classList.add(vr), e && t.dispatchEvent(new CustomEvent("theme:filter:sort-update", { bubbles: !0, detail: { href: s } })));
                    }
                    onSortButtonClick(t) {
                        t.preventDefault(), this.sortButton && this.sortButton.dispatchEvent(new Event("click")), this.sortActions(t.currentTarget);
                    }
                    onSortCheck(t) {
                        let e = null;
                        if (window.location.search.includes("sort_by")) {
                            const t = new window.URL(window.location.href).searchParams;
                            for (const [s, i] of t.entries()) {
                                const t = this.sort.querySelector(`[${or}="${i}"]`);
                                if (s.includes("sort_by") && t) {
                                    e = t;
                                    break;
                                }
                            }
                        }
                        this.sortActions(e, !1);
                    }
                    initSort() {
                        this.sortLinks.forEach((t) => {
                            t.addEventListener("click", this.onSortButtonClickEvent);
                        }),
                            this.sort.addEventListener("theme:filter:sort", this.onSortCheckEvent),
                            this.sortButton &&
                                this.sortButton.addEventListener("click", () => {
                                    const t = this.collectionSidebar.classList.contains(pr);
                                    S() && t && this.hideSidebar();
                                });
                    }
                    showSidebarCallback() {
                        const t = this.container.querySelector(lr),
                            e = document.documentElement.hasAttribute("data-scroll-locked"),
                            s = S();
                        this.collectionSidebar.classList.add(ur),
                            null === t && !s && e && (this.accessibility.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }))),
                            (s || null !== t) &&
                                (t && this.accessibility.trapFocus(this.collectionSidebar, { elementToFocus: this.collectionSidebar.querySelector(cr) }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                    }
                    hideSidebar() {
                        const t = this.container.querySelector(lr),
                            e = document.documentElement.hasAttribute("data-scroll-locked");
                        this.groupTagsButton.setAttribute("aria-expanded", "false"),
                            this.collectionSidebar.classList.remove(pr),
                            t && this.accessibility.removeTrapFocus(),
                            e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }
                    toggleSidebarSlider() {
                        S() ? this.hideSidebar() : this.collectionSidebar.classList.contains(pr) && this.showSidebarCallback();
                    }
                    collectionSidebarClose(t) {
                        t.preventDefault(), this.hideSidebar(), document.body.classList.contains(gr) && this.groupTagsButton && this.groupTagsButton.focus();
                    }
                    groupTagsButtonClick() {
                        document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }
                    onUnload() {
                        null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)),
                            this.collectionSidebarCloseButtons.length &&
                                this.collectionSidebarCloseButtons.forEach((t) => {
                                    t.removeEventListener("click", this.collectionSidebarCloseEvent);
                                }),
                            this.sort &&
                                (this.sortLinks.forEach((t) => {
                                    t.removeEventListener("click", this.onSortButtonClickEvent);
                                }),
                                this.sort.removeEventListener("theme:filter:sort", this.onSortCheckEvent));
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.sort = this.container.querySelector(`[${sr}]`)),
                            (this.sortButton = this.container.querySelector(nr)),
                            (this.sortLinks = this.container.querySelectorAll(ir)),
                            (this.collectionSidebar = this.container.querySelector(ar)),
                            (this.collectionSidebarCloseButtons = this.container.querySelectorAll(cr)),
                            (this.groupTagsButton = this.container.querySelector(hr)),
                            (this.collectionNav = this.container.querySelector(dr)),
                            (this.accessibility = U),
                            (this.groupTagsButtonClickEvent = (t) => this.groupTagsButtonClick(t)),
                            (this.collectionSidebarCloseEvent = (t) => this.collectionSidebarClose(t)),
                            (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
                            (this.onSortCheckEvent = (t) => this.onSortCheck(t)),
                            (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                fr[this.id].onUnload();
            },
        },
        Lo,
    ]),
        customElements.get("collection-filters-form") || customElements.define("collection-filters-form", Rn),
        customElements.get("range-slider") || customElements.define("range-slider", er);
    const yr = "[data-ticker-scale]",
        br = "[data-ticker-text]",
        wr = "data-clone",
        Er = "autoplay",
        Sr = "speed",
        Lr = "ticker--animated",
        kr = "ticker--unloaded",
        Ar = "ticker__comparitor",
        Tr = 1.63,
        Cr = 100;
    let qr = class extends HTMLElement {
        connectedCallback() {
            this.checkWidth(), this.addEventListener("theme:ticker:refresh", this.checkWidthEvent), document.addEventListener("theme:resize:width", this.checkWidthEvent);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.checkWidthEvent);
        }
        checkWidth() {
            const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", "");
            if (this.clientWidth - t < this.comparitor.clientWidth || this.autoplay) {
                if ((this.text.classList.add(Lr), 1 === this.scale.childElementCount)) {
                    if (((this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(wr, ""), this.scale.appendChild(this.clone), this.autoplay))
                        for (let t = 0; t < 10; t++) {
                            const t = this.text.cloneNode(!0);
                            t.setAttribute(wr, ""), this.scale.appendChild(t);
                        }
                    const t = ((this.text.clientWidth / Cr) * Number(this.speed)).toFixed(2);
                    this.scale.style.setProperty("--animation-time", `${t}s`);
                }
            } else {
                this.text.classList.add(Lr);
                let t = this.scale.querySelector(`[${wr}]`);
                t && this.scale.removeChild(t), this.text.classList.remove(Lr);
            }
        }
        constructor() {
            super(),
                (this.autoplay = this.hasAttribute(Er)),
                (this.scale = this.querySelector(yr)),
                (this.text = this.querySelector(br)),
                (this.speed = this.hasAttribute(Sr) ? this.getAttribute(Sr) : Tr),
                (this.comparitor = this.text.cloneNode(!0)),
                this.comparitor.classList.add(Ar),
                this.appendChild(this.comparitor),
                this.scale.classList.remove(kr),
                (this.checkWidthEvent = this.checkWidth.bind(this));
        }
    };
    const xr = { slide: "[data-slide]", slider: "[data-slider]" },
        Mr = "data-target-referrer";
    let Hr = class extends HTMLElement {
        connectedCallback() {
            this.removeAnnouncement(),
                this.slider && this.initSliders(),
                this.addEventListener("theme:block:select", (t) => {
                    this.onBlockSelect(t);
                }),
                this.addEventListener("theme:block:deselect", (t) => {
                    this.onBlockDeselect(t);
                }),
                document.dispatchEvent(new CustomEvent("theme:announcement:init", { bubbles: !0 }));
        }
        removeAnnouncement() {
            for (let t = 0; t < this.slides.length; t++) {
                const e = this.slides[t];
                e.hasAttribute(Mr) && (-1 !== this.locationPath.indexOf(e.getAttribute(Mr)) || window.Shopify.designMode || e.parentNode.removeChild(e));
            }
        }
        initSliders() {
            this.initSlider(),
                document.addEventListener("theme:resize:width", this.initSliderEvent),
                this.addEventListener("theme:slider:loaded", () => {
                    var t;
                    null === (t = this.querySelectorAll(xr.tickerBar)) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
                        });
                });
        }
        initSlider() {
            const t = E(),
                e = !t;
            var s, i;
            ((t && this.enableSlider) || (e && !this.enableSlider)) &&
                (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
                t && this.enableSlider ? (this.enableSlider = !1) : e && !this.enableSlider && (this.enableSlider = !0),
                (this.slider = new Go(this, this.querySelector(xr.slider))),
                null === (i = this.slider.flkty) || void 0 === i || i.reposition());
        }
        onBlockSelect(t) {
            this.slider && this.slider.onBlockSelect(t);
        }
        onBlockDeselect(t) {
            this.slider ? this.slider.onBlockDeselect(t) : this.toggleTicker(t, !1);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent),
                document.removeEventListener("theme:resize:width", this.tickerResizeEvent),
                this.removeEventListener("theme:block:select", (t) => {
                    this.onBlockSelect(t);
                }),
                this.removeEventListener("theme:block:deselect", (t) => {
                    this.onBlockDeselect(t);
                });
        }
        constructor() {
            super(), (this.locationPath = location.href), (this.slides = this.querySelectorAll(xr.slide)), (this.slider = this.querySelector(xr.slider)), (this.enableSlider = E()), (this.initSliderEvent = (t) => this.initSlider(t));
        }
    };
    customElements.get("announcement-bar") || customElements.define("announcement-bar", Hr), customElements.get("ticker-bar") || customElements.define("ticker-bar", qr);
    const Pr = "body",
        Ir = "[data-drawer]",
        Br = "[data-drawer-inner]",
        Dr = "[data-drawer-underlay]",
        Fr = "[data-stagger-animation]",
        Or = "[data-header-wrapper]",
        $r = "data-drawer-toggle",
        _r = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Rr = "drawer--animated",
        Nr = "is-open",
        zr = "is-focused";
    let Ur = {};
    const Wr = {
            onLoad() {
                Ur[this.id] = [];
                this.container.querySelectorAll(Ir).forEach((t) => {
                    Ur[this.id].push(
                        new (class {
                            connectToggle() {
                                this.buttons.forEach((t) => {
                                    t.addEventListener("click", () => {
                                        this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                                    });
                                });
                            }
                            connectDrawer() {
                                this.drawer.addEventListener("theme:drawer:toggle", () => {
                                    this.drawer.classList.contains(Nr) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !0 })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !0 }));
                                }),
                                    this.drawerInner &&
                                        this.drawerInner.addEventListener("transitionend", (t) => {
                                            t.target == this.drawerInner && (this.drawer.classList.contains(Nr) || (this.drawer.classList.remove(Rr), document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 }))));
                                        }),
                                    document.addEventListener("theme:cart:open", this.hideDrawer),
                                    document.addEventListener("theme:drawer:close", this.hideDrawer),
                                    document.addEventListener("theme:drawer:open", this.showDrawer);
                            }
                            watchFocus(t) {
                                !this.wrapper.contains(t.target) && this.body.classList.contains(zr) && this.hideDrawer();
                            }
                            closers() {
                                this.wrapper.addEventListener(
                                    "keyup",
                                    function (t) {
                                        "Escape" === t.code && (this.hideDrawer(), this.buttons[0].focus());
                                    }.bind(this)
                                ),
                                    this.underlay.addEventListener("click", () => {
                                        this.hideDrawer();
                                    });
                            }
                            showDrawer() {
                                this.drawerInner &&
                                    this.drawerInner.querySelector(this.btnSelector) &&
                                    (this.accessibility.removeTrapFocus(),
                                    this.drawerInner.addEventListener("transitionend", (t) => {
                                        t.target == this.drawerInner && this.drawer.classList.contains(Nr) && this.accessibility.trapFocus(this.drawerInner, { elementToFocus: this.drawerInner.querySelector(this.btnSelector) });
                                    })),
                                    this.buttons.forEach((t) => {
                                        t.setAttribute("aria-expanded", !0);
                                    }),
                                    this.drawer.classList.add(Nr),
                                    this.drawer.classList.add(Rr),
                                    this.drawer.querySelector(_r).focus(),
                                    document.addEventListener("focusin", this.initWatchFocus),
                                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                            }
                            hideDrawer() {
                                this.drawer.classList.contains(Nr) &&
                                    (this.accessibility.removeTrapFocus(),
                                    this.body.classList.contains(zr) && this.buttons.length && this.buttons[0].focus(),
                                    this.buttons.forEach((t) => {
                                        t.setAttribute("aria-expanded", !1);
                                    }),
                                    this.drawer.classList.remove(Nr),
                                    document.removeEventListener("focusin", this.initWatchFocus),
                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
                            }
                            onUnload() {
                                document.removeEventListener("theme:cart:open", this.hideDrawer), document.removeEventListener("theme:drawer:close", this.hideDrawer), document.removeEventListener("theme:drawer:open", this.showDrawer);
                            }
                            constructor(t) {
                                (this.drawer = t),
                                    (this.drawerWrapper = this.drawer.closest(Ir)),
                                    (this.drawerInner = this.drawer.querySelector(Br)),
                                    (this.underlay = this.drawer.querySelector(Dr)),
                                    (this.wrapper = this.drawer.closest(Or)),
                                    (this.key = this.drawer.dataset.drawer),
                                    (this.btnSelector = `[${$r}='${this.key}']`),
                                    (this.buttons = document.querySelectorAll(this.btnSelector)),
                                    (this.staggers = this.drawer.querySelectorAll(Fr)),
                                    (this.body = document.querySelector(Pr)),
                                    (this.accessibility = U),
                                    (this.initWatchFocus = (t) => this.watchFocus(t)),
                                    (this.showDrawer = this.showDrawer.bind(this)),
                                    (this.hideDrawer = this.hideDrawer.bind(this)),
                                    this.connectToggle(),
                                    this.connectDrawer(),
                                    this.closers();
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                Ur[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        Vr = ".page-header",
        jr = "js__header__stuck",
        Xr = "has-header-sticky",
        Jr = "shopify-section-group-header-group",
        Yr = "data-header-sticky",
        Qr = "data-scroll-locked";
    let Gr = {};
    const Kr = {
            onLoad() {
                Gr = new (class {
                    listen() {
                        document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset);
                    }
                    onScroll(t) {
                        t.detail.down ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple() : t.detail.position <= this.headerOffset && this.unstickSimple();
                    }
                    updateHeaderOffset(t) {
                        t.target.classList.contains(Jr) &&
                            setTimeout(() => {
                                var t;
                                this.headerOffset = null === (t = document.querySelector(Vr)) || void 0 === t ? void 0 : t.offsetTop;
                            });
                    }
                    stickOnLoad() {
                        window.scrollY > this.headerOffset && this.stickSimple();
                    }
                    stickSimple() {
                        this.cls.add(jr), (this.isStuck = !0);
                    }
                    unstickSimple() {
                        document.documentElement.hasAttribute(Qr) || (this.cls.remove(jr), (this.isStuck = !1));
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent),
                            document.removeEventListener("shopify:section:load", this.updateHeaderOffset),
                            document.removeEventListener("shopify:section:unload", this.updateHeaderOffset);
                    }
                    constructor(t) {
                        var e;
                        (this.wrapper = t),
                            (this.sticks = this.wrapper.hasAttribute(Yr)),
                            document.body.classList.toggle(Xr, this.sticks),
                            this.sticks &&
                                ((this.isStuck = !1),
                                (this.cls = this.wrapper.classList),
                                (this.headerOffset = null === (e = document.querySelector(Vr)) || void 0 === e ? void 0 : e.offsetTop),
                                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                                (this.scrollEvent = (t) => this.onScroll(t)),
                                this.listen(),
                                this.stickOnLoad());
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof Gr.unload && Gr.unload();
            },
        },
        Zr = "data-hover-disclosure-toggle",
        ta = "[data-hover-disclosure]",
        ea = "[data-top-link]",
        sa = "[data-header-wrapper]",
        ia = "[data-stagger]",
        oa = "[data-stagger-first]",
        na = "[data-stagger-second]",
        ra = "is-visible",
        aa = "meganav--visible",
        la = "meganav--is-transitioning";
    let ca = {},
        ha = {};
    const da = {
            onLoad() {
                (ca[this.id] = []),
                    (ha = this.container.querySelectorAll(ta)),
                    ha.forEach((t) => {
                        ca[this.id].push(
                            new (class {
                                onBlockSelect(t) {
                                    this.disclosure.contains(t.target) && this.showDisclosure(t);
                                }
                                onBlockDeselect(t) {
                                    this.disclosure.contains(t.target) && this.hideDisclosure();
                                }
                                showDisclosure(t) {
                                    t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(la),
                                        this.grandparent ? this.wrapper.classList.add(aa) : this.wrapper.classList.remove(aa),
                                        this.trigger.setAttribute("aria-expanded", !0),
                                        this.trigger.classList.add(ra),
                                        this.disclosure.classList.add(ra),
                                        this.transitionTimeout && clearTimeout(this.transitionTimeout),
                                        (this.transitionTimeout = setTimeout(() => {
                                            this.wrapper.classList.remove(la);
                                        }, 200));
                                }
                                hideDisclosure() {
                                    this.disclosure.classList.remove(ra), this.trigger.classList.remove(ra), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(aa, la);
                                }
                                staggerChildAnimations() {
                                    this.disclosure.querySelectorAll(ia).forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    }),
                                        this.disclosure.querySelectorAll(oa).forEach((t, e) => {
                                            const s = 100 * e;
                                            (t.style.transitionDelay = `${s}ms`),
                                                t.parentElement.querySelectorAll(na).forEach((t, e) => {
                                                    const i = 20 * (e + 1);
                                                    t.style.transitionDelay = `${s + i}ms`;
                                                });
                                        });
                                }
                                handleTablets() {
                                    this.trigger.addEventListener(
                                        "touchstart",
                                        function (t) {
                                            this.disclosure.classList.contains(ra) || (t.preventDefault(), this.showDisclosure(t));
                                        }.bind(this),
                                        { passive: !0 }
                                    );
                                }
                                connectHoverToggle() {
                                    this.trigger.addEventListener("mouseenter", (t) => this.showDisclosure(t)),
                                        this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
                                        this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                        this.trigger.addEventListener("focusout", (t) => {
                                            this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                        }),
                                        this.disclosure.addEventListener("keyup", (t) => {
                                            "Escape" === t.code && this.hideDisclosure();
                                        });
                                }
                                constructor(t) {
                                    (this.disclosure = t),
                                        (this.wrapper = t.closest(sa)),
                                        (this.key = this.disclosure.id),
                                        (this.trigger = document.querySelector(`[${Zr}='${this.key}']`)),
                                        (this.link = this.trigger.querySelector(ea)),
                                        (this.grandparent = this.trigger.classList.contains("grandparent")),
                                        (this.transitionTimeout = 0),
                                        this.trigger.setAttribute("aria-haspopup", !0),
                                        this.trigger.setAttribute("aria-expanded", !1),
                                        this.trigger.setAttribute("aria-controls", this.key),
                                        this.connectHoverToggle(),
                                        this.handleTablets(),
                                        this.staggerChildAnimations();
                                }
                            })(t)
                        );
                    });
            },
            onBlockSelect(t) {
                ca[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                ca[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        ua = "data-cart-count";
    const pa = {
            onLoad() {
                new (class {
                    listen() {
                        document.addEventListener("theme:cart:change", (t) => {
                            (this.cartCount = t.detail.cartCount), this.update();
                        });
                    }
                    update() {
                        null !== this.cartCount &&
                            this.counts.forEach((t) => {
                                t.setAttribute(ua, this.cartCount), (t.innerHTML = this.cartCount < 10 ? `${this.cartCount}` : "9+");
                            });
                    }
                    constructor(t) {
                        (this.section = t), (this.counts = this.section.querySelectorAll(`[${ua}]`)), (this.cartCount = null), this.listen();
                    }
                })(this.container);
            },
        },
        ma = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
        },
        va = "is-visible",
        ga = "is-hiding",
        fa = "is-hidden",
        ya = "is-focused",
        ba = "is-scrolling";
    let wa = {};
    const Ea = {
            onLoad() {
                wa[this.id] = [];
                this.container.querySelectorAll(ma.slideruleWrappper).forEach((t) => {
                    wa[this.id].push(
                        new (class {
                            clickEvents() {
                                this.trigger.addEventListener("click", () => {
                                    (this.cachedButton = this.trigger), this.showSliderule();
                                }),
                                    this.exit.forEach((t) => {
                                        t.addEventListener("click", () => {
                                            this.hideSliderule();
                                        });
                                    });
                            }
                            keyboardEvents() {
                                this.sliderule.addEventListener("keyup", (t) => {
                                    t.stopPropagation(), "Escape" === t.code && this.hideSliderule();
                                });
                            }
                            trapFocusSliderule(t = !0) {
                                const e = t ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
                                this.accessibility.removeTrapFocus(), e && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, { elementToFocus: document.body.classList.contains(ya) ? e : null });
                            }
                            hideSliderule(t = !1) {
                                const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                                this.pane.setAttribute(ma.sliderulePane, e), this.pane.classList.add(ga), this.sliderule.classList.add(ga);
                                const s = t ? `[${ma.dataAnimates}].${fa}` : `[${ma.dataAnimates}="${e}"]`,
                                    i = this.pane.querySelectorAll(s);
                                i.length &&
                                    i.forEach((t) => {
                                        t.classList.remove(fa);
                                    });
                                const o = t ? this.pane.querySelectorAll(`.${va}, .${ga}`) : this.children;
                                o.forEach((s, i) => {
                                    const n = o.length - 1 == i;
                                    s.classList.remove(va), t && (s.classList.remove(ga), this.pane.classList.remove(ga));
                                    const r = () => {
                                        parseInt(this.pane.getAttribute(ma.sliderulePane)) === e && this.sliderule.classList.remove(va),
                                            this.sliderule.classList.remove(ga),
                                            this.pane.classList.remove(ga),
                                            n && (this.accessibility.removeTrapFocus(), t || this.trapFocusSliderule(!1)),
                                            s.removeEventListener("animationend", r);
                                    };
                                    window.theme.settings.enableAnimations ? s.addEventListener("animationend", r) : r();
                                });
                            }
                            showSliderule() {
                                let t = null;
                                const e = this.sliderule.closest(`.${va}`);
                                let s = this.pane;
                                e && (s = e), s.scrollTo({ top: 0, left: 0, behavior: "smooth" }), s.classList.add(ba);
                                const i = () => {
                                    s.scrollTop <= 0 ? (s.classList.remove(ba), t && cancelAnimationFrame(t)) : (t = requestAnimationFrame(i));
                                };
                                (t = requestAnimationFrame(i)), this.sliderule.classList.add(va);
                                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                                    n = o + 1;
                                this.pane.setAttribute(ma.sliderulePane, n);
                                const r = this.pane.querySelectorAll(`[${ma.dataAnimates}="${o}"]`);
                                r.length &&
                                    r.forEach((t, e) => {
                                        const s = r.length - 1 == e;
                                        t.classList.add(ga);
                                        const i = () => {
                                            t.classList.remove(ga), parseInt(this.pane.getAttribute(ma.sliderulePane)) !== o && t.classList.add(fa), s && this.trapFocusSliderule(), t.removeEventListener("animationend", i);
                                        };
                                        window.theme.settings.enableAnimations ? t.addEventListener("animationend", i) : i();
                                    });
                            }
                            closeSliderule() {
                                this.pane &&
                                    this.pane.hasAttribute(ma.sliderulePane) &&
                                    parseInt(this.pane.getAttribute(ma.sliderulePane)) > 0 &&
                                    (this.hideSliderule(!0), parseInt(this.pane.getAttribute(ma.sliderulePane)) > 0 && this.pane.setAttribute(ma.sliderulePane, 0));
                            }
                            onUnload() {
                                document.removeEventListener("theme:sliderule:close", this.closeSliderule);
                            }
                            constructor(t) {
                                (this.sliderule = t), (this.key = this.sliderule.id);
                                const e = `[${ma.slideruleOpen}='${this.key}']`;
                                (this.exitSelector = `[${ma.slideruleClose}='${this.key}']`),
                                    (this.trigger = document.querySelector(e)),
                                    (this.exit = document.querySelectorAll(this.exitSelector)),
                                    (this.pane = document.querySelector(`[${ma.sliderulePane}]`)),
                                    (this.children = this.sliderule.querySelectorAll(ma.children)),
                                    (this.drawerContent = document.querySelector(ma.drawerContent)),
                                    (this.cachedButton = null),
                                    (this.accessibility = U),
                                    this.trigger.setAttribute("aria-haspopup", !0),
                                    this.trigger.setAttribute("aria-expanded", !1),
                                    this.trigger.setAttribute("aria-controls", this.key),
                                    (this.closeSliderule = this.closeSliderule.bind(this)),
                                    this.clickEvents(),
                                    this.keyboardEvents(),
                                    document.addEventListener("theme:sliderule:close", this.closeSliderule);
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                wa[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        Sa = "[data-takes-space-wrapper]",
        La = "[data-child-takes-space]",
        ka = "[data-header-desktop]",
        Aa = '.navlink[href="#"]',
        Ta = "[data-cart-toggle]",
        Ca = ".main-content > .shopify-section.section-overlay-header:first-of-type",
        qa = "js__header__clone",
        xa = "has-first-section-overlay-header",
        Ma = "js__show__mobile",
        Ha = "has-header-transparent",
        Pa = "data-header-transparent";
    let Ia = {};
    co("header", [
        {
            onLoad() {
                Ia = new (class {
                    initTicker(t = !1) {
                        this.tickerFrames.forEach((e) => {
                            new qr(e, t);
                        }),
                            (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
                            document.addEventListener("theme:resize:width", this.tickerResizeEvent);
                    }
                    listenWidth() {
                        "ResizeObserver" in window ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth);
                    }
                    killDeadLinks() {
                        this.deadLinks.forEach((t) => {
                            t.onclick = (t) => {
                                t.preventDefault();
                            };
                        });
                    }
                    checkWidth() {
                        document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(Ma) : this.wrapper.classList.remove(Ma);
                    }
                    getMinWidth() {
                        const t = this.wrapper.cloneNode(!0);
                        t.classList.add(qa), document.body.appendChild(t);
                        const e = t.querySelectorAll(Sa);
                        let s = 0,
                            i = 0;
                        return (
                            e.forEach((t) => {
                                const e = t.querySelectorAll(La);
                                let o = 0;
                                (o =
                                    3 === e.length
                                        ? (function (t) {
                                              let e = [];
                                              return (
                                                  t.forEach((t) => {
                                                      t.firstElementChild && e.push(t.firstElementChild.clientWidth);
                                                  }),
                                                  e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                                                  e.reduce((t, e) => t + e)
                                              );
                                          })(e)
                                        : (function (t) {
                                              let e = 0;
                                              return (
                                                  t.forEach((t) => {
                                                      e += t.clientWidth;
                                                  }),
                                                  e
                                              );
                                          })(e)),
                                    o > s && ((s = o), (i = 20 * e.length));
                            }),
                            document.body.removeChild(t),
                            s + i
                        );
                    }
                    cartToggleEvent() {
                        const t = this.wrapper.querySelectorAll(Ta);
                        t.length &&
                            t.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", { bubbles: !0 }));
                                });
                            });
                    }
                    unload() {
                        var t;
                        "ResizeObserver" in window ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth);
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.style = this.wrapper.dataset.style),
                            (this.desktop = this.wrapper.querySelector(ka)),
                            (this.deadLinks = document.querySelectorAll(Aa)),
                            (this.resizeObserver = null),
                            (this.checkWidth = this.checkWidth.bind(this)),
                            this.killDeadLinks(),
                            "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                            this.cartToggleEvent();
                        const e = document.querySelector(Ca);
                        document.body.classList.toggle(Ha, this.wrapper.hasAttribute(Pa)), document.body.classList.toggle(xa, e);
                    }
                })(this.container);
            },
            onUnload() {
                "function" == typeof Ia.unload && Ia.unload();
            },
        },
        Wr,
        Ea,
        Kr,
        da,
        pa,
    ]),
        customElements.get("ticker-bar") || customElements.define("ticker-bar", qr);
    const Ba = "[data-block-scroll]",
        Da = "flickity-enabled",
        Fa = {};
    const Oa = {
            onLoad() {
                Fa[this.id] = new (class {
                    onBlockSelect(t) {
                        const e = this.container.querySelector(Ba);
                        if (e && !e.classList.contains(Da)) {
                            const s = t.srcElement;
                            s && e.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
                        }
                    }
                    constructor(t) {
                        this.container = t.container;
                    }
                })(this);
            },
            onBlockSelect(t) {
                Fa[this.id].onBlockSelect(t);
            },
        },
        $a = "[data-slider-mobile]",
        _a = "[data-slide]",
        Ra = "[data-slider-thumb]",
        Na = "[data-slider-container]",
        za = "[data-popup-container]",
        Ua = "[data-popup-close]",
        Wa = "is-animating",
        Va = "is-open",
        ja = "data-slider-thumb",
        Xa = {};
    function Ja() {
        this.entries = [];
    }
    function Ya(t, e) {
        Qa(t);
        var s = (function (t, e) {
            Qa(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var s = [];
            return (
                e.forEach(function (e) {
                    for (var i = 0; i < t.options.length; i++) {
                        if ((t.options[i].name || t.options[i]).toLowerCase() === e.name.toLowerCase()) {
                            s[i] = e.value;
                            break;
                        }
                    }
                }),
                s
            );
        })(t, e);
        return (function (t, e) {
            return (
                Qa(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e),
                t.variants.filter(function (t) {
                    return e.every(function (e, s) {
                        return t.options[s] === e;
                    });
                })[0] || null
            );
        })(t, s);
    }
    function Qa(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    co("look", [
        {
            onLoad() {
                Xa[this.id] = new (class {
                    init() {
                        this.slider &&
                            this.slides.length &&
                            this.thumbs.length &&
                            (this.popupContainer.addEventListener("transitionend", (t) => {
                                t.target == this.popupContainer && (this.popupContainer.classList.remove(Wa), t.target.classList.contains(Va) ? this.popupOpenCallback() : this.popupCloseCallback());
                            }),
                            this.popupContainer.addEventListener("transitionstart", (t) => {
                                t.target == this.popupContainer && this.popupContainer.classList.add(Wa);
                            }),
                            this.popupClose.forEach((t) => {
                                t.addEventListener("click", () => {
                                    this.popupContainer.classList.remove(Va), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                });
                            }),
                            this.thumbs.forEach((t, e) => {
                                t.addEventListener("click", (s) => {
                                    s.preventDefault();
                                    const i = t.hasAttribute(ja) && "" !== t.getAttribute(ja) ? parseInt(t.getAttribute(ja)) : e,
                                        o = this.slides[i];
                                    if (S()) {
                                        const t = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                                        this.slider.scrollTo({ top: 0, left: o.offsetLeft - t, behavior: "auto" }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })), this.popupContainer.classList.add(Wa, Va);
                                    } else {
                                        let { stickyHeaderHeight: t } = c();
                                        const e = o.getBoundingClientRect().top,
                                            s = o.offsetHeight / 2,
                                            i = window.innerHeight,
                                            n = i / 2,
                                            r = this.container.querySelector(Na);
                                        let a = e + s - n + window.scrollY;
                                        if (r) {
                                            const e = r.getBoundingClientRect().top + window.scrollY,
                                                s = e + r.offsetHeight;
                                            a < e ? (a = e - t) : a + i > s && (a = s - i);
                                        }
                                        window.scrollTo({ top: a, left: 0, behavior: "smooth" });
                                    }
                                });
                            }));
                    }
                    popupCloseByEvent() {
                        this.popupContainer.classList.remove(Va);
                    }
                    popupOpenCallback() {
                        document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, { once: !0 }), document.addEventListener("theme:product:added", this.popupCloseByEvent, { once: !0 });
                    }
                    popupCloseCallback() {
                        document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, { once: !0 }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, { once: !0 });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.slider = this.container.querySelector($a)),
                            (this.slides = this.container.querySelectorAll(_a)),
                            (this.thumbs = this.container.querySelectorAll(Ra)),
                            (this.popupContainer = this.container.querySelector(za)),
                            (this.popupClose = this.container.querySelectorAll(Ua)),
                            (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
                            this.init();
                    }
                })(this);
            },
        },
        Oa,
    ]),
        (Ja.prototype.add = function (t, e, s) {
            this.entries.push({ element: t, event: e, fn: s }), t.addEventListener(e, s);
        }),
        (Ja.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var Ga = '[name="id"]',
        Ka = '[name="selling_plan"]',
        Za = '[name^="options"]',
        tl = '[name="quantity"]',
        el = '[name^="properties"]';
    const sl = "data-scrollbar",
        il = "data-scrollbar-slider",
        ol = "data-scrollbar-slide-fullwidth",
        nl = "[data-scrollbar-arrow-prev]",
        rl = "[data-scrollbar-arrow-next]",
        al = "is-hidden",
        ll = 200;
    let cl = class {
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events());
        }
        listen() {
            document.addEventListener("theme:modal:open", () => {
                this.toggleNextArrow();
            }),
                document.addEventListener("theme:resize", () => {
                    this.toggleNextArrow();
                });
        }
        events() {
            this.arrowNext.addEventListener("click", (t) => {
                t.preventDefault(), this.goToNext();
            }),
                this.arrowPrev.addEventListener("click", (t) => {
                    t.preventDefault(), this.goToPrev();
                }),
                this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow();
                });
        }
        goToNext() {
            const t = (this.scrollbar.hasAttribute(ol) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(al), this.toggleNextArrow();
        }
        goToPrev() {
            const t = this.scrollbar.hasAttribute(ol) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                e = this.scrollbar.scrollLeft - t;
            this.move(e), this.arrowNext.classList.remove(al), this.togglePrevArrow();
        }
        toggleNextArrow() {
            setTimeout(() => {
                this.arrowNext.classList.toggle(al, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            }, ll);
        }
        togglePrevArrow() {
            setTimeout(() => {
                this.arrowPrev.classList.toggle(al, this.scrollbar.scrollLeft <= 0);
            }, ll);
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t) => {
                t.addEventListener("click", (e) => {
                    e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
                });
            });
        }
        move(t) {
            this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
        }
        constructor(t) {
            (this.scrollbar = t),
                (this.arrowNext = this.scrollbar.parentNode.querySelector(rl)),
                (this.arrowPrev = this.scrollbar.parentNode.querySelector(nl)),
                this.scrollbar.hasAttribute(sl) && (this.init(), this.listen()),
                this.scrollbar.hasAttribute(il) && this.scrollToVisibleElement();
        }
    };
    const hl = "[data-grid-swatch-form]",
        dl = "[data-product-grid-item]",
        ul = "[data-product-information]",
        pl = "[data-product-image]",
        ml = "[data-swatch-button]",
        vl = "[data-swatch-link]",
        gl = "[data-swatch-template]",
        fl = "is-visible",
        yl = "hidden",
        bl = "no-events",
        wl = "swatch",
        El = "data-swatch-handle",
        Sl = "data-swatch-label",
        Ll = "data-scrollbar",
        kl = "data-swatch-count",
        Al = "data-tooltip",
        Tl = "data-swatch-variant-name",
        Cl = "data-variant-title";
    let ql = class extends HTMLElement {
            connectedCallback() {
                this.hasAttribute(Al) && new So(this);
            }
            constructor() {
                super();
            }
        },
        xl = class extends HTMLElement {
            connectedCallback() {
                (this.handle = this.getAttribute(El)),
                    (this.productItem = this.closest(dl)),
                    (this.productInfo = this.closest(ul)),
                    (this.productImage = this.productItem.querySelector(pl)),
                    (this.template = document.querySelector(gl).innerHTML);
                const t = this.getAttribute(Sl).trim().toLowerCase();
                (function (t) {
                    const e = `${window.theme.routes.root}products/${t}.js`;
                    return window
                        .fetch(e)
                        .then((t) => t.json())
                        .catch((t) => {
                            console.error(t);
                        });
                })(this.handle).then((e) => {
                    (this.product = e),
                        (this.colorOption = e.options.find(function (e) {
                            return e.name.toLowerCase() === t || null;
                        })),
                        this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                });
            }
            init() {
                (this.innerHTML = ""),
                    (this.count = 0),
                    this.swatches.forEach((t) => {
                        let e = null,
                            s = !1,
                            i = "";
                        for (const s of this.product.variants) {
                            const o = s.options.includes(t);
                            if ((!e && o && (e = s), o && s.featured_media)) {
                                (i = s.featured_media.preview_image.src), (e = s);
                                break;
                            }
                        }
                        for (const e of this.product.variants) {
                            if (e.options.includes(t) && e.available) {
                                s = !0;
                                break;
                            }
                        }
                        if (e) {
                            const r = document.createElement("div");
                            r.innerHTML = this.template;
                            const a = r.querySelector(ml),
                                l = r.querySelector(vl),
                                c = t
                                    .trim()
                                    .toLowerCase()
                                    .replace(/[^\w\s-]/g, "")
                                    .replace(/\s+/g, "-")
                                    .replace(/-+/g, "-"),
                                h = e.title.replaceAll('"', "'");
                            (a.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
                                a.classList.add(`${wl}-${c}`),
                                (a.dataset.tooltip = t),
                                (a.dataset.swatchVariant = e.id),
                                (a.dataset.swatchVariantName = h),
                                (a.dataset.swatchImage = i),
                                (a.dataset.variant = e.id),
                                a.style.setProperty("--swatch", `var(--${c})`),
                                (l.href = ((o = this.product.url), (n = e.id), /variant=/.test(o) ? o.replace(/(variant=)[^&]+/, "$1" + n) : /\?/.test(o) ? o.concat("&variant=").concat(n) : o.concat("?variant=").concat(n))),
                                (l.innerText = t),
                                (l.dataset.swatch = t),
                                (l.disabled = !s),
                                (this.innerHTML += r.innerHTML),
                                this.count++;
                        }
                        var o, n;
                    }),
                    (this.swatchCount = this.productInfo.querySelector(`[${kl}]`)),
                    (this.swatchElements = this.querySelectorAll(vl)),
                    (this.swatchForm = this.productInfo.querySelector(hl)),
                    (this.hideSwatchesTimer = 0),
                    this.swatchCount.hasAttribute(kl) &&
                        ((this.swatchCount.innerText = `${this.count} ${this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor}`),
                        this.swatchCount.addEventListener("mouseenter", () => {
                            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(bl), this.swatchForm.classList.add(fl);
                        }),
                        this.productInfo.addEventListener("mouseleave", () => {
                            this.hideSwatchesTimer = setTimeout(() => {
                                this.productInfo.classList.remove(bl), this.swatchForm.classList.remove(fl);
                            }, 100);
                        })),
                    this.hasAttribute(Ll) && new cl(this),
                    this.showDeferredImage(),
                    this.bindSwatchButtonEvents();
            }
            showDeferredImage() {
                const t = this.productItem.querySelectorAll(`[${Cl}]`);
                t.length &&
                    this.productItem.addEventListener(
                        "mouseenter",
                        () => {
                            t.forEach((t) => {
                                t.classList.remove(yl);
                            });
                        },
                        { once: !0 }
                    );
            }
            bindSwatchButtonEvents() {
                var t;
                null === (t = this.querySelectorAll(ml)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.addEventListener("mouseenter", this.showVariantImageEvent), t.hasAttribute(Al) && new So(t);
                    }),
                    this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent);
            }
            showVariantImage(t) {
                var e;
                const s = null === (e = t.target.getAttribute(Tl)) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
                    i = this.productImage.querySelectorAll(`[${Cl}]`),
                    o = this.productImage.querySelector(`[${Cl}="${s}"]`);
                null == i ||
                    i.forEach((t) => {
                        t.classList.remove(fl);
                    }),
                    null == o || o.classList.add(fl);
            }
            hideVariantImages() {
                var t;
                null === (t = this.productImage.querySelectorAll(`[${Cl}].${fl}`)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.classList.remove(fl);
                    });
            }
            constructor() {
                super(), (this.productItemMouseLeaveEvent = () => this.hideVariantImages()), (this.showVariantImageEvent = (t) => this.showVariantImage(t));
            }
        };
    const Ml = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-product-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]",
        },
        Hl = "is-visible",
        Pl = "is-fade",
        Il = "no-events",
        Bl = "is-active",
        Dl = "data-sibling-cutline",
        Fl = "data-sibling-image",
        Ol = "data-sibling-link",
        $l = "data-sibling-price",
        _l = "data-product-link";
    let Rl = class extends HTMLElement {
        connectedCallback() {
            (this.product = this.closest(Ml.productGridItem)),
                (this.siblingScrollbar = this.querySelector(Ml.siblingsInnerHolder)),
                (this.siblingCount = this.querySelector(Ml.siblingCount)),
                (this.siblingFieldset = this.querySelector(Ml.siblingFieldset)),
                (this.siblingLinks = this.querySelectorAll(Ml.siblingLink)),
                (this.productInfo = this.closest(Ml.productInfo)),
                (this.productLink = this.closest(Ml.link)),
                (this.hideSwatchesTimer = 0),
                this.initScrollbar(),
                this.siblingCount && this.siblingFieldset && this.productInfo && (this.siblingCount.addEventListener("mouseenter", () => this.showSiblings()), this.productInfo.addEventListener("mouseleave", () => this.hideSiblings())),
                this.siblingLinks.length &&
                    new (class {
                        init() {
                            this.cacheDefaultValues(),
                                this.product.addEventListener("mouseleave", () => this.resetProductValues()),
                                this.swatches.forEach((t) => {
                                    t.addEventListener("mouseenter", (t) => this.showSibling(t));
                                }),
                                this.productLinks.length &&
                                    this.swatches.forEach((t) => {
                                        t.addEventListener("click", () => {
                                            this.productLinks[0].click();
                                        });
                                    });
                        }
                        cacheDefaultValues() {
                            (this.productLinkValue = this.productLinks[0].hasAttribute(_l) ? this.productLinks[0].getAttribute(_l) : ""),
                                (this.productPriceValue = this.productPrice.innerHTML),
                                this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML);
                        }
                        resetProductValues() {
                            this.product.classList.remove(Bl),
                                this.productLinkValue &&
                                    this.productLinks.forEach((t) => {
                                        t.href = this.productLinkValue;
                                    }),
                                this.productPrice && (this.productPrice.innerHTML = this.productPriceValue),
                                this.productCutline && this.productCutline && ((this.productCutline.innerHTML = this.productCutlineValue), (this.productCutline.title = this.productCutlineValue)),
                                this.hideSiblingImage();
                        }
                        showSibling(t) {
                            const e = t.target,
                                s = e.hasAttribute(Ol) ? e.getAttribute(Ol) : "",
                                i = e.hasAttribute($l) ? e.getAttribute($l) : "",
                                o = e.hasAttribute(Dl) ? e.getAttribute(Dl) : "",
                                n = e.hasAttribute(Fl) ? e.getAttribute(Fl) : "";
                            s &&
                                this.productLinks.forEach((t) => {
                                    t.href = s;
                                }),
                                i && (this.productPrice.innerHTML = i),
                                o ? ((this.productCutline.innerHTML = o), (this.productCutline.title = o)) : ((this.productCutline.innerHTML = ""), (this.productCutline.title = "")),
                                n && this.showSiblingImage(n);
                        }
                        showSiblingImage(t) {
                            if (!this.productImageSibling) return;
                            const e = window.devicePixelRatio || 1,
                                s = this.productImage.offsetWidth * e,
                                i = 180 * Math.ceil(s / 180),
                                o = r.getSizedImageUrl(t, `${i}x`),
                                n = this.productImageSibling.querySelector(`[src="${o}"]`),
                                a = () => {
                                    this.productImageSibling.classList.add(Hl), this.productImageSibling.querySelector(`[src="${o}"]`).classList.add(Pl);
                                },
                                l = () => {
                                    this.productImageSibling.querySelectorAll("img").forEach((t) => {
                                        t.classList.remove(Pl);
                                    }),
                                        requestAnimationFrame(a);
                                };
                            if (n) l();
                            else {
                                const t = document.createElement("img");
                                (t.src = o),
                                    this.productCutline && (t.alt = this.productCutline.innerText),
                                    t.addEventListener("load", () => {
                                        this.productImageSibling.append(t), l();
                                    });
                            }
                        }
                        hideSiblingImage() {
                            this.productImageSibling &&
                                (this.productImageSibling.classList.remove(Hl),
                                this.productImageSibling.querySelectorAll("img").forEach((t) => {
                                    t.classList.remove(Pl);
                                }));
                        }
                        constructor(t, e) {
                            (this.swatches = t),
                                (this.product = e),
                                (this.productLinks = this.product.querySelectorAll(Ml.productLink)),
                                (this.productCutline = this.product.querySelector(Ml.productCutline)),
                                (this.productPrice = this.product.querySelector(Ml.productPrice)),
                                (this.productImage = this.product.querySelector(Ml.productImage)),
                                (this.productImageSibling = this.product.querySelector(Ml.productImageSibling)),
                                this.init();
                        }
                    })(this.siblingLinks, this.product),
                this.querySelectorAll(Ml.tooltip).forEach((t) => {
                    new So(t);
                });
        }
        showSiblings() {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(Il), this.siblingFieldset.classList.add(Hl);
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout(() => {
                this.productLink && this.productLink.classList.remove(Il), this.siblingFieldset.classList.remove(Hl);
            }, 100);
        }
        initScrollbar() {
            this.siblingScrollbar && new cl(this.siblingScrollbar);
        }
        constructor() {
            super();
        }
    };
    const Nl = "body",
        zl = "[data-related-section]",
        Ul = "[data-tabs-holder]",
        Wl = "data-tab",
        Vl = "data-tab-index",
        jl = "[data-aos]",
        Xl = "data-block-id",
        Jl = "[data-tab]",
        Yl = ".tab-link",
        Ql = ".tab-link__recent",
        Gl = ".tab-content",
        Kl = "[data-scrollbar]",
        Zl = "current",
        tc = "hidden",
        ec = "aos-animate",
        sc = "aos-no-transition",
        ic = "is-focused",
        oc = {};
    const nc = {
            onLoad() {
                oc[this.id] = [];
                this.container.querySelectorAll(Ul).forEach((t) => {
                    oc[this.id].push(
                        new (class {
                            init() {
                                const t = this.container.querySelectorAll(Jl);
                                this.container.addEventListener("theme:tab:check", () => this.checkRecentTab()),
                                    this.container.addEventListener("theme:tab:hide", () => this.hideRelatedTab()),
                                    t.length &&
                                        t.forEach((t) => {
                                            const e = parseInt(t.getAttribute(Wl)),
                                                s = this.container.querySelector(`${Gl}-${e}`);
                                            t.addEventListener("click", () => {
                                                this.tabChange(t, s);
                                            }),
                                                t.addEventListener("keyup", (e) => {
                                                    ("Space" !== e.code && "Enter" !== e.code) || !this.body.classList.contains(ic) || this.tabChange(t, s);
                                                });
                                        });
                            }
                            tabChange(t, e) {
                                if (t.classList.contains(Zl)) return;
                                const s = this.container.querySelector(`${Jl}.${Zl}`),
                                    i = this.container.querySelector(`${Gl}.${Zl}`);
                                null == s || s.classList.remove(Zl),
                                    null == i || i.classList.remove(Zl),
                                    t.classList.add(Zl),
                                    e.classList.add(Zl),
                                    t.classList.contains(tc) && e.classList.add(tc),
                                    this.accessibility.a11y.removeTrapFocus(),
                                    this.container.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !0 })),
                                    t.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "tab" } })),
                                    this.animateItems(e);
                            }
                            animateItems(t, e = !0) {
                                const s = t.querySelectorAll(jl);
                                s.length &&
                                    s.forEach((t) => {
                                        t.classList.remove(ec),
                                            e &&
                                                (t.classList.add(sc),
                                                requestAnimationFrame(() => {
                                                    t.classList.remove(sc), t.classList.add(ec);
                                                }));
                                    });
                            }
                            initNativeScrollbar() {
                                this.scrollbarHolder.length &&
                                    this.scrollbarHolder.forEach((t) => {
                                        new cl(t);
                                    });
                            }
                            checkRecentTab() {
                                const t = this.container.querySelector(Ql);
                                if (t) {
                                    t.classList.remove(tc);
                                    const e = parseInt(t.getAttribute(Wl)),
                                        s = this.container.querySelector(`${Gl}[${Vl}="${e}"]`);
                                    s && (s.classList.remove(tc), this.animateItems(s, !1)), this.initNativeScrollbar();
                                }
                            }
                            hideRelatedTab() {
                                const t = this.container.querySelector(zl);
                                if (!t) return;
                                const e = t.closest(`${Gl}.${Zl}`);
                                if (!e) return;
                                const s = parseInt(e.getAttribute(Vl)),
                                    i = this.container.querySelectorAll(Jl);
                                if (i.length > s) {
                                    const t = i[s].nextSibling;
                                    t && (i[s].classList.add(tc), t.dispatchEvent(new Event("click")), this.initNativeScrollbar());
                                }
                            }
                            onBlockSelect(t) {
                                const e = this.container.querySelector(`${Yl}[${Xl}="${t.detail.blockId}"]`);
                                e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                            }
                            constructor(t) {
                                (this.container = t),
                                    (this.body = document.querySelector(Nl)),
                                    (this.accessibility = window.accessibility),
                                    this.container && ((this.scrollbarHolder = this.container.querySelectorAll(Kl)), this.init(), this.initNativeScrollbar());
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                oc[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
        },
        rc = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current",
            focused: "is-focused",
        },
        ac = 3e3,
        lc = "[data-animation]",
        cc = "[data-api-content]",
        hc = "[data-quick-add-btn]",
        dc = "[data-add-to-cart]",
        uc = "[data-cart-drawer]",
        pc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        mc = "[data-message-error]",
        vc = "[data-quick-add-modal-handle]",
        gc = "[data-product-upsell-ajax]",
        fc = "[data-quick-add-modal-close]",
        yc = "data-product-grid-item",
        bc = "[data-product-information]",
        wc = "[data-quick-add-holder]",
        Ec = "[data-quick-add-modal]",
        Sc = "[data-quick-add-modal-template]",
        Lc = "closing",
        kc = "data-product-id",
        Ac = "data-quick-add-modal-handle",
        Tc = "data-sibling-swapper",
        Cc = "data-quick-add-holder";
    let qc = class extends HTMLElement {
        connectedCallback() {
            this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent),
                this.buttonATC &&
                    this.buttonATC.addEventListener("click", (t) => {
                        t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC } }));
                    }),
                this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler());
        }
        modalButtonClickEvent(t) {
            t.preventDefault();
            const e = this.modalButton.hasAttribute(Tc),
                s = this.modalButton.classList.contains(rc.siblingLinkCurrent);
            s || (this.modalButton.classList.add(rc.loading), (this.modalButton.disabled = !0), e && !s && ((this.currentModal = t.target.closest(Ec)), this.currentModal.classList.add(rc.loading)), this.renderModal());
        }
        modalCreate(t) {
            const e = document.querySelector(`${Ec}[${kc}="${this.productId}"]`);
            if (e) (this.modal = e), this.modalOpen();
            else {
                const e = this.quickAddHolder.querySelector(Sc);
                if (!e) return;
                const s = document.createElement("div");
                (s.innerHTML = e.innerHTML),
                    document.body.appendChild(s.querySelector(Ec)),
                    e.remove(),
                    (this.modal = document.querySelector(`${Ec}[${kc}="${this.productId}"]`)),
                    (this.modal.querySelector(gc).innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(cc).innerHTML),
                    this.modalCreatedCallback();
            }
        }
        modalOpen() {
            "function" == typeof this.modal.show && this.modal.show(),
                this.modal.setAttribute("open", !0),
                this.modal.removeAttribute("inert"),
                this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", { bubbles: !1 }));
            (this.modal.querySelector("[autofocus]") || this.modal.querySelector(pc)).focus(),
                this.quickAddHolder.classList.add(rc.disabled),
                this.modalButton && (this.modalButton.classList.remove(rc.loading), (this.modalButton.disabled = !1)),
                requestAnimationFrame(() => {
                    this.modal.querySelectorAll(lc).forEach((t) => {
                        t.classList.add(rc.animated);
                    });
                }),
                document.dispatchEvent(new CustomEvent("theme:quick-add:open", { bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, { once: !0 });
        }
        modalClose() {
            if (this.isAnimating) return;
            if (!this.modal.hasAttribute(Lc)) return this.modal.setAttribute(Lc, ""), void (this.isAnimating = !0);
            "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"),
                this.modal.removeAttribute(Lc),
                this.modal.setAttribute("inert", ""),
                this.modal.classList.remove(rc.loading),
                this.modalButton && (this.modalButton.disabled = !1),
                this.quickAddHolder && this.quickAddHolder.classList.contains(rc.disabled) && this.quickAddHolder.classList.remove(rc.disabled),
                this.resetAnimatedItems();
            const t = this.cartDrawer && this.cartDrawer.classList.contains(rc.open),
                e = document.querySelector("dialog[open]");
            t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })), document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded);
        }
        modalEvents() {
            var t;
            null === (t = this.modal.querySelector(fc)) ||
                void 0 === t ||
                t.addEventListener("click", (t) => {
                    t.preventDefault(), this.modalClose();
                }),
                this.modal.addEventListener("click", (t) => {
                    "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose();
                }),
                this.modal.addEventListener("keydown", (t) => {
                    "Escape" == t.code && (t.preventDefault(), this.modalClose());
                }),
                this.modal.addEventListener("theme:modal:close", () => {
                    this.modalClose();
                }),
                this.modal.addEventListener("animationend", (t) => {
                    t.target === this.modal &&
                        ((this.isAnimating = !1),
                        this.modal.hasAttribute(Lc) &&
                            (this.modalClose(),
                            document.body.classList.contains(rc.focused) &&
                                this.buttonQuickAdd &&
                                (this.buttonQuickAdd.addEventListener(
                                    "transitionend",
                                    () => {
                                        this.buttonQuickAdd.focus(), this.buttonQuickAdd.classList.remove(rc.visible);
                                    },
                                    { once: !0 }
                                ),
                                this.buttonQuickAdd.classList.add(rc.visible))));
                });
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose();
        }
        quickAddLoadingToggle(t) {
            t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(rc.disabled);
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
                const e = t.detail.holder,
                    s = e.closest(`[${yc}]`);
                if (!s) return;
                const i = e.querySelector(mc),
                    o = s.classList.contains(rc.overlayText),
                    n = s.querySelector(bc),
                    r = e.querySelector(dc);
                r && (r.classList.remove(rc.added, rc.loading), e.classList.add(rc.error)),
                    i && (i.innerText = t.detail.description),
                    o && n.classList.add(rc.hidden),
                    setTimeout(() => {
                        this.resetQuickAddButtons(), o && n.classList.remove(rc.hidden);
                    }, ac);
            });
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(rc.visible, rc.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(rc.added), (this.buttonQuickAdd.disabled = !1));
        }
        renderModal() {
            this.modal
                ? this.modalOpen()
                : window
                      .fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`)
                      .then(this.upsellErrorsHandler)
                      .then((t) => t.text())
                      .then((t) => {
                          this.modalCreate(t);
                      });
        }
        modalCreatedCallback() {
            this.modalEvents(), this.modalOpen(), D(this.modal);
        }
        upsellErrorsHandler(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Ie({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        resetAnimatedItems() {
            var t;
            null === (t = this.modal) ||
                void 0 === t ||
                t.querySelectorAll(lc).forEach((t) => {
                    t.classList.remove(rc.animated);
                });
        }
        constructor() {
            var t;
            (super(), (this.container = this), (this.quickAddHolder = this.container.querySelector(wc)), this.quickAddHolder) &&
                ((this.modal = null),
                (this.currentModal = null),
                (this.productId = this.quickAddHolder.getAttribute(Cc)),
                (this.modalButton = this.quickAddHolder.querySelector(vc)),
                (this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute(Ac)),
                (this.cartDrawer = document.querySelector(uc)),
                (this.buttonQuickAdd = this.quickAddHolder.querySelector(hc)),
                (this.buttonATC = this.quickAddHolder.querySelector(dc)),
                (this.button = this.modalButton || this.buttonATC),
                (this.modalClose = this.modalClose.bind(this)),
                (this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this)),
                (this.isAnimating = !1),
                (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
                (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
        }
    };
    co("product-grid", [nc]),
        customElements.get("quick-add-product") || customElements.define("quick-add-product", qc),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", ql),
        customElements.get("grid-swatch") || customElements.define("grid-swatch", xl),
        customElements.get("product-siblings") || customElements.define("product-siblings", Rl);
    const xc = (t, e) => {
            const { el: s, elStyle: i, elHeight: o, rowsLimit: n, rowsWrapped: r, options: a } = t;
            let l = t.buffer,
                c = l;
            if (r === n + 1) return { ...t };
            const h = l;
            let d = r,
                u = o;
            return (
                (s.innerHTML = c = l.length ? `${l}${a.delimiter}${e}${a.replaceStr}` : `${e}${a.replaceStr}`),
                parseFloat(i.height) > parseFloat(o) && (d++, (u = i.height), d === n + 1)
                    ? ((s.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`), { ...t, elHeight: u, rowsWrapped: d })
                    : ((s.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`), { ...t, buffer: c, elHeight: u, rowsWrapped: d })
            );
        },
        Mc = "complementary-products",
        Hc = "quick-add-product",
        Pc = "is-loaded",
        Ic = "data-url";
    let Bc = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(
                ((t, e) => {
                    t[0].isIntersecting &&
                        (e.unobserve(this),
                        this.hasAttribute(Ic) &&
                            "" !== this.getAttribute(Ic) &&
                            fetch(this.getAttribute(Ic))
                                .then((t) => t.text())
                                .then((t) => {
                                    const e = document.createElement("div");
                                    e.innerHTML = t;
                                    const s = e.querySelector(Mc);
                                    s && s.innerHTML.trim().length && (this.innerHTML = s.innerHTML), e.querySelector(`${Mc} ${Hc}`) && this.classList.add(Pc);
                                })
                                .catch((t) => {
                                    console.error(t);
                                }));
                }).bind(this),
                { rootMargin: "0px 0px 400px 0px" }
            ).observe(this);
        }
        constructor() {
            super();
        }
    };
    const Dc = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
        Fc = 'input[type="email"]',
        Oc = 'input[type="checkbox"]',
        $c = "[data-form-wrapper]";
    let _c = class extends HTMLElement {
        connectedCallback() {
            this.fieldCheckbox &&
                (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
                this.form &&
                    this.form.addEventListener("theme:product:add", () => {
                        (this.fieldCheckbox.checked = !1), this.fieldCheckbox.dispatchEvent(new Event("change"));
                    }));
        }
        clearInputValues() {
            this.fields.length &&
                this.fields.forEach((t) => {
                    t.value = "";
                });
        }
        onChange(t) {
            (this.fieldEmail.required = Boolean(t.target.checked)), t.target.checked || this.clearInputValues();
        }
        disconnectedCallback() {
            this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
        }
        constructor() {
            super(), (this.fieldCheckbox = this.querySelector(Oc)), (this.fieldEmail = this.querySelector(Fc)), (this.fields = this.querySelectorAll(Dc)), (this.form = this.closest($c)), (this.onChangeEvent = (t) => this.onChange(t));
        }
    };
    const Rc = ".product__page",
        Nc = "[data-form-wrapper]",
        zc = "[data-header-sticky]",
        Uc = "[data-product-media-list]",
        Wc = "is-sticky",
        Vc = "data-sticky-enabled";
    window.theme.variables = { productPageSticky: !1 };
    const jc = {};
    const Xc = {
            onLoad() {
                jc[this.id] = new (class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                            this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    stickyFormEvents(t) {
                        this.removeAnimationFrameSticky(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t)));
                    }
                    scrollEvents(t) {
                        (this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down), this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
                    }
                    resizeEvents(t) {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky();
                    }
                    stickyScrollCheck() {
                        const t = this.container.querySelector(`${Rc} ${Nc}`);
                        if (t)
                            if (E()) {
                                const e = this.container.querySelector(Nc),
                                    s = this.container.querySelector(Uc);
                                if (!e || !s) return;
                                e.offsetHeight < s.offsetHeight ? ((theme.variables.productPageSticky = !0), t.classList.add(Wc)) : ((theme.variables.productPageSticky = !1), t.classList.remove(Wc));
                            } else (theme.variables.productPageSticky = !1), t.classList.remove(Wc);
                    }
                    calculateStickyPosition(t = null) {
                        if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrameSticky();
                        const e = Boolean(t && t.detail),
                            s = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            i = this.formWrapper.offsetHeight,
                            o = window.innerHeight - i - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        if ((this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n), this.stickyFormLoad)) {
                            if (document.querySelector(zc)) {
                                let { headerHeight: t } = c();
                                this.stickyDefaultTop = t;
                            } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                            this.stickyScrollTop = this.stickyDefaultTop;
                        }
                        this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
                        const r = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * r),
                            this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (s && this.onChangeCounter <= 10) || (s && this.stickyFormLastHeight !== i) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                                : this.requestAnimationSticky && this.removeAnimationFrameSticky(),
                            (this.stickyFormLastHeight = i);
                    }
                    removeAnimationFrameSticky() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute(Vc)),
                            (this.formWrapper = this.container.querySelector(Nc)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
                            setTimeout(() => {
                                this.init();
                            }, 50);
                    }
                })(this);
            },
            onUnload() {
                jc[this.id].onUnload();
            },
        },
        Jc = "data-section-type",
        Yc = "[data-share-button]",
        Qc = "[data-share-message]",
        Gc = "is-visible";
    let Kc = class extends HTMLElement {
        init() {
            navigator.share
                ? this.shareButton.addEventListener("click", () => {
                      navigator.share({ url: this.urlToShare, title: document.title });
                  })
                : this.shareButton.addEventListener("click", this.copyToClipboard.bind(this));
        }
        updateShareLink() {
            "product" == this.container.getAttribute(Jc) &&
                this.container.addEventListener("theme:variant:change", (t) => {
                    t.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`);
                });
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlToShare).then(() => {
                this.shareMessage.classList.add(Gc);
                const t = () => {
                    this.shareMessage.classList.remove(Gc), this.shareMessage.removeEventListener("animationend", t);
                };
                this.shareMessage.addEventListener("animationend", t);
            });
        }
        constructor() {
            super(),
                (this.container = this.closest(`[${Jc}]`)),
                (this.shareButton = this.querySelector(Yc)),
                (this.shareMessage = this.querySelector(Qc)),
                (this.urlToShare = this.shareButton.dataset.shareUrl ? this.shareButton.dataset.shareUrl : document.location.href),
                this.init(),
                this.updateShareLink();
        }
    };
    const Zc = "[data-button-arrow]",
        th = "[data-deferred-media-button]",
        eh = "model-viewer, video, iframe, button, [href], input, [tabindex]",
        sh = "[data-image-id]",
        ih = "[data-product-media-list]",
        oh = "[data-section-type]",
        nh = "slider__arrows",
        rh = "is-dragging",
        ah = "media--active",
        lh = "media--hidden",
        ch = "media--hiding",
        hh = "data-active-media",
        dh = "data-button-prev",
        uh = "data-button-next",
        ph = "data-image-id",
        mh = "data-media-id",
        vh = "data-fader-desktop",
        gh = "data-fader-mobile";
    let fh = class extends HTMLElement {
        connectedCallback() {
            this.productMediaObserver(), this.toggleEvents(), this.listen(), this.setHeight();
        }
        disconnectedCallback() {
            this.unlisten();
        }
        listen() {
            document.addEventListener("theme:resize:width", this.toggleEvents), document.addEventListener("theme:resize:width", this.setHeight), this.addEventListener("theme:media:select", this.selectMediaEvent);
        }
        unlisten() {
            document.removeEventListener("theme:resize:width", this.toggleEvents), document.removeEventListener("theme:resize:width", this.setHeight), this.removeEventListener("theme:media:select", this.selectMediaEvent);
        }
        toggleEvents() {
            const t = S();
            (t && this.hasAttribute(gh)) || (!t && this.hasAttribute(vh)) ? this.bindEventListeners() : this.unbindEventListeners();
        }
        bindEventListeners() {
            this.initialized ||
                (this.productMediaList.addEventListener("mousedown", this.handleMouseDown),
                this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave),
                this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
                this.productMediaList.addEventListener("mousemove", this.handleMouseMove),
                this.productMediaList.addEventListener("touchstart", this.handleMouseDown, { passive: !0 }),
                this.productMediaList.addEventListener("touchend", this.handleMouseUp, { passive: !0 }),
                this.productMediaList.addEventListener("touchmove", this.handleMouseMove, { passive: !0 }),
                this.productMediaList.addEventListener("keyup", this.handleKeyUp),
                this.initArrows(),
                this.resetScrollPosition(),
                (this.initialized = !0));
        }
        unbindEventListeners() {
            this.initialized &&
                (this.productMediaList.removeEventListener("mousedown", this.handleMouseDown),
                this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave),
                this.productMediaList.removeEventListener("mouseup", this.handleMouseUp),
                this.productMediaList.removeEventListener("mousemove", this.handleMouseMove),
                this.productMediaList.removeEventListener("touchstart", this.handleMouseDown),
                this.productMediaList.removeEventListener("touchend", this.handleMouseUp),
                this.productMediaList.removeEventListener("touchmove", this.handleMouseMove),
                this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
                this.removeArrows(),
                (this.initialized = !1));
        }
        handleMouseDown(t) {
            (this.isDown = !0), (this.startX = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft);
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1);
        }
        handleMouseUp(t) {
            const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft - this.startX,
                s = e > 0 ? 1 : -1;
            Math.abs(e) > 10 && (s < 0 ? this.showNextImage() : this.showPreviousImage()),
                (this.isDown = !1),
                requestAnimationFrame(() => {
                    this.classList.remove(rh);
                });
        }
        handleMouseMove() {
            this.isDown && this.classList.add(rh);
        }
        handleKeyUp(t) {
            "ArrowLeft" === t.code && this.showPreviousImage(), "ArrowRight" === t.code && this.showNextImage();
        }
        handleArrowsClickEvent() {
            var t;
            null === (t = this.querySelectorAll(Zc)) ||
                void 0 === t ||
                t.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), t.target.hasAttribute(dh) && this.showPreviousImage(), t.target.hasAttribute(uh) && this.showNextImage();
                    });
                });
        }
        resetScrollPosition() {
            0 !== this.productMediaList.scrollLeft && (this.productMediaList.scrollLeft = 0);
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(nh),
                    (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
                    this.productMediaList.append(t),
                    (this.buttons = this.querySelectorAll(Zc)),
                    (this.buttonPrev = this.querySelector(`[${dh}]`)),
                    (this.buttonNext = this.querySelector(`[${uh}]`));
            }
            this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${nh}`)) || void 0 === t || t.remove();
        }
        preloadImageOnArrowHover() {
            var t, e;
            null === (t = this.buttonPrev) ||
                void 0 === t ||
                t.addEventListener("mouseover", () => {
                    const t = this.getPreviousMediaId();
                    this.preloadImage(t);
                }),
                null === (e = this.buttonNext) ||
                    void 0 === e ||
                    e.addEventListener("mouseover", () => {
                        const t = this.getNextMediaId();
                        this.preloadImage(t);
                    });
        }
        preloadImage(t) {
            var e;
            null === (e = this.querySelector(`[${mh}="${t}"] img`)) || void 0 === e || e.setAttribute("loading", "eager");
        }
        showMediaOnVariantSelect(t) {
            const e = t.detail.id;
            this.setActiveMedia(e);
        }
        getCurrentMedia() {
            return this.querySelector(`${sh}.${ah}`);
        }
        getNextMediaId() {
            const t = this.getCurrentMedia(),
                e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(ph)) ? (null == t ? void 0 : t.nextElementSibling) : this.querySelector(sh);
            return null == e ? void 0 : e.getAttribute(mh);
        }
        getPreviousMediaId() {
            const t = this.getCurrentMedia(),
                e = this.productMediaItems.length - 1,
                s = (null == t ? void 0 : t.previousElementSibling) || this.productMediaItems[e];
            return null == s ? void 0 : s.getAttribute(mh);
        }
        showNextImage() {
            const t = this.getNextMediaId();
            this.selectMedia(t);
        }
        showPreviousImage() {
            const t = this.getPreviousMediaId();
            this.selectMedia(t);
        }
        selectMedia(t) {
            this.dispatchEvent(new CustomEvent("theme:media:select", { detail: { id: t } }));
        }
        setActiveMedia(t) {
            if (!t) return;
            this.setAttribute(hh, t);
            const e = this.querySelector(`${sh}.${ah}`),
                s = this.querySelector(`[${mh}="${t}"]`),
                i = null == s ? void 0 : s.querySelector(eh),
                o = s.querySelector("deferred-media");
            var n;
            (null == e || e.classList.add(ch), null == e || e.classList.remove(ah), null == s || s.classList.remove(ch, lh), null == s || s.classList.add(ah), o && !0 !== o.getAttribute("loaded")) &&
                (null === (n = s.querySelector(th)) || void 0 === n || n.dispatchEvent(new Event("click", { bubbles: !1 })));
            requestAnimationFrame(() => {
                this.setHeight(), null == i || i.focus();
            });
        }
        setHeight() {
            var t, e;
            const s = (null === (t = this.querySelector(`${sh}.${ah}`)) || void 0 === t ? void 0 : t.offsetHeight) || (null === (e = this.productMediaItems[0]) || void 0 === e ? void 0 : e.offsetHeight);
            this.style.setProperty("--height", `${s}px`);
        }
        productMediaObserver() {
            this.productMediaItems.forEach((t) => {
                t.addEventListener("transitionend", (e) => {
                    e.target == t && t.classList.contains(ch) && (t.classList.remove(ch), t.classList.add(lh));
                }),
                    t.addEventListener("transitioncancel", (e) => {
                        e.target == t && t.classList.contains(ch) && (t.classList.remove(ch), t.classList.add(lh));
                    });
            });
        }
        constructor() {
            super(),
                (this.initialized = !1),
                (this.buttons = !1),
                (this.isDown = !1),
                (this.startX = 0),
                (this.scrollLeft = 0),
                (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
                (this.container = this.closest(oh)),
                (this.handleMouseDown = this.handleMouseDown.bind(this)),
                (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
                (this.handleMouseUp = this.handleMouseUp.bind(this)),
                (this.handleMouseMove = this.handleMouseMove.bind(this)),
                (this.handleKeyUp = this.handleKeyUp.bind(this)),
                (this.productMediaItems = this.querySelectorAll(sh)),
                (this.productMediaList = this.querySelector(ih)),
                (this.setHeight = this.setHeight.bind(this)),
                (this.toggleEvents = this.toggleEvents.bind(this)),
                (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
        }
    };
    const yh = "data-option-position",
        bh = '[name^="options"], [data-popout-option]',
        wh = '[name^="options"]:checked, [name^="options"][type="hidden"]',
        Eh = "data-value",
        Sh = "[data-popout]",
        Lh = "sold-out",
        kh = "unavailable",
        Ah = "sale";
    const Th = "[data-product]",
        Ch = "[data-product-form]",
        qh = "[data-add-to-cart]",
        xh = "[data-add-to-cart-text]",
        Mh = "[data-compare-price]",
        Hh = "[data-compare-text]",
        Ph = "[data-form-wrapper]",
        Ih = "[data-product-select]",
        Bh = "[data-price-wrapper]",
        Dh = "product-images",
        Fh = "[data-product-json]",
        Oh = "[data-product-price]",
        $h = "[data-product-unit-price]",
        _h = "[data-product-base]",
        Rh = "[data-product-unit]",
        Nh = "[data-product-preorder]",
        zh = "[data-subscription-watch-price]",
        Uh = "[data-subscription-selectors]",
        Wh = "[data-toggles-group]",
        Vh = "data-group-toggle",
        jh = "[data-plan-description]",
        Xh = "[data-section-type]",
        Jh = "[data-quick-add-modal]",
        Yh = "[data-price-off]",
        Qh = "[data-price-off-type]",
        Gh = "[data-price-off-amount]",
        Kh = "[data-remaining-count]",
        Zh = "[data-remaining-max]",
        td = "[data-remaining-wrapper]",
        ed = "[data-product-remaining-json]",
        sd = "[data-option-value]",
        id = "[data-option-position]",
        od = "[data-product-form-installment]",
        nd = 'input[name="id"]',
        rd = "hidden",
        ad = "variant--soldout",
        ld = "variant--unavailable",
        cd = "product__price--sale",
        hd = "count-is-low",
        dd = "count-is-in",
        ud = "count-is-out",
        pd = "count-is-unavailable",
        md = "data-tall-layout",
        vd = "data-remaining-max",
        gd = "data-enable-history-state",
        fd = "data-option-position",
        yd = "data-image-id",
        bd = "data-media-id",
        wd = "data-quick-add-btn";
    let Ed = class extends HTMLElement {
        connectedCallback() {
            if ((this.cartAddEvents(), (this.container = this.closest(Xh) || this.closest(Jh)), !this.container)) return;
            if (
                ((this.sectionId = this.container.dataset.sectionId),
                (this.tallLayout = "true" === this.container.getAttribute(md)),
                (this.product = this.container.querySelector(Th)),
                (this.productForm = this.container.querySelector(Ch)),
                (this.productImages = this.container.querySelector(Dh)),
                (this.installmentForm = this.container.querySelector(od)),
                (this.sellout = null),
                (this.priceOffWrap = this.container.querySelector(Yh)),
                (this.priceOffAmount = this.container.querySelector(Gh)),
                (this.priceOffType = this.container.querySelector(Qh)),
                (this.planDescription = this.container.querySelector(jh)),
                (this.remainingWrapper = this.container.querySelector(td)),
                this.remainingWrapper)
            ) {
                const t = this.container.querySelector(Zh);
                t &&
                    ((this.remainingMaxInt = parseInt(t.getAttribute(vd), 10)),
                    (this.remainingCount = this.container.querySelector(Kh)),
                    (this.remainingJSONWrapper = this.container.querySelector(ed)),
                    (this.remainingJSON = null),
                    this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON"));
            }
            (this.enableHistoryState = "true" === this.container.getAttribute(gd)),
                (this.hasUnitPricing = this.container.querySelector(Rh)),
                (this.subSelectors = this.container.querySelector(Uh)),
                (this.subPrices = this.container.querySelector(zh)),
                (this.isPreOrder = this.container.querySelector(Nh));
            let t = null;
            const e = this.container.querySelector(Fh);
            e && (t = e.innerHTML),
                t
                    ? ((this.productJSON = JSON.parse(t)),
                      this.linkForm(),
                      (this.sellout = new (class {
                          init() {
                              this.update();
                          }
                          update() {
                              this.getCurrentState(),
                                  this.optionElements.forEach((t) => {
                                      const e = t.closest(`[${yh}]`);
                                      if (!e) return;
                                      const s = t.value || t.getAttribute(Eh),
                                          i = e.getAttribute(yh),
                                          o = parseInt(i, 10) - 1,
                                          n = t.closest(Sh);
                                      let r = [...this.selections];
                                      r[o] = s;
                                      const a = this.productJSON.variants.find((t) => {
                                          let e = !0;
                                          for (let s = 0; s < r.length; s++) t.options[s] !== r[s] && (e = !1);
                                          return e;
                                      });
                                      t.classList.remove(Lh, kh),
                                          t.parentNode.classList.remove(Ah),
                                          n && n.classList.remove(Lh, kh, Ah),
                                          void 0 === a ? (t.classList.add(kh), n && n.classList.add(kh)) : a && !1 === a.available && (t.classList.add(Lh), n && n.classList.add(Lh)),
                                          a && a.compare_at_price > a.price && theme.settings.variantOnSale && t.parentNode.classList.add(Ah);
                                  });
                          }
                          getCurrentState() {
                              this.selections = [];
                              const t = this.container.querySelectorAll(wh);
                              t.length &&
                                  t.forEach((t) => {
                                      const e = t.value;
                                      e && "" !== e && this.selections.push(e);
                                  });
                          }
                          constructor(t, e) {
                              (this.container = t), (this.productJSON = e), (this.optionElements = this.container.querySelectorAll(bh)), this.productJSON && this.optionElements.length && this.init();
                          }
                      })(this.container, this.productJSON)))
                    : console.error("Missing product JSON");
        }
        cartAddEvents() {
            (this.buttonATC = this.querySelector(qh)),
                this.buttonATC &&
                    this.buttonATC.addEventListener("click", (t) => {
                        t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC }, bubbles: !1 }));
                    });
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            (this.productForm = new (class {
                destroy() {
                    this._listeners.removeAll();
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, function (t) {
                        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                variant() {
                    const t = this.options();
                    return t.length ? Ya(this.product, t) : this.product.variants[0];
                }
                plan(t) {
                    let e = { allocation: null, group: null, detail: null };
                    const s = this.element.querySelector(`${Ka}:checked`);
                    if (!s) return null;
                    const i = s.value,
                        o = i && "" !== i ? i : null;
                    return (
                        o &&
                            t &&
                            (e.allocation = t.selling_plan_allocations.find(function (t) {
                                return t.selling_plan_id.toString() === o.toString();
                            })),
                        e.allocation &&
                            (e.group = this.product.selling_plan_groups.find(function (t) {
                                return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                            })),
                        e.group &&
                            (e.detail = e.group.selling_plans.find(function (t) {
                                return t.id.toString() === o.toString();
                            })),
                        e && e.allocation && e.detail && e.allocation ? e : null
                    );
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, function (t) {
                        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                }
                getFormState() {
                    const t = this.variant();
                    return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                }
                _setIdInputValue(t) {
                    t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                }
                _onSubmit(t, e) {
                    (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant);
                }
                _onFormEvent(t) {
                    return void 0 === t
                        ? Function.prototype.bind()
                        : function (e) {
                              (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                          }.bind(this);
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                        function (t) {
                            return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                        }.bind(this)
                    );
                }
                _serializeInputValues(t, e) {
                    return t.reduce(function (t, s) {
                        return (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) && t.push(e({ name: s.name, value: s.value })), t;
                    }, []);
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t;
                }
                constructor(t, e, s) {
                    (this.element = t),
                        (this.product = this._validateProductObject(e)),
                        (this.variantElement = this.element.querySelector(Ga)),
                        (s = s || {}),
                        (this._listeners = new Ja()),
                        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
                        (this.optionInputs = this._initInputs(Za, s.onOptionChange)),
                        (this.planInputs = this._initInputs(Ka, s.onPlanChange)),
                        (this.quantityInputs = this._initInputs(tl, s.onQuantityChange)),
                        (this.propertyInputs = this._initInputs(el, s.onPropertyChange));
                }
            })(this.container, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this) })),
                this.pushState(this.productForm.getFormState(), !0),
                this.subsToggleListeners();
        }
        onOptionChange(t) {
            this.pushState(t.dataset), this.updateProductImage(t);
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset);
        }
        pushState(t, e = !1) {
            var s;
            (this.productState = this.setProductState(t)),
                this.updateAddToCartState(t),
                this.updateProductPrices(t),
                this.updateSaleText(t),
                this.updateSubscriptionText(t),
                this.updateRemaining(t),
                this.updateLegend(t),
                this.fireHookEvent(t),
                null === (s = this.sellout) || void 0 === s || s.update(t),
                this.enableHistoryState && !e && this.updateHistoryState(t);
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(Bh),
                o = this.container.querySelectorAll(qh),
                n = this.container.querySelectorAll(xh),
                r = this.container.querySelectorAll(Ph);
            if (this.installmentForm && e) {
                const t = this.installmentForm.querySelector(nd);
                (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
            }
            this.isPreOrder && (s = theme.strings.preOrder),
                i.length &&
                    e &&
                    i.forEach((t) => {
                        t.classList.remove(rd);
                    }),
                o.length &&
                    o.forEach((t) => {
                        t.hasAttribute(wd) || (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
                    }),
                n.length &&
                    n.forEach((t) => {
                        e ? (e.available ? (t.innerHTML = s) : (t.innerHTML = theme.strings.soldOut)) : (t.innerHTML = theme.strings.unavailable);
                    }),
                r.length &&
                    r.forEach((t) => {
                        if (e) {
                            e.available ? t.classList.remove(ad, ld) : (t.classList.add(ad), t.classList.remove(ld));
                            const s = t.querySelector(Ih);
                            s && (s.value = e.id);
                            const i = t.querySelector(`${nd}[form]`);
                            i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
                        } else t.classList.add(ld), t.classList.remove(ad);
                    });
        }
        updateHistoryState(t) {
            const e = t.variant,
                s = t.plan,
                i = window.location.href;
            if (e && i.includes("/product")) {
                const t = new window.URL(i),
                    o = t.searchParams;
                o.set("variant", e.id), s && s.detail && s.detail.id && this.productState.hasPlan ? o.set("selling_plan", s.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                const n = t.toString();
                window.history.replaceState({ path: n }, "", n);
            }
        }
        updateRemaining(t) {
            var e;
            const s = t.variant;
            if ((null === (e = this.remainingWrapper) || void 0 === e || e.classList.remove(dd, ud, pd, hd), s && this.remainingWrapper && this.remainingJSON)) {
                const t = this.remainingJSON[s.id];
                ("out" === t || t < 1) && this.remainingWrapper.classList.add(ud),
                    ("in" === t || t >= this.remainingMaxInt) && this.remainingWrapper.classList.add(dd),
                    ("low" === t || (t > 0 && t < this.remainingMaxInt)) && (this.remainingWrapper.classList.add(hd), this.remainingCount && (this.remainingCount.innerHTML = t));
            } else !s && this.remainingWrapper && this.remainingWrapper.classList.add(pd);
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            this.container.querySelectorAll(Wh).forEach((t) => {
                t.addEventListener(
                    "change",
                    function (t) {
                        const e = t.target.value.toString(),
                            s = this.container.querySelector(`[${Vh}="${e}"]`),
                            i = this.container.querySelectorAll(`[${Vh}]`);
                        if (s) {
                            s.classList.remove(rd);
                            const t = s.querySelector('[name="selling_plan"]');
                            (t.checked = !0), t.dispatchEvent(new Event("change"));
                        }
                        i.forEach((t) => {
                            if (t !== s) {
                                t.classList.add(rd);
                                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                    (t.checked = !1), t.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(rd);
        }
        updateSaleTextStandard(t) {
            if ((this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), this.priceOffAmount && this.priceOffWrap)) {
                const e = t.variant,
                    s = (e.compare_at_price - e.price) / e.compare_at_price,
                    i = Math.floor(100 * s);
                (this.priceOffAmount.innerHTML = `${i}%`), this.priceOffWrap.classList.remove(rd);
            }
        }
        updateSubscriptionText(t) {
            t.plan && this.planDescription ? ((this.planDescription.innerHTML = t.plan.detail.description), this.planDescription.classList.remove(rd)) : this.planDescription && this.planDescription.classList.add(rd);
        }
        updateSaleTextSubscription(t) {
            if ((this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap)) {
                const e = t.plan.detail.price_adjustments[0],
                    i = e.value;
                e && "percentage" === e.value_type ? (this.priceOffAmount.innerHTML = `${i}%`) : (this.priceOffAmount.innerHTML = s.formatMoney(i, theme.moneyFormat)), this.priceOffWrap.classList.remove(rd);
            }
        }
        updateProductPrices(t) {
            const e = t.variant,
                i = t.plan;
            this.container.querySelectorAll(Bh).forEach((t) => {
                const o = t.querySelector(Mh),
                    n = t.querySelector(Oh),
                    r = t.querySelector(Hh);
                let a = "",
                    l = "";
                this.productState.available && ((a = e.compare_at_price), (l = e.price)),
                    this.productState.hasPlan && (l = i.allocation.price),
                    this.productState.planSale && ((a = i.allocation.compare_at_price), (l = i.allocation.price)),
                    o &&
                        (this.productState.onSale || this.productState.planSale ? (o.classList.remove(rd), r.classList.remove(rd), n.classList.add(cd)) : (o.classList.add(rd), r.classList.add(rd), n.classList.remove(cd)),
                        (o.innerHTML = s.formatMoney(a, theme.moneyFormat))),
                    (n.innerHTML = 0 === l ? window.theme.strings.free : s.formatMoney(l, theme.moneyFormat));
            }),
                this.hasUnitPricing && this.updateProductUnits(t);
        }
        updateProductUnits(t) {
            const e = t.variant,
                i = t.plan;
            let o = null;
            if ((e && e.unit_price && (o = e.unit_price), i && i.allocation && i.allocation.unit_price && (o = i.allocation.unit_price), o)) {
                const t = this.getBaseUnit(e),
                    i = s.formatMoney(o, theme.moneyFormat);
                (this.container.querySelector($h).innerHTML = i), (this.container.querySelector(_h).innerHTML = t), xe(this.container.querySelector(Rh));
            } else He(this.container.querySelector(Rh));
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
        }
        setProductState(t) {
            const e = t.variant,
                s = t.plan,
                i = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
            return (
                !e || (e.requires_selling_plan && !s)
                    ? (i.available = !1)
                    : (e.available || (i.soldOut = !0),
                      e.compare_at_price > e.price && (i.onSale = !0),
                      e.unit_price && (i.showUnitPrice = !0),
                      this.product && this.product.requires_selling_plan && (i.requiresPlan = !0),
                      s && this.subPrices && ((i.hasPlan = !0), s.allocation.per_delivery_price !== s.allocation.price && (i.planPerDelivery = !0), e.price > s.allocation.price && (i.planSale = !0))),
                i
            );
        }
        updateProductImage(t) {
            const e = t.dataset.variant;
            if (e && e.featured_media) {
                const t = this.container.querySelector(`[${yd}="${e.featured_media.id}"]`);
                if (t) {
                    const e = t.getAttribute(bd),
                        s = E();
                    if ((t.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: !0, detail: { id: e } })), s && this.tallLayout)) {
                        const e = t.getBoundingClientRect().top;
                        if (e > window.scrollY) return;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })), Zo(e);
                    }
                }
            }
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                const t = this.container.querySelectorAll(sd);
                t.length &&
                    t.forEach((t) => {
                        const s = t.closest(id);
                        if (s) {
                            const i = s.getAttribute(fd),
                                o = parseInt(i, 10) - 1,
                                n = e.options[o];
                            t.innerHTML = n;
                        }
                    });
            }
        }
        constructor() {
            super();
        }
    };
    const Sd = "[data-image-id]",
        Ld = "product-images",
        kd = "[data-section-type]",
        Ad = "[data-thumb-item]",
        Td = "[data-thumb-link]",
        Cd = "[data-thumbs-slider]",
        qd = "data-active-media",
        xd = "data-media-id",
        Md = "is-active";
    class Hd extends HTMLElement {
        connectedCallback() {
            this.handleEvents(), this.preloadImagesOnHover(), this.activeMediaObserver();
        }
        disconnectedCallback() {
            this.observer && this.observer.disconnect();
        }
        activeMediaObserver() {
            (this.observer = new MutationObserver((t) => {
                for (const e of t) "attributes" === e.type && e.attributeName == qd && this.setActiveThumb();
            })),
                this.observer.observe(this.productImagesContainer, { attributes: !0, childList: !1, subtree: !1 });
        }
        handleEvents() {
            this.thumbLinks.forEach((t) => {
                t.addEventListener("click", (e) => {
                    e.preventDefault();
                    const s = t.closest(Ad),
                        i = t.getAttribute(xd);
                    s.classList.contains(Md) || this.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: !0, detail: { id: i } }));
                }),
                    t.addEventListener("keyup", (e) => {
                        if ("Enter" === e.code) {
                            var s;
                            const e = t.getAttribute(xd),
                                i =
                                    null === (s = this.productImagesContainer.querySelector(`[${xd}="${e}"]`)) || void 0 === s
                                        ? void 0
                                        : s.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
                            i && (i.dispatchEvent(new Event("focus")), i.dispatchEvent(new Event("select")));
                        }
                    });
            });
        }
        preloadImagesOnHover() {
            this.thumbLinks.forEach((t) => {
                t.addEventListener("mouseover", () => {
                    const e = t.getAttribute(xd),
                        s = this.productImagesContainer.querySelector(`[${xd}="${e}"] img`);
                    null == s || s.setAttribute("loading", "eager");
                });
            });
        }
        setActiveThumb() {
            var t;
            const e = this.productImagesContainer.getAttribute(qd),
                s = this.querySelector(`[${xd}="${e}"]`);
            null === (t = this.querySelector(`${Ad}.${Md}`)) || void 0 === t || t.classList.remove(Md),
                null == s || s.parentNode.classList.add(Md),
                requestAnimationFrame(() => {
                    this.scrollToThumb();
                });
        }
        scrollToThumb() {
            const t = this.thumbSlider;
            if (t) {
                const e = t.querySelector(`.${Md}`);
                if (!e) return;
                const s = t.scrollTop,
                    i = t.scrollLeft,
                    o = t.offsetWidth,
                    n = t.offsetHeight,
                    r = s + n,
                    a = i + o,
                    l = e.offsetTop,
                    c = e.offsetLeft,
                    h = e.offsetWidth,
                    d = e.offsetHeight,
                    u = s > l,
                    p = i > c,
                    m = c + h > a,
                    v = l + d > r || u,
                    g = m || p,
                    f = S();
                if (v || g) {
                    let e = l - n + d,
                        s = c - o + h;
                    u && (e = l), m && f && (s += parseInt(window.getComputedStyle(t).paddingRight)), p && ((s = c), f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))), t.scrollTo({ top: e, left: s, behavior: "smooth" });
                }
            }
        }
        constructor() {
            super(),
                (this.container = this.closest(kd)),
                (this.productImages = this.container.querySelectorAll(Sd)),
                (this.productImagesContainer = this.container.querySelector(Ld)),
                (this.productThumbs = this.container.querySelectorAll(Ad)),
                (this.thumbSlider = this.querySelector(Cd)),
                (this.thumbLinks = this.querySelectorAll(Td));
        }
    }
    const Pd = "dialog",
        Id = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Bd = "[data-modal-open]",
        Dd = "[data-modal-close]",
        Fd = "closing";
    let Od = class extends HTMLElement {
            connectedCallback() {
                (this.modal = this.querySelector(Pd)),
                    (this.buttonModalOpen = this.querySelector(Bd)),
                    (this.buttonModalClose = this.querySelector(Dd)),
                    (this.focusTarget = this.modal.querySelector("[autofocus]") || this.modal.querySelector(Id)),
                    (this.isAnimating = !1),
                    this.modalEvents();
            }
            modalOpen() {
                var t;
                "function" == typeof this.modal.showModal && this.modal.showModal(),
                    this.modal.setAttribute("open", !0),
                    this.modal.removeAttribute("inert"),
                    null === (t = this.focusTarget) || void 0 === t || t.focus(),
                    document.dispatchEvent(new CustomEvent("theme:modal:open", { bubbles: !0 })),
                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
            }
            modalClose() {
                if (!this.isAnimating) {
                    if (!this.modal.hasAttribute(Fd)) return this.modal.setAttribute(Fd, ""), void (this.isAnimating = !0);
                    "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"),
                        this.modal.removeAttribute(Fd),
                        this.modal.setAttribute("inert", ""),
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }
            }
            modalEvents() {
                this.buttonModalOpen.addEventListener("click", (t) => {
                    t.preventDefault(), this.modalOpen();
                }),
                    this.buttonModalClose.addEventListener("click", (t) => {
                        t.preventDefault(), this.modalClose();
                    }),
                    this.modal.addEventListener("click", (t) => {
                        "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose();
                    }),
                    this.modal.addEventListener("keydown", (t) => {
                        "Escape" == t.code && (t.preventDefault(), this.modalClose());
                    }),
                    this.modal.addEventListener("theme:modal:close", () => {
                        this.modalClose();
                    }),
                    this.modal.addEventListener("animationend", (t) => {
                        t.target === this.modal && ((this.isAnimating = !1), this.modal.hasAttribute(Fd) && this.modalClose());
                    });
            }
            constructor() {
                super();
            }
        },
        $d = class extends Qt {
            loadContent() {
                super.loadContent(), Shopify.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) }]);
            }
            setupModelViewerUI(t) {
                t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")));
            }
            constructor() {
                super();
            }
        };
    (window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(t) {
            t ||
                (window.ShopifyXR
                    ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
                          window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
        window.addEventListener("DOMContentLoaded", () => {
            window.ProductModel && window.ProductModel.loadShopifyXR();
        });
    const _d = "data-store-availability-container",
        Rd = ".shopify-section",
        Nd = "[data-pickup-drawer]",
        zd = "[data-pickup-drawer-open]",
        Ud = "[data-pickup-drawer-close]",
        Wd = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Vd = "[data-section-type]",
        jd = "hidden",
        Xd = "closing";
    let Jd = class extends HTMLElement {
        connectedCallback() {
            (this.container = this.closest(Vd)),
                (this.drawer = null),
                (this.buttonDrawerOpen = null),
                (this.buttonDrawerClose = null),
                (this.a11y = U),
                (this.isAnimating = !1),
                this.container.addEventListener("theme:variant:change", (t) => this.fetchPickupAvailability(t)),
                this.fetchPickupAvailability();
        }
        fetchPickupAvailability(t) {
            if ((t && !t.detail.variant) || (t && t.detail.variant && !t.detail.variant.available)) return void this.classList.add(jd);
            const e = t && t.detail.variant ? t.detail.variant.id : this.getAttribute(_d);
            e &&
                fetch(`${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`)
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = new DOMParser().parseFromString(t, "text/html").querySelector(Rd).innerHTML;
                        (this.innerHTML = e), (this.drawer = this.querySelector(Nd)), this.drawer ? (this.classList.remove(jd), this.drawerEvents()) : this.classList.add(jd);
                    })
                    .catch((t) => {
                        console.error(t);
                    });
        }
        openDrawer() {
            if (this.drawer) {
                "function" == typeof this.drawer.showModal && this.drawer.showModal(),
                    this.drawer.setAttribute("open", !0),
                    this.drawer.removeAttribute("inert"),
                    this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                (this.drawer.querySelector("[autofocus]") || this.drawer.querySelector(Wd)).focus(), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
            }
        }
        closeDrawer() {
            if (this.isAnimating) return;
            if (!this.drawer.hasAttribute(Xd)) return this.drawer.setAttribute(Xd, ""), void (this.isAnimating = !0);
            "function" == typeof this.drawer.close ? this.drawer.close() : this.drawer.removeAttribute("open"), this.drawer.removeAttribute(Xd), this.drawer.setAttribute("inert", "");
            document.querySelector("dialog[open]") || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        drawerEvents() {
            var t, e;
            null === (t = this.querySelector(zd)) ||
                void 0 === t ||
                t.addEventListener("click", () => {
                    this.openDrawer(), (window.accessibility.lastElement = this.buttonDrawerOpen);
                }),
                null === (e = this.drawer.querySelector(Ud)) ||
                    void 0 === e ||
                    e.addEventListener("click", (t) => {
                        t.preventDefault(), this.closeDrawer();
                    }),
                this.drawer.addEventListener("click", (t) => {
                    "DIALOG" === t.target.nodeName && "click" === t.type && this.closeDrawer();
                }),
                this.drawer.addEventListener("keydown", (t) => {
                    "Escape" === t.code && (t.preventDefault(), this.closeDrawer());
                }),
                this.drawer.addEventListener("animationend", (t) => {
                    t.target === this.drawer && ((this.isAnimating = !1), this.drawer.hasAttribute(Xd) && this.closeDrawer());
                });
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Ie({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        constructor() {
            super();
        }
    };
    const Yd = {};
    function Qd(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Yd[t.url]
                ? Yd[t.url]
                : (function (t, e) {
                      const s = new Promise((s, i) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        s(t);
                                    })
                                    .catch((t) => {
                                        i(t);
                                    })
                              : (function (t, e, s) {
                                    let i = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange = function () {
                                            o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? s() : ((o = !0), e());
                                        }),
                                        i.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        s();
                                    },
                                    function () {
                                        i();
                                    }
                                );
                      });
                      return (Yd[t] = s), s;
                  })(t.url, t.type);
        if (t.json)
            return Yd[t.json]
                ? Promise.resolve(Yd[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Yd[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Yd[e]
                ? Yd[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          s = new Promise((e, s) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, s) {
                                                  s ? e(s) : t();
                                              })(e, s, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  s(t);
                              }
                          });
                      return (Yd[e] = s), s;
                  })(t);
        }
        return Promise.reject();
    }
    (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
    const Gd = ".pswp",
        Kd = ".pswp__custom-close",
        Zd = "iframe, video",
        tu = ".pswp__thumbs",
        eu = "is-current",
        su = "pswp--custom-loader",
        iu = "pswp--custom-opening",
        ou = "pswp__loader",
        nu = "is-focused",
        ru = "data-pswp-option-classes",
        au = "aria-current",
        lu = `<div class="${ou}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    let cu = class {
        init() {
            this.pswpElement.classList.add(iu),
                this.initLoader(),
                Qd({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(su) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(ru, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = lu), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(ru, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(su) && this.pswpElement.classList.remove(su),
                this.pswpElement.classList.remove(iu),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.init(),
                this.thumbsActions(),
                document.body.classList.contains(nu) &&
                    setTimeout(() => {
                        this.a11y.trapFocus(this.pswpElement, { elementToFocus: this.closeBtn });
                    }, 200),
                this.popup.listen("close", () => this.onClose()),
                this.options &&
                    this.options.closeElClasses &&
                    this.options.closeElClasses.length &&
                    this.options.closeElClasses.forEach((t) => {
                        const e = this.pswpElement.querySelector(`.pswp__${t}`);
                        e && e.addEventListener("keyup", this.keyupCloseEvent);
                    });
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.children.length &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${tu} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (s) => {
                        s.preventDefault();
                        const i = t.parentElement.querySelector(`.${eu}`);
                        i.classList.remove(eu), i.setAttribute(au, !1), t.classList.add(eu), t.setAttribute(au, !0), this.popup.goTo(e);
                    });
                }),
                this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
                this.popup.listen("beforeChange", () => this.setCurrentThumb()));
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        keyupClose(t) {
            "Enter" === t.code && this.popup.close();
        }
        onClose() {
            const t = this.pswpElement.querySelector(Zd);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; ) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(ru, "");
            const e = this.pswpElement.querySelector(`.${ou}`);
            e && this.pswpElement.removeChild(e),
                this.options &&
                    this.options.closeElClasses &&
                    this.options.closeElClasses.length &&
                    this.options.closeElClasses.forEach((t) => {
                        const e = this.pswpElement.querySelector(`.pswp__${t}`);
                        e && e.removeEventListener("keyup", this.keyupCloseEvent);
                    }),
                this.a11y.removeTrapFocus(),
                window.accessibility.lastElement &&
                    document.body.classList.contains(nu) &&
                    requestAnimationFrame(() => {
                        window.accessibility.lastElement.focus();
                    });
        }
        setCurrentThumb() {
            const t = this.pswpElement.querySelector(`${tu} > .${eu}`);
            if ((t && (t.classList.remove(eu), t.setAttribute(au, !1)), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(eu), e.setAttribute(au, !0), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                s = t.offsetLeft;
            if (e <= s + t.offsetWidth || e > s) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: s - e, behavior: "smooth" });
            }
        }
        constructor(t, e = "") {
            (this.items = t),
                (this.pswpElement = document.querySelectorAll(Gd)[0]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(tu)),
                (this.closeBtn = this.pswpElement.querySelector(Kd)),
                (this.keyupCloseEvent = (t) => this.keyupClose(t)),
                (this.a11y = U);
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }), this.init();
        }
    };
    const hu = "[data-zoom-caption]",
        du = "[data-zoom-image]",
        uu = "[data-pswp-thumbs-template]",
        pu = "[data-section-type]",
        mu = ".pswp__thumbs",
        vu = "product-images",
        gu = "is-dragging",
        fu = "variant--soldout",
        yu = "variant--unavailable",
        bu = "pswp-zoom-gallery",
        wu = "pswp-zoom-gallery--single",
        Eu = "data-image-src",
        Su = "data-image-width",
        Lu = "data-image-height";
    let ku = class extends HTMLElement {
        connectedCallback() {
            this.images.forEach((t, e) => {
                t.addEventListener("click", (s) => {
                    s.preventDefault(), t.closest(vu).classList.contains(gu) || (this.createZoom(e), (window.accessibility.lastElement = t));
                }),
                    t.addEventListener("keyup", (s) => {
                        "Enter" === s.code && (s.preventDefault(), this.createZoom(e), (window.accessibility.lastElement = t));
                    });
            });
        }
        createZoom(t) {
            const e = this.container.querySelector(uu),
                s = null == e ? void 0 : e.innerHTML;
            let i = [],
                o = 0;
            this.images.forEach((e) => {
                const n = e.getAttribute(Eu);
                if (((o += 1), i.push({ src: n, w: parseInt(e.getAttribute(Su)), h: parseInt(e.getAttribute(Lu)), msrc: n }), this.images.length === o)) {
                    new cu(i, {
                        history: !1,
                        focus: !1,
                        index: t,
                        mainClass: 1 === o ? `${bu} ${wu}` : `${bu}`,
                        showHideOpacity: !0,
                        howAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !0,
                        closeEl: !0,
                        closeElClasses: ["caption-close", "title"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                        addCaptionHTMLFn: (t, e, s) => {
                            this.zoomCaption(t, e, s);
                        },
                        getThumbBoundsFn: () => {
                            const e = this.images[t],
                                s = window.scrollY || document.documentElement.scrollTop,
                                i = e.getBoundingClientRect();
                            return { x: i.left, y: i.top + s, w: i.width };
                        },
                    }),
                        this.thumbsContainer && "" !== s && (this.thumbsContainer.innerHTML = s);
                }
            });
        }
        zoomCaption(t, e) {
            let s = "";
            const i = e.children[0];
            return (
                this.zoomCaptions &&
                    ((s = this.zoomCaptions.innerHTML), this.zoomCaptions.closest(`.${fu}`) ? i.classList.add(fu) : i.classList.remove(fu), this.zoomCaptions.closest(`.${yu}`) ? i.classList.add(yu) : i.classList.remove(yu)),
                (i.innerHTML = s),
                !1
            );
        }
        constructor() {
            super(), (this.container = this.closest(pu)), (this.images = this.querySelectorAll(du)), (this.zoomCaptions = this.container.querySelector(hu)), (this.thumbsContainer = document.querySelector(mu));
        }
    };
    const Au = "[data-add-to-cart]",
        Tu = "[data-product-json]",
        Cu = "[data-product-form]",
        qu = "data-section-id",
        xu = "data-cart-bar",
        Mu = "#cart-bar",
        Hu = "data-add-to-cart-bar",
        Pu = "data-cart-bar-scroll",
        Iu = ".product__submit__add",
        Bu = "[data-truncated-holder]",
        Du = "[data-truncated-button]",
        Fu = "[data-truncated-content]",
        Ou = "data-truncated-content",
        $u = "[data-form-wrapper]",
        _u = "[data-product-variants]",
        Ru = "[data-slider]",
        Nu = "data-slider-index",
        zu = "is-expanded",
        Uu = "is-visible",
        Wu = "is-loading",
        Vu = {};
    const ju = {
        onLoad() {
            Vu[this.id] = new (class {
                scrollEvents(t) {
                    this.cartBarExist && this.cartBarScroll();
                }
                resizeEvents(t) {
                    this.truncateText();
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(Uu)) return;
                    const t = this.truncateElement.querySelectorAll("style");
                    t.length &&
                        t.forEach((t) => {
                            this.truncateElementHolder.prepend(t);
                        });
                    const e = this.truncateElement.cloneNode(!0),
                        s = this.truncateElement.getAttribute(Ou),
                        i = this.truncateElement.nextElementSibling;
                    i && i.remove(), this.truncateElement.parentElement.append(e);
                    const o = this.truncateElement.nextElementSibling;
                    o.classList.add(s),
                        o.removeAttribute(Ou),
                        xe(o),
                        ((t = "", e = 1, s = {}) => {
                            const i = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...s },
                                o = t && (t instanceof NodeList ? t : 1 === t.nodeType ? [t] : document.querySelectorAll(t));
                            for (let t = 0; t < o.length; t++) {
                                const s = o[t],
                                    n = /<!--[\s\S]*?-->/g,
                                    r = s.innerHTML.replace(n, "").split(i.delimiter);
                                s.innerHTML = "";
                                const a = window.getComputedStyle(s);
                                r.reduce(xc, { el: s, buffer: s.innerHTML, elStyle: a, elHeight: 0, rowsLimit: e, rowsWrapped: 0, options: i });
                            }
                        })(o, 5, { replaceStr: "", delimiter: " " }),
                        He(o),
                        this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(zu) : (o.remove(), this.truncateElementHolder.classList.remove(zu)),
                        this.toggleTruncatedContent(this.truncateElementHolder);
                }
                toggleTruncatedContent(t) {
                    const e = t.querySelector(Du);
                    e &&
                        e.addEventListener("click", (e) => {
                            e.preventDefault(), t.classList.remove(zu), t.classList.add(Uu);
                        });
                }
                initCartBar() {
                    (this.cartBarBtn = this.cartBar.querySelector(Iu)),
                        this.cartBarBtn &&
                            (this.cartBarBtn.addEventListener("click", (t) => {
                                t.preventDefault(),
                                    t.currentTarget.hasAttribute(Hu)
                                        ? (theme.settings.cartDrawerEnabled && (t.currentTarget.classList.add(Wu), t.currentTarget.setAttribute("disabled", "disabled")),
                                          this.form.querySelector(Au).dispatchEvent(new Event("click", { bubbles: !0 })))
                                        : t.currentTarget.hasAttribute(Pu) && this.scrollToTop();
                            }),
                            this.cartBarBtn.hasAttribute(Hu) && document.addEventListener("theme:product:add-error", this.scrollToTop));
                }
                scrollToTop() {
                    const t = this.container.querySelector(_u),
                        e = (E() ? this.container : t || this.form).getBoundingClientRect().top;
                    Zo(E() ? e : e - 10);
                }
                cartBarScroll() {
                    const t = window.scrollY,
                        e = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
                    if (e && this.cartBar) {
                        const s = t > e.offsetTop + e.offsetHeight;
                        this.cartBar.classList.toggle(Uu, s);
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:product:add-error", this.scrollToTop),
                        this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEvent),
                        this.cartBarExist && document.removeEventListener("theme:scroll", this.scrollEvent);
                }
                onBlockSelect(t) {
                    const e = t.srcElement.closest(Ru);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Nu) ? e.getAttribute(Nu) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockSelect(t);
                    }
                }
                onBlockDeselect(t) {
                    const e = t.srcElement.closest(Ru);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Nu) ? e.getAttribute(Nu) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockDeselect(t);
                    }
                }
                constructor(t) {
                    (this.section = t),
                        (this.container = t.container),
                        (this.id = this.container.getAttribute(qu)),
                        (this.sliders = this.container.querySelectorAll(Ru)),
                        (this.slider = []),
                        (this.truncateElementHolder = this.container.querySelector(Bu)),
                        (this.truncateElement = this.container.querySelector(Fu)),
                        (this.formWrapper = this.container.querySelector($u)),
                        (this.cartBarExist = "true" === this.container.getAttribute(xu)),
                        (this.cartBar = this.container.querySelector(Mu)),
                        (this.scrollToTop = this.scrollToTop.bind(this)),
                        (this.scrollEvent = (t) => this.scrollEvents(t)),
                        (this.resizeEvent = (t) => this.resizeEvents(t)),
                        (this.unlockTimer = 0),
                        (this.accessibility = U),
                        this.truncateElementHolder && this.truncateElement && (setTimeout(() => this.truncateText(), 50), document.addEventListener("theme:resize", this.resizeEvent));
                    const e = this.container.querySelector(Tu);
                    if ((e && !e.innerHTML) || !e) return;
                    const s = JSON.parse(e.innerHTML).handle;
                    let i = {};
                    s && (i = { handle: s }),
                        Shopify.Products.recordRecentlyViewed(i),
                        (this.form = this.container.querySelector(Cu)),
                        this.sliders.length &&
                            this.sliders.forEach((t, e) => {
                                t.setAttribute(Nu, e), this.slider.push(new Go(this.container, t));
                            }),
                        this.cartBarExist && (this.initCartBar(), document.addEventListener("theme:scroll", this.scrollEvent));
                }
            })(this);
        },
        onUnload(t) {
            Vu[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Vu[this.id].onBlockSelect(t);
        },
        onBlockDeselect(t) {
            Vu[this.id].onBlockDeselect(t);
        },
    };
    co("product", [ju, Lo, nc, Xc]),
        customElements.get("complementary-products") || customElements.define("complementary-products", Bc),
        customElements.get("pickup-availability") || customElements.define("pickup-availability", Jd),
        customElements.get("product-form") || customElements.define("product-form", Ed),
        customElements.get("product-images") || customElements.define("product-images", fh),
        customElements.get("product-thumbs") || customElements.define("product-thumbs", Hd),
        customElements.get("product-modal") || customElements.define("product-modal", Od),
        customElements.get("product-model") || customElements.define("product-model", $d),
        customElements.get("product-siblings") || customElements.define("product-siblings", Rl),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", ql),
        customElements.get("recipient-form") || customElements.define("recipient-form", _c),
        customElements.get("share-button") || customElements.define("share-button", Kc),
        customElements.get("zoom-images") || customElements.define("zoom-images", ku);
    const Xu = "[data-api-related-template]",
        Ju = "[data-related-section]",
        Yu = "[data-product-grid-item]",
        Qu = "[data-recent-wrapper]",
        Gu = "[data-recently-viewed-wrapper]",
        Ku = ".product-item",
        Zu = "grid-slider",
        tp = "data-limit",
        ep = "data-minimum",
        sp = "data-product-id",
        ip = "is-hidden",
        op = {};
    const np = {
        onLoad() {
            op[this.id] = new (class {
                related() {
                    const t = this.container.querySelector(Ju);
                    if (!t) return;
                    const e = t.getAttribute(sp),
                        s = t.getAttribute(tp),
                        i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
                    fetch(i)
                        .then((t) => t.text())
                        .then((e) => {
                            const s = document.createElement("div");
                            (s.innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector(Xu).innerHTML),
                                s.querySelector(Yu) ? (t.innerHTML = s.innerHTML) : t.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
                        })
                        .catch(function () {
                            t.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
                        });
                }
                recent() {
                    const t = this.container.querySelector(Qu),
                        e = t ? parseInt(t.getAttribute(tp)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (t, e) => {
                            const s = e.container,
                                i = s.querySelector(Qu),
                                o = s.querySelector(Gu),
                                n = t.querySelectorAll(Ku),
                                r = i.querySelector(Zu),
                                a = i.hasAttribute(ep) ? parseInt(i.getAttribute(ep)) : 4,
                                l = !o && n.length > 0,
                                c = o && n.length >= a;
                            (l || c) && (c && o.classList.remove(ip), Pe(i), i.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: !0 })), r && r.dispatchEvent(new CustomEvent("theme:grid-slider:init", { bubbles: !0 })));
                        },
                    });
                }
                constructor(t) {
                    (this.section = t), (this.sectionId = t.id), (this.container = t.container), this.related(), this.recent();
                }
            })(this);
        },
    };
    co("related", [np, nc]), co("reviews", [Ko, Oa]);
    const rp = {},
        ap = "[data-slider-logos]",
        lp = "[data-slider-text]",
        cp = "[data-slide]",
        hp = "[data-slide-index]",
        dp = "is-selected",
        up = "flickity-enabled",
        pp = "data-slide",
        mp = "data-slide-index";
    co("logos", [
        {
            onLoad() {
                rp[this.id] = new (class {
                    initSlideshowText() {
                        this.slideshowText &&
                            (this.flkty = new n(this.slideshowText, {
                                fade: !0,
                                autoPlay: !1,
                                prevNextButtons: !1,
                                cellAlign: "left",
                                contain: !0,
                                pageDots: !1,
                                wrapAround: !1,
                                selectedAttraction: 0.2,
                                friction: 0.6,
                                draggable: !1,
                                accessibility: !1,
                                on: { ready: () => this.sliderAccessibility(), change: () => this.sliderAccessibility() },
                            }));
                    }
                    sliderAccessibility() {
                        const t = this.slideshowText.querySelectorAll(`${cp} a, ${cp} button`);
                        t.length &&
                            t.forEach((t) => {
                                const e = t.closest(cp);
                                if (e) {
                                    const s = e.classList.contains(dp) ? 0 : -1;
                                    t.setAttribute("tabindex", s);
                                }
                            });
                    }
                    initSlideshowNav() {
                        this.slideshowNav &&
                            ((this.logoSlides = this.slideshowNav.querySelectorAll(hp)),
                            this.logoSlides.length &&
                                this.logoSlides.forEach((t) => {
                                    t.addEventListener("click", (e) => {
                                        e.preventDefault();
                                        const s = parseInt(t.getAttribute(mp)),
                                            i = this.slideshowNav.classList.contains(up);
                                        if ((this.flkty && this.flkty.select(s), i)) this.flktyNav.select(s), this.slideshowNav.classList.contains(dp) || this.flktyNav.playPlayer();
                                        else {
                                            const e = this.slideshowNav.querySelector(`.${dp}`);
                                            e && e.classList.remove(dp), t.classList.add(dp);
                                        }
                                    });
                                }),
                            this.setSlideshowNavState(),
                            document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize));
                    }
                    setSlideshowNavState() {
                        const t = this.slideshowNav.querySelectorAll(cp),
                            e = 200 * t.length,
                            s = this.slideshowNav.classList.contains(up);
                        if (e > b()) {
                            if (!s) {
                                const e = this.slideshowNav.querySelector(`.${dp}`);
                                e && e.classList.remove(dp),
                                    t[0].classList.add(dp),
                                    (this.flktyNav = new o(this.slideshowNav, { autoPlay: 4e3, prevNextButtons: !1, contain: !1, pageDots: !1, wrapAround: !0, watchCSS: !0, selectedAttraction: 0.05, friction: 0.8, initialIndex: 0 })),
                                    this.flkty && (this.flkty.select(0), this.flktyNav.on("change", (t) => this.flkty.select(t)));
                            }
                        } else s && (this.flktyNav.destroy(), t[0].classList.add(dp), this.flkty && this.flkty.select(0));
                    }
                    onBlockSelect(t) {
                        if (!this.slideshowNav) return;
                        const e = this.slideshowNav.querySelector(`[${pp}="${t.detail.blockId}"]`),
                            s = parseInt(e.getAttribute(mp));
                        this.slideshowNav.classList.contains(up) ? (this.flktyNav.select(s), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(dp)) : e.dispatchEvent(new Event("click"));
                    }
                    onBlockDeselect() {
                        this.slideshowNav && this.slideshowNav.classList.contains(up) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(dp));
                    }
                    onUnload() {
                        this.slideshowNav && (this.slideshowNav.classList.contains(up) && this.flktyNav.destroy(), this.flkty && this.flkty.destroy(), document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize));
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.slideshowNav = this.container.querySelector(ap)),
                            (this.slideshowText = this.container.querySelector(lp)),
                            (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
                            (this.flkty = null),
                            (this.flktyNav = null),
                            this.initSlideshowText(),
                            this.initSlideshowNav();
                    }
                })(this);
            },
            onUnload(t) {
                rp[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                rp[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                rp[this.id].onBlockDeselect(t);
            },
        },
        Oa,
    ]);
    const vp = "data-video-play";
    let gp = class extends HTMLElement {
        connectedCallback() {
            var t;
            (this.videoPlay = this.querySelectorAll(`[${vp}]`)),
                null === (t = this.videoPlay) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            const e = t.currentTarget;
                            if ("" !== e.getAttribute(vp).trim()) {
                                t.preventDefault();
                                const s = [{ html: e.getAttribute(vp) }];
                                new cu(s), (window.accessibility.lastElement = e);
                            }
                        });
                    });
        }
        constructor() {
            super();
        }
    };
    const fp = "[data-video-template]",
        yp = "is-loading",
        bp = "data-video-id";
    let wp = class extends HTMLElement {
        connectedCallback() {
            (this.videoId = this.getAttribute(bp)),
                (this.videoTemplate = this.querySelector(fp)),
                (this.video = null),
                this.videoId &&
                    (this.addEventListener(
                        "touchstart",
                        () => {
                            var t;
                            null === (t = this.video) || void 0 === t || t.play();
                        },
                        { passive: !0 }
                    ),
                    this.renderVideo());
        }
        renderVideo() {
            (this.videoTemplateObserver = new IntersectionObserver(
                (t, e) => {
                    t.forEach((t) => {
                        if (t.isIntersecting) {
                            const s = this.videoTemplate.innerHTML;
                            (this.innerHTML = s), this.classList.remove(yp), (this.video = this.querySelector("video")), this.observeVideoPlayToggle(), e.unobserve(t.target);
                        }
                    });
                },
                { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
            )),
                this.videoTemplateObserver.observe(this);
        }
        observeVideoPlayToggle() {
            if (!this.video) return;
            (this.videoPlayObserver = new IntersectionObserver(
                (t) => {
                    t.forEach((t) => {
                        const e = t.isIntersecting;
                        e && "function" == typeof this.video.play && this.video.play(), e || "function" != typeof this.video.pause || this.video.pause();
                    });
                },
                { rootMargin: "0px", threshold: [0, 1] }
            )),
                this.videoPlayObserver.observe(this.video);
        }
        disconnectedCallback() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect(), this.videoPlayObserver && this.videoPlayObserver.disconnect();
        }
        constructor() {
            super();
        }
    };
    co("featured-video", [Ao]), customElements.get("video-background") || customElements.define("video-background", wp), customElements.get("video-popup") || customElements.define("video-popup", gp), co("slideshow", [Ko, Ao]);
    const Ep = "[data-images-holder]",
        Sp = "[data-image-holder]",
        Lp = "[data-image-element]",
        kp = "[data-images-button]",
        Ap = "data-start-position",
        Tp = {};
    const Cp = {
        onLoad() {
            Tp[this.id] = [];
            this.container.querySelectorAll(Ep).forEach((t) => {
                Tp[this.id].push(
                    new (class {
                        init() {
                            this.changeValues(), this.imagesButton.addEventListener("mousedown", this.onStartEvent), this.imagesButton.addEventListener("touchstart", this.onStartEvent, { passive: !0 });
                        }
                        changeValues(t) {
                            const e = this.imagesHolder.offsetWidth,
                                s = this.imagesButton.offsetWidth;
                            if (
                                (!t || (t && "touchmove" !== t.type && "mousemove" !== t.type)) &&
                                ((this.imageElement.style.width = `${e}px`), (this.imageHolder.style.width = 100 - parseInt(this.startPosition) + "%"), 0 !== this.startPosition)
                            ) {
                                const t = (e * parseInt(this.startPosition)) / 100;
                                this.x = t - s / 2;
                            }
                            this.x > e - s ? (this.x = e - s) : this.x < 0 && (this.x = 0), (this.imagesButton.style.left = (this.x / e) * 100 + "%"), (this.imageHolder.style.width = 100 - ((this.x + s / 2) / e) * 100 + "%");
                        }
                        onStart(t) {
                            t.preventDefault();
                            let e = t;
                            t.touches && (e = t.touches[0]),
                                (this.x = this.imagesButton.offsetLeft),
                                (this.startX = e.pageX - this.x),
                                this.imagesHolder.addEventListener("mousemove", this.onMoveEvent),
                                this.imagesHolder.addEventListener("mouseup", this.onStopEvent),
                                this.imagesHolder.addEventListener("touchmove", this.onMoveEvent),
                                this.imagesHolder.addEventListener("touchend", this.onStopEvent);
                        }
                        onMove(t) {
                            let e = t;
                            t.touches && (e = t.touches[0]), (this.x = e.pageX - this.startX), this.changeValues(t);
                        }
                        onStop(t) {
                            this.imagesHolder.removeEventListener("mousemove", this.onMoveEvent),
                                this.imagesHolder.removeEventListener("mouseup", this.onStopEvent),
                                this.imagesHolder.removeEventListener("touchmove", this.onMoveEvent),
                                this.imagesHolder.removeEventListener("touchend", this.onStopEvent);
                        }
                        onUnload() {
                            this.changeValuesEvent && document.removeEventListener("theme:resize", this.changeValuesEvent);
                        }
                        constructor(t) {
                            (this.imagesHolder = t),
                                this.imagesHolder &&
                                    ((this.imageHolder = this.imagesHolder.querySelector(Sp)),
                                    (this.imageElement = this.imagesHolder.querySelector(Lp)),
                                    (this.imagesButton = this.imagesHolder.querySelector(kp)),
                                    (this.startPosition = this.imagesHolder.hasAttribute(Ap) ? this.imagesHolder.getAttribute(Ap) : 0),
                                    (this.startX = 0),
                                    (this.x = 0),
                                    (this.changeValuesEvent = (t) => this.changeValues(t)),
                                    (this.onMoveEvent = (t) => this.onMove(t)),
                                    (this.onStopEvent = (t) => this.onStop(t)),
                                    (this.onStartEvent = (t) => this.onStart(t)),
                                    this.init(),
                                    document.addEventListener("theme:resize", this.changeValuesEvent));
                        }
                    })(t)
                );
            });
        },
        onUnload() {
            Tp[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    co("custom-content", [Ko, Ao, Cp, hn]), customElements.get("video-background") || customElements.define("video-background", wp), customElements.get("video-popup") || customElements.define("video-popup", gp);
    var qp = {};
    function xp(t) {
        return qp[t];
    }
    (qp.basic = []),
        (qp.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (qp.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (qp.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let Mp = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    co("map", {
        onLoad() {
            Mp[this.id] = new (class {
                initMaps() {
                    (function (t) {
                        if (null === window.theme.mapAPI) {
                            const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
                            window.theme.mapAPI = Qd({ url: e });
                        }
                        return window.theme.mapAPI;
                    })(this.key)
                        .then(() => {
                            return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long
                                ? new google.maps.LatLng(this.lat, this.long)
                                : ((t = this.address),
                                  new Promise((e, s) => {
                                      new google.maps.Geocoder().geocode({ address: t }, function (t, i) {
                                          if ("OK" == i) {
                                              var o = { lat: t[0].geometry.location.lat(), lng: t[0].geometry.location.lng() };
                                              e(o);
                                          } else s(i);
                                      });
                                  }));
                            var t;
                        })
                        .then((t) => {
                            const e = { zoom: parseInt(this.zoomString, 10), styles: xp(this.styleString), center: t, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 },
                                s = (function (t, e) {
                                    var s = new google.maps.Map(t, e),
                                        i = s.getCenter();
                                    return (
                                        new google.maps.Marker({ map: s, position: i }),
                                        google.maps.event.addDomListener(window, "resize", function () {
                                            google.maps.event.trigger(s, "resize"), s.setCenter(i);
                                        }),
                                        s
                                    );
                                })(this.mapContainer, e);
                            return s;
                        })
                        .then((t) => {
                            (this.map = t), (Mp[this.id] = t);
                        })
                        .catch((t) => {
                            console.log("Failed to load Google Map"), console.log(t);
                        });
                }
                unload() {
                    void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.mapContainer = this.container.querySelector("[data-map-container]")),
                        (this.key = this.container.getAttribute("data-api-key")),
                        (this.styleString = this.container.getAttribute("data-style") || ""),
                        (this.zoomString = this.container.getAttribute("data-zoom") || 14),
                        (this.address = this.container.getAttribute("data-address")),
                        (this.enableCorrection = this.container.getAttribute("data-latlong-correction")),
                        (this.lat = this.container.getAttribute("data-lat")),
                        (this.long = this.container.getAttribute("data-long")),
                        this.key && this.initMaps();
                }
            })(this);
        },
        onUnload() {
            "function" == typeof Mp[this.id].unload && Mp[this.id].unload();
        },
    });
    const Hp = (t, e = null) => {
            (t.style.opacity = 1),
                (function s() {
                    (t.style.opacity -= 0.1) < 0 ? (t.style.display = "none") : requestAnimationFrame(s), 0 === parseFloat(t.style.opacity) && "function" == typeof e && e();
                })();
        },
        Pp = "[data-large-promo]",
        Ip = "[data-large-promo-inner]",
        Bp = "[data-tracking-consent]",
        Dp = "[data-confirm-cookies]",
        Fp = "cart-bar",
        Op = "[data-close-modal]",
        $p = "[data-modal-underlay]",
        _p = "[data-newsletter]",
        Rp = "[data-newsletter-holder]",
        Np = "[data-newsletter-close]",
        zp = "[data-newsletter-heading]",
        Up = "[data-newsletter-field]",
        Wp = "[data-promo-text]",
        Vp = "[data-newsletter-form]",
        jp = "data-popup-delay",
        Xp = "data-cookie-name",
        Jp = "data-target-referrer",
        Yp = "hidden",
        Qp = "has-value",
        Gp = "cart-bar-visible",
        Kp = "is-visible",
        Zp = "has-success",
        tm = "selected",
        em = "has-block-selected",
        sm = "mobile",
        im = "desktop",
        om = "bottom",
        nm = "data-enable";
    let rm = {},
        am = class {
            always() {
                Pe(this.element, null, this.callback);
            }
            delayed(t = 10) {
                setTimeout(() => {
                    Pe(this.element, null, this.callback);
                }, 1e3 * t);
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    s = ["load", "resize", "scroll"],
                    i = () => {
                        (t = setTimeout(() => {
                            (t = 0), Pe(this.element, null, this.callback);
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            s.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            s.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            i();
                    };
                i();
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (Pe(this.element, null, this.callback), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(t, e, s = null) {
                if (
                    ((this.element = e),
                    (this.delay = t.getAttribute(jp)),
                    (this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.callback = s),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        lm = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(Jp)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el);
            }
            constructor(t) {
                if (((this.el = t), (this.locationPath = location.href), !this.el.hasAttribute(Jp))) return !1;
                this.init();
            }
        };
    const cm = {
        onLoad() {
            rm[this.id] = [];
            this.container.querySelectorAll(Pp).forEach((t) => {
                rm[this.id].push(
                    new (class {
                        init() {
                            const t = !1 !== this.cookie.read(),
                                e = this.popup.classList.contains(sm),
                                s = this.popup.classList.contains(im),
                                i = !E();
                            let o = !0;
                            ((e && !i) || (s && i)) && (o = !1),
                                o
                                    ? (t && !window.Shopify.designMode) ||
                                      (window.Shopify.designMode || new am(this.popup, this.modal, () => this.scrollLock()), this.form && this.form.classList.contains(Zp) && this.checkForSuccess(), this.initClosers())
                                    : this.scrollUnlock();
                        }
                        checkForSuccess() {
                            Pe(this.modal, null, () => this.scrollLock()), this.cookie.write();
                        }
                        initClosers() {
                            this.close.addEventListener("click", this.closeModal.bind(this)), this.underlay.addEventListener("click", this.closeModal.bind(this));
                        }
                        closeModal(t) {
                            t.preventDefault(), Hp(this.modal), this.cookie.write(), this.scrollUnlock();
                        }
                        scrollLock() {
                            "none" !== window.getComputedStyle(this.popup).display && (this.a11y.trapFocus(this.modal), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                        }
                        scrollUnlock() {
                            this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }
                        onBlockSelect(t) {
                            this.popup.contains(t.target) && (Pe(this.modal, null, () => this.scrollLock()), this.popup.classList.add(tm), this.popup.parentNode.classList.add(em));
                        }
                        onBlockDeselect(t) {
                            this.popup.contains(t.target) && (Hp(this.modal), this.scrollUnlock(), this.popup.classList.remove(tm), this.popup.parentNode.classList.remove(em));
                        }
                        constructor(t) {
                            (this.popup = t),
                                (this.modal = this.popup.querySelector(Ip)),
                                (this.close = this.popup.querySelector(Op)),
                                (this.underlay = this.popup.querySelector($p)),
                                (this.form = this.popup.querySelector(Vp)),
                                (this.cookie = new tn(this.popup.getAttribute(Xp), "user_has_closed")),
                                (this.isTargeted = new lm(this.popup)),
                                (this.a11y = U),
                                this.init();
                        }
                    })(t)
                );
            });
            this.container.querySelectorAll(Bp).forEach((t) => {
                rm[this.id].push(
                    new (class {
                        init() {
                            this.showPopup && Pe(this.modal), this.clickEvents();
                        }
                        clickEvents() {
                            this.acceptButton.addEventListener("click", (t) => {
                                t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => Hp(this.modal)), document.documentElement.style.setProperty("--cookie-bar-height", "0px");
                            }),
                                document.addEventListener("trackingConsentAccepted", () => {});
                        }
                        onBlockSelect(t) {
                            this.popup.contains(t.target) && this.showPopup && (Pe(this.modal), this.popup.classList.add(tm), this.popup.parentNode.classList.add(em));
                        }
                        onBlockDeselect(t) {
                            this.popup.contains(t.target) && (Hp(this.modal), this.popup.classList.remove(tm), this.popup.parentNode.classList.remove(em));
                        }
                        constructor(t) {
                            (this.popup = t),
                                (this.modal = document.querySelector(Bp)),
                                (this.acceptButton = this.modal.querySelector(Dp)),
                                (this.enable = "true" === this.modal.getAttribute(nm)),
                                (this.showPopup = !1),
                                window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                    if (t) throw t;
                                    const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                        s = window.Shopify.customerPrivacy.getTrackingConsent();
                                    (this.showPopup = !e && "no_interaction" === s && this.enable), window.Shopify.designMode && (this.showPopup = !0), this.init();
                                });
                        }
                    })(t)
                );
            });
            this.container.querySelectorAll(_p).forEach((t) => {
                rm[this.id].push(
                    new (class {
                        init() {
                            const t = !1 !== this.cookie.read(),
                                e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                s = [...this.holder.classList].toString().includes(om);
                            e && (this.delay = 0), (t && !window.Shopify.designMode) || (this.show(), this.form.classList.contains(Zp) && this.checkForSuccess()), s && this.observeCartBar();
                        }
                        show() {
                            window.Shopify.designMode ? Pe(this.holder) : new am(this.popup, this.holder), this.showForm(), this.inputField(), this.closePopup();
                        }
                        checkForSuccess() {
                            Pe(this.holder), this.cookie.write();
                        }
                        observeCartBar() {
                            if (((this.cartBar = document.getElementById(Fp)), !this.cartBar)) return;
                            let t = this.cartBar.classList.contains(Kp);
                            document.body.classList.toggle(Gp, t),
                                (this.observer = new MutationObserver((e) => {
                                    for (const s of e) "attributes" === s.type && ((t = s.target.classList.contains(Kp)), document.body.classList.toggle(Gp, t));
                                })),
                                this.observer.observe(this.cartBar, { attributes: !0, childList: !1, subtree: !1 });
                        }
                        showForm() {
                            this.heading.addEventListener("click", (t) => {
                                t.preventDefault(), this.heading.classList.add(Yp), this.form.classList.remove(Yp), this.newsletterField.focus();
                            }),
                                this.heading.addEventListener("keyup", (t) => {
                                    "Enter" === t.code && this.heading.dispatchEvent(new Event("click"));
                                });
                        }
                        closePopup() {
                            this.close.addEventListener("click", (t) => {
                                t.preventDefault(), Hp(this.holder), this.cookie.write();
                            });
                        }
                        inputField() {
                            const t = () => {
                                this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(Qp);
                            };
                            this.newsletterField.addEventListener("input", t),
                                this.newsletterField.addEventListener("focus", t),
                                this.newsletterField.addEventListener("focusout", () => {
                                    this.resetClassTimer && clearTimeout(this.resetClassTimer),
                                        (this.resetClassTimer = setTimeout(() => {
                                            this.holder.classList.remove(Qp);
                                        }, 2e3));
                                });
                        }
                        onBlockSelect(t) {
                            this.popup.contains(t.target) && (Pe(this.holder), this.popup.classList.add(tm), this.popup.parentNode.classList.add(em));
                        }
                        onBlockDeselect(t) {
                            this.popup.contains(t.target) && (Hp(this.holder), this.popup.classList.remove(tm), this.popup.parentNode.classList.remove(em));
                        }
                        onUnload() {
                            this.observer && this.observer.disconnect();
                        }
                        constructor(t) {
                            (this.popup = t),
                                (this.holder = this.popup.querySelector(Rp)),
                                (this.close = this.popup.querySelector(Np)),
                                (this.heading = this.popup.querySelector(zp)),
                                (this.newsletterField = this.popup.querySelector(Up)),
                                (this.cookie = new tn(this.popup.getAttribute(Xp), "newsletter_is_closed")),
                                (this.form = this.popup.querySelector(Vp)),
                                (this.isTargeted = new lm(this.popup)),
                                (this.resetClassTimer = 0),
                                this.init();
                        }
                    })(t)
                );
            });
            this.container.querySelectorAll(Wp).forEach((t) => {
                rm[this.id].push(
                    new (class {
                        init() {
                            (!1 !== this.cookie.read() && !window.Shopify.designMode) || (window.Shopify.designMode ? Pe(this.popup) : new am(this.popup, this.popup), this.clickEvents());
                        }
                        clickEvents() {
                            this.close.addEventListener("click", (t) => {
                                t.preventDefault(), Hp(this.popup), this.cookie.write();
                            });
                        }
                        onBlockSelect(t) {
                            this.popup.contains(t.target) && (Pe(this.popup), this.popup.classList.add(tm), this.popup.parentNode.classList.add(em));
                        }
                        onBlockDeselect(t) {
                            this.popup.contains(t.target) && (Hp(this.popup), this.popup.classList.remove(tm), this.popup.parentNode.classList.remove(em));
                        }
                        constructor(t) {
                            (this.popup = t), (this.close = this.popup.querySelector(Op)), (this.cookie = new tn(this.popup.getAttribute(Xp), "user_has_closed")), (this.isTargeted = new lm(this.popup)), this.init();
                        }
                    })(t)
                );
            });
        },
        onBlockSelect(t) {
            rm[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            rm[this.id].forEach((e) => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
            });
        },
        onUnload() {
            rm[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    co("popups", [cm, hn]);
    const hm = "[data-password-login]",
        dm = "[data-password-modal]",
        um = "[data-modal-body]",
        pm = "[data-modal-close]",
        mm = "#login_form .errors",
        vm = "is-open";
    co("password-template", {
        onLoad() {
            new (class {
                init() {
                    this.passwordLogin.length &&
                        this.modal &&
                        this.modalBody &&
                        (this.passwordLogin.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.preventDefault(), this.openModal();
                            });
                        }),
                        this.closeButtons.length &&
                            this.closeButtons.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault(), this.closeModal();
                                });
                            }),
                        this.loginErrors && this.openModal());
                }
                openModal() {
                    Pe(this.modal, "block", () => {
                        this.modal.classList.add(vm);
                    }),
                        "none" !== window.getComputedStyle(this.modal).display && (this.a11y.trapFocus(this.modal), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                }
                closeModal() {
                    Hp(this.modal), this.modal.classList.remove(vm), this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.passwordLogin = this.container.querySelectorAll(hm)),
                        (this.modal = this.container.querySelector(dm)),
                        (this.modalBody = this.container.querySelector(um)),
                        (this.closeButtons = this.container.querySelectorAll(pm)),
                        (this.a11y = U),
                        (this.loginErrors = this.container.querySelector(mm)),
                        this.init();
                }
            })(this);
        },
    }),
        co("list-collections", [Ko, Oa]),
        co("columns", [Oa, Ko]),
        co("newsletter", hn),
        co("before-after", [Cp]);
    const gm = "[data-scroll-to]",
        fm = "[data-tooltip]",
        ym = "[data-collapsible-trigger]",
        bm = "open",
        wm = "data-scroll-to",
        Em = "data-tooltip-stop-mouseenter",
        Sm = {};
    const Lm = {
            onLoad() {
                Sm[this.id] = new (class {
                    init() {
                        this.scrollToButtons.forEach((t) => {
                            t.addEventListener("click", () => {
                                const e = this.container.querySelector(t.getAttribute(wm));
                                e && "A" !== t.tagName && this.scrollToElement(e);
                            });
                        });
                    }
                    scrollToElement(t) {
                        Zo(t.getBoundingClientRect().top + 1);
                        const e = t.nextElementSibling.matches("details") ? t.nextElementSibling : null;
                        if (e) {
                            const t = null == e ? void 0 : e.querySelector(ym);
                            e.hasAttribute(bm) || null == t || t.dispatchEvent(new Event("click"));
                        }
                        const s = document.querySelectorAll(`${fm}:not([${Em}])`);
                        s.length &&
                            s.forEach((t) => {
                                t.setAttribute(Em, ""),
                                    setTimeout(() => {
                                        t.removeAttribute(Em);
                                    }, 1e3);
                            });
                    }
                    constructor(t) {
                        (this.section = t), (this.container = t.container), (this.scrollToButtons = this.container.querySelectorAll(gm)), this.scrollToButtons.length && this.init();
                    }
                })(this);
            },
        },
        km = "[data-scroll-spy]",
        Am = "is-selected",
        Tm = "data-scroll-spy",
        Cm = "data-scroll-spy-mobile",
        qm = "data-scroll-spy-desktop",
        xm = {};
    const Mm = {
        onLoad() {
            xm[this.id] = new (class {
                init() {
                    this.loopAnchors(), document.addEventListener("theme:resize:width", this.loopAnchors);
                }
                loopAnchors() {
                    this.scrollSpyAnchors.length &&
                        this.scrollSpyAnchors.forEach((t) => {
                            this.toggleObserver(t);
                        });
                }
                toggleObserver(t) {
                    const e = this.container.querySelector(t.getAttribute(Tm));
                    if (!e) return;
                    this.observers[e.id] && this.observers[e.id].unobserve(e);
                    const s = E();
                    ((!s && t.hasAttribute(Cm)) || (s && t.hasAttribute(qm)) || (!t.hasAttribute(qm) && !t.hasAttribute(Cm))) && this.runObserver(e);
                }
                runObserver(t) {
                    let { stickyHeaderHeight: e } = c();
                    const s = { rootMargin: -1 * e + "px 0px 0px 0px", threshold: [0.5, 1] };
                    (this.observers[t.id] = new IntersectionObserver((t) => {
                        t.forEach((t) => {
                            const s = this.container.querySelector(`[${Tm}].${Am}`),
                                i = this.container.querySelector(`[${Tm}="#${t.target.id}"]`);
                            t.intersectionRatio > 0.5 && t.boundingClientRect.top - e <= t.boundingClientRect.height && (null == s || s.classList.remove(Am), null == i || i.classList.add(Am));
                        });
                    }, s)),
                        this.observers[t.id].observe(t);
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.loopAnchors),
                        this.observers.length &&
                            this.observers.forEach((t) => {
                                t.disconnect();
                            });
                }
                constructor(t) {
                    (this.section = t), (this.container = t.container), (this.scrollSpyAnchors = this.container.querySelectorAll(km)), (this.loopAnchors = this.loopAnchors.bind(this)), (this.observers = []), this.init();
                }
            })(this);
        },
        onUnload() {
            xm[this.id].onUnload();
        },
    };
    co("sidebar", [Lm, Mm]);
    const Hm = "[data-hover-target]",
        Pm = "[data-collection-image]",
        Im = "data-hover-target",
        Bm = "is-visible",
        Dm = "is-selected";
    let Fm = {};
    co("collections-hover", [
        {
            onLoad() {
                Fm[this.id] = new (class {
                    init() {
                        this.buttons.length &&
                            this.buttons.forEach((t) => {
                                t.addEventListener("mouseenter", (t) => {
                                    const e = t.currentTarget.getAttribute(Im);
                                    this.updateState(e);
                                });
                            });
                    }
                    updateState(t) {
                        const e = this.container.querySelector(`[${Im}="${t}"]`),
                            s = this.container.querySelector(`#${t}:not(.${Bm})`),
                            i = this.container.querySelector(`${Hm}.${Dm}`),
                            o = this.container.querySelector(`${Pm}.${Bm}`);
                        s && E() && (null == o || o.classList.remove(Bm), null == i || i.classList.remove(Dm), s.classList.add(Bm), e.classList.add(Dm));
                    }
                    onBlockSelect(t) {
                        this.updateState(t.target.id);
                    }
                    constructor(t) {
                        (this.container = t.container), (this.buttons = this.container.querySelectorAll(Hm)), this.init();
                    }
                })(this);
            },
            onBlockSelect(t) {
                Fm[this.id].onBlockSelect(t);
            },
        },
        Mm,
    ]);
    const Om = "[data-featured-image]",
        $m = "[data-featured-aside]",
        _m = "[data-featured-content]",
        Rm = "[data-featured-wrapper]",
        Nm = "data-horizontal-scroll",
        zm = "data-horizontal-scroll-reversed",
        Um = {};
    co("featured-product", [
        {
            onLoad() {
                Um[this.id] = new (class {
                    init() {
                        this.horizontalScroll && this.imagesHolder && ((this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent)), document.addEventListener("theme:scroll", this.scrollEvent)),
                            this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent));
                    }
                    scrollEvents() {
                        this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent));
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null));
                    }
                    calculateHorizontalPosition() {
                        let t = window.scrollY + this.headerHeight;
                        const e = t + window.innerHeight,
                            s = this.imagesHolder.offsetTop,
                            i = this.imagesHolder.offsetHeight,
                            o = s + i + this.headerHeight,
                            n = i - (window.innerHeight - this.headerHeight),
                            r = this.horizontalScrollReversed ? 1 : -1;
                        let a = 0;
                        (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
                            (a *= this.images.length - 1),
                            this.container.style.setProperty("--translateX", a * r + "%"),
                            this.lastPercent !== a ? (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent)) : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.lastPercent = a);
                    }
                    calculateHeight() {
                        let { stickyHeaderHeight: t } = c();
                        this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight + this.contentHolder.offsetHeight}px`), (this.headerHeight = t);
                    }
                    onUnload() {
                        this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent),
                            this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.horizontalScroll = this.container.hasAttribute(Nm)),
                            (this.horizontalScrollReversed = this.container.hasAttribute(zm)),
                            (this.images = this.container.querySelectorAll(Om)),
                            (this.imagesHolder = this.container.querySelector($m)),
                            (this.contentHolder = this.container.querySelector(_m)),
                            (this.wrapper = this.container.querySelector(Rm)),
                            (this.requestAnimationSticky = null),
                            (this.lastPercent = 0),
                            (this.scrollEvent = () => this.scrollEvents()),
                            (this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition()),
                            (this.calculateHeightEvent = () => this.calculateHeight()),
                            this.init();
                    }
                })(this);
            },
            onUnload(t) {
                Um[this.id].onUnload(t);
            },
        },
    ]);
    const Wm = "[data-timeline-holder]",
        Vm = "[data-timeline-row]",
        jm = "[data-timeline-row-editor]",
        Xm = "[data-timeline-button]",
        Jm = "[data-header-sticky]",
        Ym = "[data-header-height]",
        Qm = "is-selected",
        Gm = {};
    co("timeline", [
        {
            onLoad() {
                Gm[this.id] = new (class {
                    init() {
                        this.calculateRowsHeight(),
                            (this.requestAnimation = requestAnimationFrame(() => this.calculatePosition())),
                            document.addEventListener("theme:scroll", this.scrollEvent),
                            document.addEventListener("theme:resize:width", this.resizeEvent),
                            this.buttons.length &&
                                this.buttons.forEach((t, e) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                        const s = t.currentTarget.closest(Vm);
                                        if (!s) return;
                                        const i = Math.max(...this.rowsHeight),
                                            o = this.holderHeight / this.rows.length,
                                            n = this.holder.getBoundingClientRect().top,
                                            r = e > 0 && i < o ? o * e + n : n,
                                            a = E() ? r + 1 : s.getBoundingClientRect().top;
                                        Zo(a);
                                    });
                                });
                    }
                    resizeEvents() {
                        (this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY),
                            (this.holderHeight = this.holder.offsetHeight),
                            this.calculateRowsHeight(),
                            (this.requestAnimation = requestAnimationFrame(() => this.calculatePosition()));
                    }
                    scrollEvents() {
                        this.requestAnimation || (this.requestAnimation = requestAnimationFrame(() => this.calculatePosition()));
                    }
                    removeAnimationFrame() {
                        this.requestAnimation && (cancelAnimationFrame(this.requestAnimation), (this.requestAnimation = null));
                    }
                    calculateRowsHeight() {
                        if (this.rows.length) {
                            this.rowsHeight = [];
                            let t = 0;
                            this.rows.forEach((e, s) => {
                                if ((this.rowsHeight.push(e.offsetHeight), window.Shopify.designMode)) {
                                    const n = this.container.querySelectorAll(jm);
                                    var i, o;
                                    n.length &&
                                        ((t += e.offsetHeight),
                                        null === (i = n[s]) || void 0 === i || i.style.setProperty("--row-height-min", `${e.offsetHeight}px`),
                                        null === (o = n[s + 1]) || void 0 === o || o.style.setProperty("--row-top-mobile", `${t}px`));
                                }
                            });
                        }
                    }
                    calculatePosition() {
                        let t = window.scrollY;
                        const e = window.innerHeight,
                            s = t + e;
                        if ((this.removeAnimationFrame(), s < this.holderTop || s > this.holderTop + this.holderHeight + e)) return;
                        const i = E(),
                            o = this.holderHeight / this.rows.length;
                        let n = this.holderTop,
                            r = null;
                        if (!i) {
                            const s = document.querySelector(Jm) && document.querySelector(Ym) ? document.querySelector(Ym).getBoundingClientRect().height : 0;
                            t += s;
                            const i = e - s,
                                o = this.holderHeight - i,
                                n = o > 0 ? o : this.holderHeight / 2,
                                a = o > 0 ? i : this.holderHeight / 2,
                                l = ((t - this.holderTop) / n) * 100;
                            (r = t + (a * l) / 100), this.holder.style.setProperty("--percent-mobile", `${l}%`);
                        }
                        this.rows.forEach((t, e) => {
                            if (e > 0) {
                                const e = i ? n + o < s : r + 1 > t.getBoundingClientRect().top + window.scrollY;
                                var a;
                                n - o < s && i && (null === (a = t.previousElementSibling) || void 0 === a || a.style.setProperty("--percent-desktop", ((s - n) / o) * 100 + "%")), t.classList.toggle(Qm, e);
                            }
                            n += o;
                        });
                    }
                    onUnload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("theme:resize:width", this.resizeEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.rows = this.container.querySelectorAll(Vm)),
                            (this.holder = this.container.querySelector(Wm)),
                            this.rows.length < 2 ||
                                !this.holder ||
                                ((this.rowsHeight = []),
                                (this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY),
                                (this.holderHeight = this.holder.offsetHeight),
                                (this.buttons = this.container.querySelectorAll(Xm)),
                                (this.requestAnimation = null),
                                (this.scrollEvent = () => this.scrollEvents()),
                                (this.resizeEvent = () => this.resizeEvents()),
                                this.init());
                    }
                })(this);
            },
            onUnload(t) {
                Gm[this.id].onUnload(t);
            },
        },
    ]),
        document.addEventListener("DOMContentLoaded", function () {
            ho("*");
            const t = document.querySelector("[data-scroll-top-button]");
            t &&
                (t.addEventListener("click", () => {
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                }),
                document.addEventListener("theme:scroll", () => {
                    t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
                })),
                window.self !== window.top && document.querySelector("html").classList.add("iframe"),
                "scrollBehavior" in document.documentElement.style || Qd({ url: window.theme.assets.smoothscroll });
        }),
        window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"));
})(themeVendor.ScrollLock, themeVendor.themeAddresses, themeVendor.themeCurrency, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.themeImages);
